// Datos de corregimientos por municipio en Colombia
// IMPORTANTE: Los nombres de departamentos y municipios deben coincidir EXACTAMENTE 
// con los nombres en colombia-municipios.js (incluyendo mayúsculas, minúsculas y acentos)
const corregimientosData = {
  "Bogotá, D.C.": {
    "Bogotá, D.c.": {
      "11001000": "Bogota (Cabecera Municipal)",
      "11001008": "San Juan",
      "11001009": "Betania",
      "11001010": "La Union"
    }
  },
  "La Guajira": {
    "Albania": {
      "44035000": "Albania (Cabecera Municipal)",
      "44035002": "Ware Waren",
      "44035003": "Los Remedios"
    },
    "Barrancas": {
      "44078000": "Barrancas (Cabecera Municipal)",
      "44078001": "Carretalito",
      "44078007": "Roche",
      "44078008": "San Pedro",
      "44078009": "Guayacanal",
      "44078011": "Pozo Hondo",
      "44078013": "Nuevo Oreganal",
      "44078014": "Patilla"
    },
    "Dibulla": {
      "44090000": "Dibulla (Cabecera Municipal)",
      "44090001": "La Punta De Los Remedios",
      "44090002": "Las Flores",
      "44090003": "Mingueo",
      "44090004": "Palomino",
      "44090005": "Campana Nuevo",
      "44090006": "Rio Ancho"
    },
    "Distracción": {
      "44098000": "Distraccion (Cabecera Municipal)",
      "44098001": "Buenavista",
      "44098002": "Chorreras",
      "44098005": "La Duda",
      "44098008": "Los Hornitos",
      "44098011": "Potrerito"
    },
    "El Molino": {
      "44110000": "El Molino (Cabecera Municipal)"
    },
    "Fonseca": {
      "44279000": "Fonseca (Cabecera Municipal)",
      "44279008": "Bangañitas",
      "44279011": "El Confuso",
      "44279013": "Los Altos",
      "44279014": "Quebrachal",
      "44279015": "Potrerito",
      "44279016": "Guamachal"
    },
    "Hatonuevo": {
      "44378000": "Hatonuevo (Cabecera Municipal)",
      "44378004": "El Pozo",
      "44378005": "Guaimarito"
    },
    "La Jagua Del Pilar": {
      "44420000": "La Jagua Del Pilar (Cabecera Municipal)",
      "44420001": "El Plan"
    },
    "Maicao": {
      "44430000": "Maicao (Cabecera Municipal)",
      "44430002": "Carraipia",
      "44430005": "La Paz",
      "44430006": "La Majayura",
      "44430007": "Paraguachon",
      "44430012": "El Limoncito",
      "44430014": "Garrapatero",
      "44430015": "Maku",
      "44430016": "Santa Cruz",
      "44430017": "Santa Rosa"
    },
    "Manaure": {
      "44560000": "Manaure (Cabecera Municipal)",
      "44560001": "Aremasahin",
      "44560002": "Musichi",
      "44560003": "El Pajaro",
      "44560006": "Shiruria",
      "44560007": "Mayapo",
      "44560008": "Manzana",
      "44560009": "La Gloria"
    },
    "Riohacha": {
      "44001000": "Riohacha (Cabecera Municipal)",
      "44001001": "Arroyo Arena",
      "44001002": "Barbacoa",
      "44001003": "Camarones",
      "44001004": "Cascajalito",
      "44001005": "Cotoprix",
      "44001008": "Galan",
      "44001011": "Matitas",
      "44001012": "Mongui",
      "44001016": "Tomarrazon (Treinta)",
      "44001017": "Villa Martin (Macho Vallo)",
      "44001018": "Las Palmas",
      "44001020": "Choles",
      "44001021": "Comejenes",
      "44001022": "El Abra",
      "44001024": "Los Moreneros",
      "44001025": "Pelechua",
      "44001026": "Perico",
      "44001027": "Tigrera",
      "44001028": "Anaime",
      "44001031": "Cerrillo",
      "44001033": "Ebanal",
      "44001035": "Juan Y Medio",
      "44001036": "La Arena",
      "44001040": "Puente Bomba"
    },
    "San Juan Del Cesar": {
      "44650000": "San Juan Del Cesar (Cabecera Municipal)",
      "44650001": "Cañaverales",
      "44650002": "Caracoli",
      "44650003": "Corral De Piedra",
      "44650004": "El Hatico De Los Indios",
      "44650005": "El Tablazo",
      "44650006": "El Totumo",
      "44650007": "Guayacanal",
      "44650008": "La Junta",
      "44650009": "La Peña",
      "44650010": "La Sierrita",
      "44650011": "Los Haticos",
      "44650012": "Los Pondores",
      "44650013": "Zambrano",
      "44650014": "Corralejas",
      "44650016": "Pondoritos",
      "44650017": "Villa Del Rio",
      "44650018": "Lagunita",
      "44650019": "Los Pozos",
      "44650021": "Curazao",
      "44650022": "Boca Del Monte",
      "44650023": "Los Cardones",
      "44650024": "El Placer"
    },
    "Uribia": {
      "44847000": "Uribia (Cabecera Municipal)",
      "44847003": "Cabo De La Vela",
      "44847004": "Carrizal",
      "44847007": "El Cardon",
      "44847012": "Nazareth",
      "44847013": "Puerto Estrella"
    },
    "Urumita": {
      "44855000": "Urumita (Cabecera Municipal)"
    },
    "Villanueva": {
      "44874000": "Villanueva (Cabecera Municipal)"
    }
  },
  "Norte De Santander": {
    "Arboledas": {
      "54051000": "Arboledas (Cabecera Municipal)",
      "54051002": "Castro",
      "54051005": "Villa Sucre"
    },
    "Bochalema": {
      "54099000": "Bochalema (Cabecera Municipal)",
      "54099002": "La Donjuana"
    },
    "Bucarasica": {
      "54109000": "Bucarasica (Cabecera Municipal)",
      "54109002": "La Curva",
      "54109003": "La Sanjuana"
    },
    "Chinácota": {
      "54172000": "Chinacota (Cabecera Municipal)"
    },
    "Chitagá": {
      "54174000": "Chitaga (Cabecera Municipal)",
      "54174002": "San Luis De Chucarima",
      "54174005": "Llano Grande",
      "54174006": "Presidente"
    },
    "Convención": {
      "54206000": "Convencion (Cabecera Municipal)",
      "54206002": "Cartagenita",
      "54206004": "El Guamal",
      "54206005": "Las Mercedes",
      "54206011": "La Libertad",
      "54206012": "La Vega",
      "54206015": "La Trinidad"
    },
    "Cucutilla": {
      "54223000": "Cucutilla (Cabecera Municipal)",
      "54223004": "Tierra Grata"
    },
    "Cáchira": {
      "54128000": "Cachira (Cabecera Municipal)",
      "54128001": "La Carrera",
      "54128003": "La Vega",
      "54128011": "Los Mangos",
      "54128015": "San Jose Del Llano"
    },
    "Cácota": {
      "54125000": "Cacota (Cabecera Municipal)"
    },
    "Durania": {
      "54239002": "Hatoviejo"
    },
    "El Carmen": {
      "54245000": "El Carmen (Cabecera Municipal)",
      "54245006": "Guamalito"
    },
    "El Tarra": {
      "54250000": "El Tarra (Cabecera Municipal)",
      "54250002": "Oru",
      "54250003": "Filo Gringo",
      "54250005": "El Paso"
    },
    "El Zulia": {
      "54261000": "El Zulia (Cabecera Municipal)",
      "54261006": "Las Piedras",
      "54261007": "Astilleros La Ye",
      "54261008": "Camilandia"
    },
    "Gramalote": {
      "54313000": "Gramalote (Cabecera Municipal)"
    },
    "Hacarí": {
      "54344000": "Hacari (Cabecera Municipal)",
      "54344003": "Maracaibo",
      "54344008": "San Jose Del Tarra",
      "54344009": "Las Juntas",
      "54344011": "La Estacion O Mesitas"
    },
    "Herrán": {
      "54347000": "Herran (Cabecera Municipal)"
    },
    "La Esperanza": {
      "54385000": "La Esperanza (Cabecera Municipal)",
      "54385001": "La Pedregosa",
      "54385002": "Leon Xiii",
      "54385003": "Pueblo Nuevo",
      "54385005": "El Tropezon",
      "54385007": "Los Cedros",
      "54385008": "Villamaria",
      "54385009": "Campo Alegre"
    },
    "La Playa": {
      "54398000": "La Playa (Cabecera Municipal)",
      "54398002": "Aspasica",
      "54398006": "La Vega De San Antonio"
    },
    "Labateca": {
      "54377000": "Labateca (Cabecera Municipal)"
    },
    "Los Patios": {
      "54405000": "Los Patios (Cabecera Municipal)",
      "54405001": "La Garita",
      "54405003": "Los Vados",
      "54405004": "Agua Linda",
      "54405006": "El Trapiche"
    },
    "Mutiscua": {
      "54480000": "Mutiscua (Cabecera Municipal)",
      "54480001": "La Laguna"
    },
    "Ocaña": {
      "54498000": "Ocaña (Cabecera Municipal)",
      "54498002": "Aguasclaras",
      "54498005": "Otare",
      "54498006": "Buenavista",
      "54498008": "La Ermita",
      "54498012": "Pueblo Nuevo"
    },
    "Pamplona": {
      "54518000": "Pamplona (Cabecera Municipal)"
    },
    "Pamplonita": {
      "54520000": "Pamplonita (Cabecera Municipal)",
      "54520001": "El Diamante"
    },
    "Puerto Santander": {
      "54553000": "Puerto Santander (Cabecera Municipal)"
    },
    "Ragonvalia": {
      "54599000": "Ragonvalia (Cabecera Municipal)"
    },
    "Salazar": {
      "54660000": "Salazar (Cabecera Municipal)",
      "54660001": "El Carmen De Nazareth",
      "54660002": "La Laguna",
      "54660005": "San Jose Del Avila"
    },
    "San Calixto": {
      "54670000": "San Calixto (Cabecera Municipal)"
    },
    "San Cayetano": {
      "54673000": "San Cayetano (Cabecera Municipal)",
      "54673002": "Cornejo",
      "54673005": "Urimaco"
    },
    "Cúcuta": {
      "54001000": "San Jose De Cucuta (Cabecera Municipal)",
      "54001001": "Agua Clara",
      "54001002": "Banco De Arenas",
      "54001003": "Buena Esperanza",
      "54001007": "Patillales",
      "54001011": "Puerto Villamizar",
      "54001015": "Ricaurte",
      "54001017": "San Faustino",
      "54001018": "San Pedro",
      "54001025": "Arrayan",
      "54001028": "Alto Viento",
      "54001029": "El Prado",
      "54001030": "Portico",
      "54001036": "Palmarito",
      "54001038": "Puerto Leon",
      "54001039": "Puerto Nuevo",
      "54001041": "Guaramito",
      "54001042": "La Floresta",
      "54001043": "La Punta",
      "54001044": "Viigilancia",
      "54001045": "Puerto Lleras",
      "54001046": "Santa Cecilia",
      "54001047": "Carmen De Tonchala",
      "54001049": "Oripaya",
      "54001050": "Las Vacas",
      "54001053": "Bella Vista",
      "54001054": "El Plomo",
      "54001055": "El Suspiro",
      "54001056": "La Sabana",
      "54001057": "Nuevo Madrid",
      "54001058": "San Agustin De Los Pozos"
    },
    "Sardinata": {
      "54720000": "Sardinata (Cabecera Municipal)",
      "54720003": "La Victoria",
      "54720004": "Las Mercedes",
      "54720005": "Luis Vero",
      "54720007": "San Roque"
    },
    "Silos": {
      "54743000": "Silos (Cabecera Municipal)",
      "54743001": "Babega",
      "54743003": "Los Rincon",
      "54743004": "La Laguna"
    },
    "Teorama": {
      "54800000": "Teorama (Cabecera Municipal)",
      "54800011": "La Cecilia",
      "54800022": "San Pablo",
      "54800025": "Quince Letras",
      "54800026": "El Aserrio"
    },
    "Tibú": {
      "54810000": "Tibu (Cabecera Municipal)",
      "54810002": "La Gabarra",
      "54810003": "Paccelly",
      "54810006": "Tres Bocas",
      "54810008": "Petrolea",
      "54810009": "Versalles",
      "54810011": "Campo Giles",
      "54810013": "La Llana",
      "54810016": "Vetas De Oriente"
    },
    "Toledo": {
      "54820000": "Toledo (Cabecera Municipal)",
      "54820015": "Samore"
    },
    "Villa Del Rosario": {
      "54874000": "Villa Del Rosario (Cabecera Municipal)",
      "54874008": "Palogordo Norte"
    },
    "Ábrego": {
      "54003000": "Abrego (Cabecera Municipal)",
      "54003002": "Casitas"
    }
  },
  "Valle Del Cauca": {
    "Alcalá": {
      "76020000": "Alcala (Cabecera Municipal)",
      "76020006": "La Floresta"
    },
    "Andalucía": {
      "76036000": "Andalucia (Cabecera Municipal)",
      "76036002": "Campoalegre",
      "76036003": "El Salto",
      "76036006": "Tamboral",
      "76036009": "Monte Hermoso",
      "76036010": "Madre Vieja"
    },
    "Ansermanuevo": {
      "76041000": "Ansermanuevo (Cabecera Municipal)",
      "76041001": "Anacaro",
      "76041003": "El Billar",
      "76041006": "El Vergel",
      "76041013": "Gramalote"
    },
    "Argelia": {
      "76054000": "Argelia (Cabecera Municipal)",
      "76054004": "El Raizal",
      "76054005": "La Aurora"
    },
    "Bolívar": {
      "76100000": "Bolivar (Cabecera Municipal)",
      "76100001": "Betania",
      "76100002": "Cerro Azul",
      "76100006": "La Herradura",
      "76100007": "La Tulia",
      "76100008": "Naranjal",
      "76100009": "Primavera",
      "76100010": "Ricaurte",
      "76100012": "Aguas Lindas",
      "76100014": "San Fernando"
    },
    "Buenaventura": {
      "76109000": "Buenaventura (Cabecera Municipal)",
      "76109001": "Aguaclara",
      "76109002": "Barco",
      "76109003": "La Bocana",
      "76109006": "Bajo Calima",
      "76109009": "Cordoba",
      "76109012": "Pital",
      "76109017": "Triana",
      "76109018": "Concepcion",
      "76109019": "La Plata",
      "76109021": "Ladrilleros",
      "76109022": "Llano Bajo",
      "76109024": "Bocas De Mayorquin",
      "76109028": "Puerto Merizalde",
      "76109030": "Punta Soldado",
      "76109031": "San Antonio (Yurumangui)",
      "76109032": "San Francisco De Naya",
      "76109033": "San Francisco Javier",
      "76109034": "San Isidro",
      "76109036": "San Lorenzo",
      "76109037": "San Pedro",
      "76109038": "Silva",
      "76109039": "Taparal",
      "76109040": "Veneral",
      "76109041": "San Jose",
      "76109042": "Sabaletas",
      "76109043": "Zacarias",
      "76109045": "La Barra",
      "76109046": "Juanchaco",
      "76109047": "Pianguita",
      "76109053": "Chamuscado",
      "76109058": "El Barranco",
      "76109061": "Guaimia",
      "76109062": "Juntas",
      "76109064": "Bartola",
      "76109069": "Papayal",
      "76109071": "San Cipriano",
      "76109074": "San Jose De Naya",
      "76109076": "San Marcos",
      "76109077": "Santa Cruz",
      "76109078": "Zaragoza",
      "76109079": "Aguamansa",
      "76109080": "Cascajita",
      "76109081": "Punta Bonita",
      "76109082": "Horizonte",
      "76109083": "Bendiciones",
      "76109084": "El Cacao",
      "76109085": "Calle Larga - Aeropuerto",
      "76109086": "Camino Viejo - Km 40",
      "76109087": "Campo Hermoso",
      "76109088": "El Crucero",
      "76109089": "El Encanto",
      "76109090": "El Llano",
      "76109091": "El Salto",
      "76109092": "Guadualito",
      "76109093": "Joaquincito Resguardo Indigena",
      "76109095": "La Balastrera",
      "76109096": "La Comba",
      "76109097": "La Contra",
      "76109098": "La Fragua",
      "76109099": "Primavera",
      "76109100": "Buenaventura Corregimiento",
      "76109104": "Papayal 2",
      "76109106": "Sagrada Familia",
      "76109107": "San Antonio",
      "76109108": "San Antoñito (Yurumangui)",
      "76109109": "San Isidro (Cajambre)",
      "76109110": "Santa Maria",
      "76109111": "Secadero",
      "76109112": "Umane",
      "76109113": "Villa Estela"
    },
    "Bugalagrande": {
      "76113000": "Bugalagrande (Cabecera Municipal)",
      "76113001": "Ceilan",
      "76113004": "El Overo (Sector Poblado)",
      "76113008": "Galicia",
      "76113010": "Mestizal",
      "76113011": "Paila Arriba",
      "76113013": "Uribe Uribe",
      "76113016": "El Overo (Sector La Maria)"
    },
    "Caicedonia": {
      "76122000": "Caicedonia (Cabecera Municipal)",
      "76122006": "Samaria",
      "76122009": "Barragan"
    },
    "Cali": {
      "76001000": "Cali (Cabecera Municipal)"
    },
    "Calima": {
      "76126000": "Calima (Cabecera Municipal)",
      "76126007": "La Gaviota",
      "76126018": "La Playa"
    },
    "Candelaria": {
      "76130000": "Candelaria (Cabecera Municipal)",
      "76130001": "Buchitolo",
      "76130002": "El Arenal",
      "76130003": "El Cabuyal",
      "76130004": "El Carmelo",
      "76130005": "El Lauro",
      "76130006": "El Tiple",
      "76130007": "Juanchito",
      "76130008": "Villa Gorgona",
      "76130009": "La Regina",
      "76130011": "Madre Vieja",
      "76130012": "San Joaquin",
      "76130014": "El Otoño",
      "76130015": "El Guali",
      "76130016": "El Poblado Campestre",
      "76130017": "Brisas Del Fraile",
      "76130018": "Cantalomota",
      "76130019": "Caucaseco",
      "76130020": "Domingo Largo",
      "76130021": "La Albania",
      "76130022": "La Gloria",
      "76130023": "Tres Tusas"
    },
    "Cartago": {
      "76147000": "Cartago (Cabecera Municipal)",
      "76147005": "Modin",
      "76147006": "Piedra De Moler",
      "76147012": "Guanabano",
      "76147013": "Guayabito",
      "76147014": "Zanjon Cauca"
    },
    "Dagua": {
      "76233000": "Dagua (Cabecera Municipal)",
      "76233001": "Atuncela",
      "76233002": "Borrero Ayerbe",
      "76233005": "El Carmen",
      "76233007": "El Limonar",
      "76233008": "El Naranjo",
      "76233009": "El Palmar",
      "76233010": "El Piñal",
      "76233011": "El Queremal",
      "76233012": "El Salado",
      "76233017": "Lobo Guerrero",
      "76233019": "San Bernardo",
      "76233020": "San Vicente",
      "76233021": "Santa Maria",
      "76233025": "Zabaletas",
      "76233027": "Juntas",
      "76233033": "Pueblo Nuevo",
      "76233035": "El Chilcal",
      "76233036": "Kilometro 26",
      "76233039": "La Virgen",
      "76233041": "Las Camelias",
      "76233044": "Vergel"
    },
    "El Cairo": {
      "76246000": "El Cairo (Cabecera Municipal)"
    },
    "El Cerrito": {
      "76248000": "El Cerrito (Cabecera Municipal)",
      "76248003": "El Castillo",
      "76248005": "El Placer",
      "76248006": "El Pomo",
      "76248008": "San Antonio",
      "76248009": "Santa Elena",
      "76248010": "Santa Luisa",
      "76248011": "Tenerife",
      "76248014": "Campoalegre",
      "76248018": "La Honda"
    },
    "El Dovio": {
      "76250000": "El Dovio (Cabecera Municipal)",
      "76250003": "Bitaco",
      "76250007": "Lituania",
      "76250013": "La Pradera"
    },
    "El Águila": {
      "76243000": "El Aguila (Cabecera Municipal)",
      "76243005": "La Maria - Quebradagrande",
      "76243006": "San Jose",
      "76243008": "Cañaveral - Villanueva",
      "76243030": "La Quiebra De San Pablo",
      "76243031": "El Guayabo"
    },
    "Florida": {
      "76275000": "Florida (Cabecera Municipal)",
      "76275004": "Chococito",
      "76275006": "La Diana",
      "76275010": "Remolino",
      "76275011": "San Antonio De Los Caballeros",
      "76275012": "San Francisco (El Llanito)",
      "76275014": "Tarragona",
      "76275015": "El Pedregal",
      "76275019": "Las Guacas",
      "76275021": "Los Caleños",
      "76275024": "El Ingenio",
      "76275025": "El Tamboral",
      "76275028": "Simon Bolivar"
    },
    "Ginebra": {
      "76306000": "Ginebra (Cabecera Municipal)",
      "76306001": "Costa Rica",
      "76306002": "La Floresta",
      "76306005": "Sabaletas",
      "76306008": "Villa Vanegas"
    },
    "Guacarí": {
      "76318000": "Guacari (Cabecera Municipal)",
      "76318003": "Guabas",
      "76318004": "Guabitas",
      "76318006": "Pichichi",
      "76318007": "Santa Rosa De Tapias",
      "76318008": "Sonso",
      "76318009": "Alto De Guacas",
      "76318010": "Puente Rojo",
      "76318011": "Canangua",
      "76318012": "El Placer",
      "76318013": "El Triunfo"
    },
    "Guadalajara De Buga": {
      "76111000": "Guadalajara De Buga (Cabecera Municipal)",
      "76111001": "La Campiña",
      "76111002": "El Placer",
      "76111005": "El Vinculo",
      "76111006": "La Habana",
      "76111007": "La Maria",
      "76111012": "Quebradaseca",
      "76111014": "Zanjon Hondo",
      "76111016": "El Porvenir",
      "76111018": "Pueblo Nuevo",
      "76111020": "La Magdalena",
      "76111021": "El Manantial",
      "76111022": "Alaska",
      "76111024": "La Palomera",
      "76111025": "La Unidad",
      "76111026": "Puerto Bertin",
      "76111027": "San Antonio",
      "76111029": "Guadualejo",
      "76111030": "La Granjita"
    },
    "Jamundí": {
      "76364000": "Jamundi (Cabecera Municipal)",
      "76364001": "Ampudia",
      "76364002": "Bocas Del Palo",
      "76364003": "Guachinte",
      "76364004": "La Liberia",
      "76364005": "Paso De La Bolsa",
      "76364006": "Potrerito",
      "76364008": "Puente Velez",
      "76364009": "Quinamayo",
      "76364010": "Robles",
      "76364011": "San Antonio",
      "76364012": "San Vicente",
      "76364013": "Timba",
      "76364014": "Villa Colombia",
      "76364015": "Villapaz",
      "76364018": "La Meseta",
      "76364019": "La Ventura",
      "76364021": "San Isidro",
      "76364022": "El Guaval",
      "76364023": "El Triunfo"
    },
    "La Cumbre": {
      "76377000": "La Cumbre (Cabecera Municipal)",
      "76377001": "Bitaco",
      "76377002": "La Maria",
      "76377003": "Lomitas",
      "76377004": "Pavas",
      "76377005": "Puente Palo",
      "76377008": "Arboledas",
      "76377009": "Jiguales",
      "76377010": "Pavitas",
      "76377011": "Tres Esquinas"
    },
    "La Unión": {
      "76400000": "La Union (Cabecera Municipal)",
      "76400005": "Quebrada Grande",
      "76400006": "San Luis",
      "76400008": "Sabanazo"
    },
    "La Victoria": {
      "76403000": "La Victoria (Cabecera Municipal)",
      "76403003": "Holguin",
      "76403004": "Miravalles",
      "76403005": "Riveralta",
      "76403006": "San Jose",
      "76403007": "San Pedro",
      "76403009": "Taguales"
    },
    "Obando": {
      "76497000": "Obando (Cabecera Municipal)",
      "76497001": "Cruces",
      "76497002": "El Chuzo",
      "76497003": "Juan Diaz",
      "76497005": "Puerto Molina",
      "76497006": "Puerto Samaria",
      "76497007": "San Isidro",
      "76497008": "Villa Rodas"
    },
    "Palmira": {
      "76520000": "Palmira (Cabecera Municipal)",
      "76520001": "Aguaclara",
      "76520002": "Amaime",
      "76520004": "Barrancas",
      "76520005": "Bolo Alizal",
      "76520006": "Bolo La Italia",
      "76520007": "Bolo San Isidro",
      "76520008": "Boyaca",
      "76520009": "Caluce - Plan De Vivienda Los Guayabos",
      "76520010": "Caucaseco",
      "76520011": "Combia",
      "76520013": "Chontaduro",
      "76520014": "Guanabanal",
      "76520015": "Guayabal",
      "76520016": "Juanchito",
      "76520017": "La Acequia",
      "76520018": "La Herradura",
      "76520019": "La Quisquina",
      "76520020": "La Torre",
      "76520022": "Matapalo",
      "76520023": "Obando",
      "76520024": "Palmaseca",
      "76520025": "Potrerillo",
      "76520026": "Rozo",
      "76520027": "Tablones",
      "76520028": "Tenjo",
      "76520029": "Tienda Nueva",
      "76520032": "La Buitrera",
      "76520033": "La Pampa",
      "76520035": "La Bolsa",
      "76520038": "La Dolores",
      "76520039": "La Cascada",
      "76520041": "Bolo Barrio Nuevo",
      "76520043": "Bolomadre Vieja",
      "76520044": "La Union",
      "76520045": "Piles",
      "76520047": "San Antonio De Las Palmas",
      "76520048": "Tres Tusas"
    },
    "Pradera": {
      "76563000": "Pradera (Cabecera Municipal)",
      "76563011": "La Granja",
      "76563013": "La Tupia",
      "76563014": "Lomitas",
      "76563018": "Potrerito",
      "76563024": "El Recreo",
      "76563025": "La Feria",
      "76563028": "La Cruz"
    },
    "Restrepo": {
      "76606000": "Restrepo (Cabecera Municipal)",
      "76606008": "San Salvador"
    },
    "Riofrío": {
      "76616000": "Riofrio (Cabecera Municipal)",
      "76616002": "Fenicia",
      "76616005": "La Zulia",
      "76616006": "Madrigal",
      "76616007": "Portugal De Piedras",
      "76616009": "Salonica"
    },
    "Roldanillo": {
      "76622000": "Roldanillo (Cabecera Municipal)",
      "76622002": "El Retiro",
      "76622003": "Higueroncito",
      "76622007": "Morelia",
      "76622009": "Santa Rita",
      "76622020": "Palmar Guayabal",
      "76622022": "Tierra Blanca"
    },
    "San Pedro": {
      "76670000": "San Pedro (Cabecera Municipal)",
      "76670002": "Buenos Aires",
      "76670007": "Presidente",
      "76670008": "San Jose",
      "76670009": "Todos Los Santos",
      "76670010": "Guayabal",
      "76670011": "Monte Grande"
    },
    "Santiago De Cali": {
      "76001001": "El Saladito",
      "76001002": "Felidia",
      "76001003": "Golondrinas",
      "76001004": "El Hormiguero",
      "76001005": "La Buitrera",
      "76001006": "La Castilla",
      "76001007": "La Elvira",
      "76001008": "La Leonera",
      "76001009": "La Paz",
      "76001010": "Los Andes",
      "76001012": "Navarro",
      "76001013": "Pance",
      "76001014": "Pichinde",
      "76001016": "Montebello",
      "76001019": "Cascajal Ii",
      "76001020": "Villacarmelo",
      "76001022": "Brisas De Montebello",
      "76001023": "Campo Alegre",
      "76001024": "Cascajal I",
      "76001025": "Crucero Alto De Los Mangos",
      "76001026": "El Filo",
      "76001027": "El Portento",
      "76001028": "La Fragua",
      "76001029": "La Voragine",
      "76001030": "Las Palmas",
      "76001031": "Los Cerros",
      "76001032": "Montañitas",
      "76001034": "Pizamos",
      "76001035": "Pueblo Nuevo",
      "76001036": "San Francisco",
      "76001037": "San Isidro",
      "76001038": "Villa Flamenco",
      "76001041": "Cascajal Iii",
      "76001042": "El Estero",
      "76001043": "La Luisa",
      "76001044": "La Sirena",
      "76001045": "Las Palmas - La Castilla",
      "76001046": "Siloe"
    },
    "Sevilla": {
      "76736000": "Sevilla (Cabecera Municipal)",
      "76736004": "Corozal",
      "76736005": "Cumbarco",
      "76736008": "La Cuchilla",
      "76736014": "San Antonio",
      "76736018": "Quebradanueva"
    },
    "Toro": {
      "76823000": "Toro (Cabecera Municipal)",
      "76823001": "Bohio",
      "76823006": "San Antonio",
      "76823007": "San Francisco",
      "76823008": "La Quiebra"
    },
    "Trujillo": {
      "76828000": "Trujillo (Cabecera Municipal)",
      "76828003": "Cristales",
      "76828004": "Dos Quebradas",
      "76828006": "Huasano",
      "76828010": "Venecia",
      "76828013": "La Sonora"
    },
    "Tuluá": {
      "76834000": "Tulua (Cabecera Municipal)",
      "76834001": "Aguaclara",
      "76834003": "Barragan",
      "76834004": "Bocas De Tulua",
      "76834005": "El Picacho",
      "76834007": "Puerto Frazadas",
      "76834009": "La Iberia",
      "76834010": "La Marina",
      "76834011": "La Moralia",
      "76834012": "La Palmera",
      "76834015": "Monteloro",
      "76834016": "Nariño",
      "76834021": "Santa Lucia",
      "76834023": "Tres Esquinas",
      "76834025": "Campoalegre",
      "76834026": "La Rivera",
      "76834029": "Cienegueta",
      "76834030": "Gato Negro",
      "76834032": "Palomestizo"
    },
    "Ulloa": {
      "76845000": "Ulloa (Cabecera Municipal)",
      "76845002": "Moctezuma",
      "76845005": "Dinamarca"
    },
    "Versalles": {
      "76863000": "Versalles (Cabecera Municipal)",
      "76863001": "Campoalegre",
      "76863002": "El Balsal",
      "76863007": "La Florida",
      "76863012": "Puerto Nuevo",
      "76863014": "Murrapal",
      "76863017": "La Playa"
    },
    "Vijes": {
      "76869000": "Vijes (Cabecera Municipal)",
      "76869001": "Cachimbal",
      "76869003": "El Porvenir",
      "76869004": "La Fresneda",
      "76869007": "La Rivera",
      "76869008": "El Tambor"
    },
    "Yotoco": {
      "76890000": "Yotoco (Cabecera Municipal)",
      "76890001": "El Caney",
      "76890004": "Rayito",
      "76890005": "Las Delicias",
      "76890006": "Mediacanoa",
      "76890007": "Miravalle",
      "76890008": "Puentetierra",
      "76890009": "San Antonio De Piedras",
      "76890011": "Campoalegre",
      "76890013": "Los Planes",
      "76890014": "Punta Brava"
    },
    "Yumbo": {
      "76892000": "Yumbo (Cabecera Municipal)",
      "76892002": "Dapa La Vega",
      "76892004": "Montañitas",
      "76892005": "Mulalo",
      "76892008": "San Marcos",
      "76892009": "Santa Ines",
      "76892014": "El Pedregal",
      "76892015": "Miravalle Norte",
      "76892017": "Arroyohondo",
      "76892018": "El Chocho",
      "76892019": "Manga Vieja",
      "76892020": "Miravalle Dapa",
      "76892021": "Pilas De Dapa"
    },
    "Zarzal": {
      "76895000": "Zarzal (Cabecera Municipal)",
      "76895002": "La Paila",
      "76895003": "Limones",
      "76895004": "Quebradanueva",
      "76895005": "Vallejuelo"
    }
  },
 /*  "Amazonas": {
    "Leticia": {
      "91001000": "Leticia (Cabecera Municipal)",
      "91001001": "Comunidad Indigena Santa Sofia",
      "91001002": "Comunidad Indigena Nazareth",
      "91001005": "Comunidad Indigena Tikuna De Arara",
      "91001007": "Comunidad Indigena San Martin De Amacayacu",
      "91001009": "Comunidad Indigena Zaragoza",
      "91001011": "Comunidad Indigena El Progreso",
      "91001012": "Comunidad Indigena El Vergel",
      "91001013": "Comunidad Indigena Patio De Ciencia Dulce  Km 11",
      "91001014": "Kilometro 6",
      "91001015": "Comunidad Indigena La Libertad",
      "91001016": "Comunidad Indigena La Milagrosa",
      "91001017": "Comunidad Indigena Sector La Playa",
      "91001018": "Comunidad Indigena Maloka Yaguas",
      "91001019": "Comunidad Indigena Loma Linda",
      "91001020": "Comunidad Indigena Macedonia",
      "91001021": "Comunidad Indigena Mocagua",
      "91001022": "Comunidad Indigena Jussy Monilla Amena",
      "91001023": "Asentamiento Humano Takana  Km 11",
      "91001024": "Comunidad Indigena Nuevo Jardin",
      "91001025": "Comunidad Indigena Palmeras",
      "91001026": "Comunidad Indigena Puerto Triunfo",
      "91001027": "Comunidad Indigena Isla De Ronda",
      "91001028": "Comunidad Indigena San Antonio De Los Lagos"
    },
    "Puerto Nariño": {
      "91540000": "Puerto Nariño (Cabecera Municipal)",
      "91540001": "San Juan De Atacuari",
      "91540002": "Boyahuazu",
      "91540003": "Doce De Octubre",
      "91540004": "Naranjales",
      "91540005": "Puerto Esperanza",
      "91540006": "Puerto Rico",
      "91540007": "San Francisco",
      "91540008": "San Juan Del Soco",
      "91540009": "Siete De Agosto",
      "91540010": "San Pedro De Tipisca",
      "91540011": "Veinte De Julio"
    }
  }, */
  "Antioquia": {
    "Abejorral": {
      "05002000": "Abejorral (Cabecera Municipal)",
      "05002002": "Pantanillo",
      "05002016": "Las Canoas"
    },
    "Abriaquí": {
      "05004000": "Abriaqui (Cabecera Municipal)"
    },
    "Alejandría": {
      "05021000": "Alejandria (Cabecera Municipal)"
    },
    "Amagá": {
      "05030000": "Amaga (Cabecera Municipal)",
      "05030001": "Camilo C",
      "05030003": "La Clarita",
      "05030011": "Minas"
    },
    "Amalfi": {
      "05031000": "Amalfi (Cabecera Municipal)",
      "05031004": "Portachuelo"
    },
    "Andes": {
      "05034000": "Andes (Cabecera Municipal)",
      "05034003": "San Jose",
      "05034006": "Santa Rita",
      "05034007": "Taparto",
      "05034012": "Santa Ines",
      "05034014": "San Bartolo"
    },
    "Angelópolis": {
      "05036000": "Angelopolis (Cabecera Municipal)",
      "05036001": "La Estacion"
    },
    "Angostura": {
      "05038000": "Angostura (Cabecera Municipal)",
      "05038008": "Llanos De Cuiba"
    },
    "Anorí": {
      "05040000": "Anori (Cabecera Municipal)",
      "05040002": "Liberia"
    },
    "Anzá": {
      "05044000": "Anza (Cabecera Municipal)",
      "05044001": "Guintar",
      "05044005": "La Cejita",
      "05044006": "La Higuina"
    },
    "Apartadó": {
      "05045000": "Apartado (Cabecera Municipal)",
      "05045001": "San Jose De Apartado",
      "05045002": "Churido",
      "05045003": "Zungo Carretera",
      "05045009": "El Reposo",
      "05045011": "El Salvador"
    },
    "Arboletes": {
      "05051000": "Arboletes (Cabecera Municipal)",
      "05051001": "Buenos Aires",
      "05051003": "El Carmelo",
      "05051005": "Las Naranjitas",
      "05051008": "El Yeso",
      "05051009": "La Trinidad",
      "05051010": "Las Platas (Santafe)",
      "05051011": "La Candelaria",
      "05051014": "El Guadual",
      "05051017": "La Atoyosa",
      "05051019": "San Jose Del Carmelo"
    },
    "Argelia": {
      "05055000": "Argelia (Cabecera Municipal)"
    },
    "Armenia": {
      "05059000": "Armenia (Cabecera Municipal)",
      "05059001": "La Herradura",
      "05059003": "El Socorro",
      "05059006": "Filo Seco",
      "05059009": "Palmichal"
    },
    "Barbosa": {
      "05079000": "Barbosa (Cabecera Municipal)",
      "05079001": "Hatillo",
      "05079014": "Popalito",
      "05079016": "Yarumito",
      "05079017": "Tablazo - Hatillo"
    },
    "Bello": {
      "05088000": "Bello (Cabecera Municipal)",
      "05088013": "San Felix",
      "05088018": "El Pinar",
      "05088020": "El Albergue"
    },
    "Belmira": {
      "05086000": "Belmira (Cabecera Municipal)",
      "05086001": "Labores"
    },
    "Betania": {
      "05091000": "Betania (Cabecera Municipal)",
      "05091003": "San Luis"
    },
    "Betulia": {
      "05093000": "Betulia (Cabecera Municipal)",
      "05093001": "Altamira"
    },
    "Briceño": {
      "05107000": "Briceño (Cabecera Municipal)",
      "05107001": "Berlin (Pueblo Nuevo)",
      "05107002": "El Roblal",
      "05107003": "Las Auras"
    },
    "Buriticá": {
      "05113000": "Buritica (Cabecera Municipal)",
      "05113001": "El Naranjo",
      "05113002": "Guarco",
      "05113003": "Tabacal",
      "05113004": "Llanos De Urarco",
      "05113005": "La Angelina"
    },
    "Caicedo": {
      "05125000": "Caicedo (Cabecera Municipal)"
    },
    "Caldas": {
      "05129000": "Caldas (Cabecera Municipal)",
      "05129001": "El Caño",
      "05129002": "La Raya",
      "05129004": "La Miel",
      "05129005": "La Corralita",
      "05129006": "La Primavera Santa Cruz",
      "05129007": "El Raizal",
      "05129008": "La Clara",
      "05129009": "La Quiebra",
      "05129010": "La Salada Parte Baja",
      "05129011": "La Tolva",
      "05129012": "La Valeria"
    },
    "Campamento": {
      "05134000": "Campamento (Cabecera Municipal)",
      "05134002": "La Solita",
      "05134003": "Llanadas"
    },
    "Caracolí": {
      "05142000": "Caracoli (Cabecera Municipal)"
    },
    "Caramanta": {
      "05145000": "Caramanta (Cabecera Municipal)",
      "05145001": "Alegrias",
      "05145002": "Sucre",
      "05145003": "Barro Blanco"
    },
    "Carepa": {
      "05147000": "Carepa (Cabecera Municipal)",
      "05147003": "Piedras Blancas",
      "05147004": "Zungo Embarcadero - Pueblo Nuevo",
      "05147005": "Zungo Embarcadero - 11 De Noviembre",
      "05147006": "Casa Verde",
      "05147007": "El Encanto",
      "05147008": "Zungo Embarcadero - 28 De Octubre"
    },
    "Carolina": {
      "05150000": "Carolina (Cabecera Municipal)"
    },
    "Caucasia": {
      "05154000": "Caucasia (Cabecera Municipal)",
      "05154003": "Cuturu",
      "05154006": "Margento",
      "05154007": "Puerto Colombia",
      "05154008": "Palanca",
      "05154009": "Palomar",
      "05154012": "Santa Rosita",
      "05154020": "Puerto Triana",
      "05154022": "La Ilusion",
      "05154023": "Caceri",
      "05154024": "El Pando",
      "05154026": "El Chino",
      "05154027": "La Esmeralda",
      "05154031": "Villa Del Socorro"
    },
    "Cañasgordas": {
      "05138000": "Cañasgordas (Cabecera Municipal)",
      "05138001": "Buenos Aires - Parte Alta",
      "05138002": "Cestillal",
      "05138003": "Juntas De Uramita",
      "05138005": "San Pascual"
    },
    "Chigorodó": {
      "05172000": "Chigorodo (Cabecera Municipal)",
      "05172003": "Barranquillita",
      "05172007": "Guapa Carreteras"
    },
    "Cisneros": {
      "05190000": "Cisneros (Cabecera Municipal)"
    },
    "Ciudad Bolívar": {
      "05101000": "Ciudad Bolivar (Cabecera Municipal)",
      "05101002": "San Bernardo De Los Farallones",
      "05101008": "Villa Alegria"
    },
    "Cocorná": {
      "05197000": "Cocorna (Cabecera Municipal)",
      "05197005": "La Piñuela"
    },
    "Concordia": {
      "05209000": "Concordia (Cabecera Municipal)",
      "05209001": "El Socorro",
      "05209006": "El Golpe",
      "05209007": "Salazar"
    },
    "Copacabana": {
      "05212000": "Copacabana (Cabecera Municipal)"
    },
    "Cáceres": {
      "05120000": "Caceres (Cabecera Municipal)",
      "05120002": "El Jardin (Tamana)",
      "05120003": "Guarumo",
      "05120004": "Manizales",
      "05120006": "Puerto Belgica",
      "05120010": "Piamonte",
      "05120012": "Rio Man"
    },
    "Dabeiba": {
      "05234000": "Dabeiba (Cabecera Municipal)",
      "05234004": "San Jose De Urama",
      "05234008": "Armenia - Camparrusia",
      "05234010": "Las Cruces De Urama",
      "05234012": "Chimiado Llano Grande",
      "05234014": "El Boton"
    },
    "Donmatías": {
      "05237000": "Don Matias (Cabecera Municipal)",
      "05237001": "Bellavista"
    },
    "Ebéjico": {
      "05240000": "Ebejico (Cabecera Municipal)",
      "05240001": "Brasil",
      "05240011": "La Clara"
    },
    "El Bagre": {
      "05250000": "El Bagre (Cabecera Municipal)",
      "05250004": "Puerto Lopez",
      "05250005": "El Real",
      "05250006": "La Corona",
      "05250007": "Las Negritas",
      "05250009": "Santa Barbara"
    },
    "El Carmen De Viboral": {
      "05148000": "El Carmen De Viboral (Cabecera Municipal)",
      "05148003": "Aguas Claras",
      "05148005": "La Chapa",
      "05148008": "La Aurora - Las Brisas"
    },
    "El Santuario": {
      "05697000": "El Santuario (Cabecera Municipal)"
    },
    "Entrerríos": {
      "05264000": "Entrerrios (Cabecera Municipal)"
    },
    "Envigado": {
      "05266000": "Envigado (Cabecera Municipal)",
      "05266001": "Las Palmas"
    },
    "Fredonia": {
      "05282000": "Fredonia (Cabecera Municipal)",
      "05282002": "Los Palomos",
      "05282003": "Minas",
      "05282004": "Puente Iglesias",
      "05282005": "Marsella",
      "05282008": "El Zancudo"
    },
    "Frontino": {
      "05284000": "Frontino (Cabecera Municipal)",
      "05284001": "Carauta",
      "05284004": "Murri - La Blanquita",
      "05284005": "Musinga - Tabladito",
      "05284006": "Nutibara",
      "05284007": "Ponton",
      "05284010": "San Lazaro"
    },
    "Giraldo": {
      "05306000": "Giraldo (Cabecera Municipal)",
      "05306001": "Manglar"
    },
    "Girardota": {
      "05308000": "Girardota (Cabecera Municipal)",
      "05308002": "San Andres",
      "05308012": "Juan Cojo",
      "05308013": "La Calle",
      "05308014": "San Esteban"
    },
    "Granada": {
      "05313000": "Granada (Cabecera Municipal)",
      "05313001": "Santa Ana"
    },
    "Guadalupe": {
      "05315000": "Guadalupe (Cabecera Municipal)",
      "05315008": "Barrio Nuevo",
      "05315009": "El Machete"
    },
    "Guarne": {
      "05318000": "Guarne (Cabecera Municipal)"
    },
    "Guatapé": {
      "05321000": "Guatape (Cabecera Municipal)"
    },
    "Gómez Plata": {
      "05310000": "Gomez Plata (Cabecera Municipal)",
      "05310001": "El Salto",
      "05310002": "San Matias",
      "05310004": "Vega De Botero"
    },
    "Heliconia": {
      "05347000": "Heliconia (Cabecera Municipal)",
      "05347001": "Alto Del Corral",
      "05347002": "Pueblito",
      "05347003": "Llanos De San Jose"
    },
    "Hispania": {
      "05353000": "Hispania (Cabecera Municipal)"
    },
    "Itagüí": {
      "05360000": "Itagüi (Cabecera Municipal)",
      "05360001": "Los Gomez",
      "05360003": "El Ajizal",
      "05360006": "El Pedregal",
      "05360012": "El Porvenir",
      "05360013": "El Progreso",
      "05360014": "La Maria"
    },
    "Ituango": {
      "05361000": "Ituango (Cabecera Municipal)",
      "05361002": "El Aro - Builopolis",
      "05361003": "La Granja",
      "05361004": "Pascuita",
      "05361005": "Santa Ana",
      "05361006": "Santa Lucia",
      "05361007": "Santa Rita",
      "05361018": "Pio X"
    },
    "Jardín": {
      "05364000": "Jardin (Cabecera Municipal)",
      "05364001": "Cristiania"
    },
    "Jericó": {
      "05368000": "Jerico (Cabecera Municipal)",
      "05368005": "Guacamayal"
    },
    "La Ceja": {
      "05376000": "La Ceja (Cabecera Municipal)",
      "05376003": "San Jose",
      "05376005": "San Nicolas"
    },
    "La Estrella": {
      "05380000": "La Estrella (Cabecera Municipal)",
      "05380007": "La Tablacita",
      "05380008": "Sagrada Familia",
      "05380009": "San Jose - Meleguindo",
      "05380010": "La Raya",
      "05380011": "San Isidro",
      "05380012": "Tarapaca",
      "05380013": "San Miguel"
    },
    "La Pintada": {
      "05390000": "La Pintada (Cabecera Municipal)",
      "05390001": "La Bocana"
    },
    "La Unión": {
      "05400000": "La Union (Cabecera Municipal)",
      "05400001": "Mesopotamia",
      "05400004": "La Concha"
    },
    "Liborina": {
      "05411000": "Liborina (Cabecera Municipal)",
      "05411001": "El Carmen - La Venta",
      "05411002": "La Honda",
      "05411003": "La Merced (Playon)",
      "05411004": "San Diego (Placita)",
      "05411005": "Curiti",
      "05411007": "Cristobal"
    },
    "Maceo": {
      "05425000": "Maceo (Cabecera Municipal)",
      "05425001": "La Susana",
      "05425003": "La Floresta",
      "05425005": "San Jose Del Nus (Jose De Nuestra Señora)"
    },
    "Marinilla": {
      "05440000": "Marinilla (Cabecera Municipal)"
    },
    "Medellín": {
      "05001000": "Medellin (Cabecera Municipal)",
      "05001001": "Palmitas",
      "05001004": "Santa Elena",
      "05001009": "Altavista",
      "05001010": "Aguas Frias",
      "05001013": "San Jose Del Manzanillo",
      "05001014": "Barro Blanco",
      "05001015": "El Cerro",
      "05001017": "El Patio",
      "05001018": "El Placer",
      "05001019": "El Plan",
      "05001022": "La Aldea",
      "05001023": "La Cuchilla",
      "05001025": "La Palma",
      "05001027": "Las Playas",
      "05001029": "Piedra Gorda",
      "05001031": "Potrerito",
      "05001032": "Travesias",
      "05001033": "Urquita",
      "05001035": "Boqueron",
      "05001039": "El Llano 1",
      "05001040": "El Llano",
      "05001048": "La Verde",
      "05001052": "Matasano",
      "05001054": "Matasano 2",
      "05001055": "Mazo",
      "05001057": "Media Luna"
    },
    "Montebello": {
      "05467000": "Montebello (Cabecera Municipal)",
      "05467001": "Sabaletas"
    },
    "Murindó": {
      "05475001": "Opogado",
      "05475005": "Jedega",
      "05475006": "Tadia"
    },
    "Mutatá": {
      "05480000": "Mutata (Cabecera Municipal)",
      "05480001": "Bejuquillo",
      "05480002": "Pavarandocito",
      "05480003": "Villa Arteaga",
      "05480004": "Pavarando Grande",
      "05480006": "Caucheras"
    },
    "Nariño": {
      "05483000": "Nariño (Cabecera Municipal)"
    },
    "Nechí": {
      "05495000": "Nechi (Cabecera Municipal)",
      "05495001": "Bijagual",
      "05495002": "Colorado",
      "05495003": "La Concha",
      "05495004": "Las Flores",
      "05495005": "Cargueros"
    },
    "Necoclí": {
      "05490000": "Necocli (Cabecera Municipal)",
      "05490001": "El Totumo",
      "05490002": "Mulatos",
      "05490003": "Pueblo Nuevo",
      "05490004": "Zapata",
      "05490005": "Caribia",
      "05490006": "Vereda Casa Blanca",
      "05490007": "Vereda El Bobal",
      "05490008": "Las Changas",
      "05490009": "El Mellito"
    },
    "Olaya": {
      "05501000": "Olaya (Cabecera Municipal)",
      "05501001": "Llanadas",
      "05501002": "Sucre"
    },
    "Peque": {
      "05543000": "Peque (Cabecera Municipal)",
      "05543003": "Los Llanos"
    },
    "Peñol": {
      "05541000": "Peñol (Cabecera Municipal)"
    },
    "Pueblorrico": {
      "05576000": "Pueblorrico (Cabecera Municipal)"
    },
    "Puerto Berrío": {
      "05579000": "Puerto Berrio (Cabecera Municipal)",
      "05579001": "Puerto Murillo",
      "05579002": "Virginias",
      "05579003": "Cabañas",
      "05579004": "El Brasil",
      "05579005": "La Cristalina",
      "05579009": "Malena",
      "05579010": "Calera",
      "05579011": "Bodegas",
      "05579012": "Dorado - Calamar",
      "05579013": "La Carlota",
      "05579014": "Minas Del Vapor",
      "05579015": "Santa Martina"
    },
    "Puerto Nare": {
      "05585000": "Puerto Nare (Cabecera Municipal)",
      "05585001": "Arabia",
      "05585002": "Los Delirios",
      "05585003": "La Sierra",
      "05585004": "La Union",
      "05585006": "La Pesca",
      "05585008": "Las Angelitas"
    },
    "Puerto Triunfo": {
      "05591000": "Puerto Triunfo (Cabecera Municipal)",
      "05591002": "Puerto Perales Nuevo",
      "05591003": "Estacion Cocorna",
      "05591004": "Doradal",
      "05591005": "La Mercedes",
      "05591007": "Estacion Pita"
    },
    "Remedios": {
      "05604000": "Remedios (Cabecera Municipal)",
      "05604001": "La Cruzada",
      "05604003": "Santa Isabel",
      "05604005": "Otu",
      "05604007": "Cañaveral",
      "05604008": "Martana",
      "05604009": "Rio Bagre"
    },
    "Retiro": {
      "05607000": "Retiro (Cabecera Municipal)",
      "05607003": "Alto De Carrizales",
      "05607004": "Don Diego",
      "05607005": "El Chuscal La Campanita",
      "05607007": "Los Salados",
      "05607009": "El Portento"
    },
    "Rionegro": {
      "05615000": "Rionegro (Cabecera Municipal)",
      "05615017": "La Mosca"
    },
    "Sabanalarga": {
      "05628000": "Sabanalarga (Cabecera Municipal)",
      "05628001": "El Junco",
      "05628002": "El Oro",
      "05628004": "El Socorro",
      "05628007": "Membrillal"
    },
    "Sabaneta": {
      "05631000": "Sabaneta (Cabecera Municipal)",
      "05631001": "Maria Auxiliadora",
      "05631002": "Cañaveralejo",
      "05631006": "San Isidro",
      "05631007": "La Inmaculada",
      "05631009": "La Doctora",
      "05631010": "Las Lomitas"
    },
    "Salgar": {
      "05642000": "Salgar (Cabecera Municipal)",
      "05642001": "El Concilio",
      "05642002": "La Camara",
      "05642003": "La Margarita",
      "05642010": "Peñalisa"
    },
    "San Andrés De Cuerquía": {
      "05647000": "San Andres De Cuerquia (Cabecera Municipal)"
    },
    "San Carlos": {
      "05649000": "San Carlos (Cabecera Municipal)",
      "05649001": "El Jordan",
      "05649002": "Samana",
      "05649005": "Puerto Garza",
      "05649012": "Dos Quebradas",
      "05649013": "La Hondita",
      "05649014": "Vallejuelo"
    },
    "San Francisco": {
      "05652000": "San Francisco (Cabecera Municipal)",
      "05652001": "Aquitania",
      "05652008": "Pailania"
    },
    "San Jerónimo": {
      "05656000": "San Jeronimo (Cabecera Municipal)"
    },
    "San José De La Montaña": {
      "05658000": "San Jose De La Montaña (Cabecera Municipal)"
    },
    "San Juan De Urabá": {
      "05659000": "San Juan De Uraba (Cabecera Municipal)",
      "05659001": "Damaquiel",
      "05659002": "San Juancito",
      "05659003": "Uveros",
      "05659004": "Siete Vueltas",
      "05659005": "San Nicolas Del Rio"
    },
    "San Luis": {
      "05660000": "San Luis (Cabecera Municipal)",
      "05660001": "El Silencio Perla Verde",
      "05660006": "El Prodigio",
      "05660007": "Buenos Aires",
      "05660011": "Monteloro (La Josefina)",
      "05660012": "La Tebaida"
    },
    "San Pedro De Los Milagros": {
      "05664000": "San Pedro De Los Milagros (Cabecera Municipal)",
      "05664005": "Ovejas"
    },
    "San Pedro De Urabá": {
      "05665000": "San Pedro De Uraba (Cabecera Municipal)",
      "05665002": "Santa Catalina",
      "05665003": "Arenas Monas",
      "05665004": "Zapindonga",
      "05665008": "El Tomate"
    },
    "San Rafael": {
      "05667000": "San Rafael (Cabecera Municipal)"
    },
    "San Roque": {
      "05670000": "San Roque (Cabecera Municipal)",
      "05670001": "Cristales",
      "05670002": "Providencia",
      "05670003": "San Jose Del Nus"
    },
    "San Vicente Ferrer": {
      "05674000": "San Vicente Ferrer (Cabecera Municipal)",
      "05674001": "Corrientes"
    },
    "Santa Bárbara": {
      "05679000": "Santa Barbara (Cabecera Municipal)",
      "05679001": "Damasco",
      "05679004": "Versalles",
      "05679009": "Yarumalito"
    },
    "Santa Fé De Antioquia": {
      "05042000": "Santa Fe De Antioquia (Cabecera Municipal)",
      "05042002": "Laureles",
      "05042007": "Sabanas"
    },
    "Santa Rosa De Osos": {
      "05686000": "Santa Rosa De Osos (Cabecera Municipal)",
      "05686001": "Aragon",
      "05686003": "Hoyorrico",
      "05686004": "San Isidro",
      "05686006": "San Pablo",
      "05686008": "Rio Grande"
    },
    "Santo Domingo": {
      "05690000": "Santo Domingo (Cabecera Municipal)",
      "05690001": "Botero",
      "05690003": "Porcecito",
      "05690004": "Santiago",
      "05690005": "Versalles"
    },
    "Segovia": {
      "05736000": "Segovia (Cabecera Municipal)",
      "05736001": "Fraguas"
    },
    "Sonsón": {
      "05756000": "Sonson (Cabecera Municipal)",
      "05756001": "Alto De Sabanas",
      "05756005": "San Miguel",
      "05756030": "La Danta",
      "05756033": "Jerusalen"
    },
    "Sopetrán": {
      "05761000": "Sopetran (Cabecera Municipal)",
      "05761001": "Cordoba",
      "05761003": "Horizontes",
      "05761005": "San Nicolas"
    },
    "Tarazá": {
      "05790000": "Taraza (Cabecera Municipal)",
      "05790001": "Barro Blanco",
      "05790002": "El Doce",
      "05790003": "Puerto Antioquia",
      "05790004": "La Caucana",
      "05790005": "El Guaimaro",
      "05790006": "Piedras"
    },
    "Tarso": {
      "05792000": "Tarso (Cabecera Municipal)"
    },
    "Titiribí": {
      "05809000": "Titiribi (Cabecera Municipal)",
      "05809001": "La Meseta",
      "05809002": "Albania",
      "05809003": "Otramina",
      "05809004": "Sitio Viejo",
      "05809014": "Porvenir",
      "05809016": "Puerto Escondido",
      "05809018": "Volcan"
    },
    "Toledo": {
      "05819000": "Toledo (Cabecera Municipal)",
      "05819001": "Buenavista",
      "05819005": "El Brugo"
    },
    "Turbo": {
      "05837000": "Turbo (Cabecera Municipal)",
      "05837001": "Currulao",
      "05837002": "Nueva Colonia",
      "05837003": "El Tres",
      "05837005": "San Vicente Del Congo",
      "05837006": "Tie",
      "05837007": "Lomas Aisladas",
      "05837008": "Rio Grande",
      "05837009": "Bocas Del Rio Atrato",
      "05837010": "El Dos",
      "05837012": "Pueblo Bello",
      "05837013": "San Jose De Mulatos",
      "05837018": "Nuevo Antioquia",
      "05837020": "Alto De Mulatos",
      "05837023": "Casanova",
      "05837024": "Las Garzas",
      "05837025": "Villa Maria"
    },
    "Támesis": {
      "05789000": "Tamesis (Cabecera Municipal)",
      "05789002": "San Pablo"
    },
    "Uramita": {
      "05842000": "Uramita (Cabecera Municipal)",
      "05842003": "El Pital"
    },
    "Urrao": {
      "05847000": "Urrao (Cabecera Municipal)",
      "05847003": "La Encarnacion"
    },
    "Valdivia": {
      "05854000": "Valdivia (Cabecera Municipal)",
      "05854002": "Puerto Valdivia",
      "05854003": "Raudal Viejo"
    },
    "Valparaíso": {
      "05856000": "Valparaiso (Cabecera Municipal)"
    },
    "Vegachí": {
      "05858000": "Vegachi (Cabecera Municipal)",
      "05858001": "El Tigre"
    },
    "Venecia": {
      "05861000": "Venecia (Cabecera Municipal)",
      "05861002": "Bolombolo"
    },
    "Vigía Del Fuerte": {
      "05873000": "Vigia Del Fuerte (Cabecera Municipal)",
      "05873001": "San Antonio De Padua",
      "05873002": "Vegaez",
      "05873004": "San Alejandro",
      "05873005": "San Miguel",
      "05873006": "Puerto Antioquia",
      "05873007": "Buchado",
      "05873009": "Palo Blanco",
      "05873010": "Bajo Murri"
    },
    "Yalí": {
      "05885000": "Yali (Cabecera Municipal)"
    },
    "Yarumal": {
      "05887000": "Yarumal (Cabecera Municipal)",
      "05887003": "Cedeño",
      "05887004": "El Cedro",
      "05887006": "Ochali",
      "05887007": "Llanos De Cuiva",
      "05887009": "El Pueblito",
      "05887021": "La Loma",
      "05887022": "Mina Vieja"
    },
    "Yolombó": {
      "05890000": "Yolombo (Cabecera Municipal)",
      "05890001": "La Floresta",
      "05890004": "El Rubi"
    },
    "Yondó": {
      "05893000": "Yondo (Cabecera Municipal)",
      "05893002": "San Luis Beltran",
      "05893003": "San Miguel Del Tigre",
      "05893005": "Bocas De San Francisco",
      "05893008": "El Bagre",
      "05893009": "Bocas De Barbacoas",
      "05893014": "Puerto Los Mangos",
      "05893015": "Puerto Matilde",
      "05893017": "Puerto Tomas"
    },
    "Zaragoza": {
      "05895000": "Zaragoza (Cabecera Municipal)",
      "05895003": "Buenos Aires",
      "05895004": "Pato",
      "05895008": "Vegas De Segovia"
    }
  },
  "Arauca": {
    "Arauca": {
      "81001000": "Arauca (Cabecera Municipal)",
      "81001017": "El Caracol",
      "81001020": "Monserrate"
    },
    "Arauquita": {
      "81065000": "Arauquita (Cabecera Municipal)",
      "81065001": "Carretero",
      "81065002": "El Troncal",
      "81065004": "San Lorenzo",
      "81065005": "La Paz",
      "81065007": "La Reinera (Gaviota)",
      "81065008": "La Esmeralda (Jujua)",
      "81065009": "Aguachica",
      "81065010": "El Caucho",
      "81065016": "Los Chorros",
      "81065017": "Panama De Arauca",
      "81065019": "Brisas Del Caranal",
      "81065020": "El Oasis",
      "81065021": "El Triunfo",
      "81065022": "La Pesquera",
      "81065023": "El Campamento",
      "81065033": "Pueblo Nuevo"
    },
    "Cravo Norte": {
      "81220000": "Cravo Norte (Cabecera Municipal)"
    },
    "Fortul": {
      "81300000": "Fortul (Cabecera Municipal)",
      "81300002": "Caranal",
      "81300003": "La Veinte",
      "81300006": "El Mordisco",
      "81300007": "Palmarito",
      "81300009": "Sitio Nuevo"
    },
    "Puerto Rondón": {
      "81591000": "Puerto Rondon (Cabecera Municipal)",
      "81591006": "San Ignacio"
    },
    "Saravena": {
      "81736000": "Saravena (Cabecera Municipal)",
      "81736002": "La Ye Del Charo",
      "81736006": "Puerto Lleras",
      "81736007": "Agua Santa",
      "81736008": "Puerto Nariño",
      "81736009": "Barrancones"
    },
    "Tame": {
      "81794000": "Tame (Cabecera Municipal)",
      "81794001": "Betoyes",
      "81794004": "Corocito",
      "81794006": "Puerto Gaitan",
      "81794009": "Puerto San Salvador",
      "81794014": "La Holanda",
      "81794015": "Puente Tabla",
      "81794019": "Botalon",
      "81794020": "Puerto Miranda"
    }
  },
  "Atlántico": {
    "Baranoa": {
      "08078000": "Baranoa (Cabecera Municipal)",
      "08078001": "Campeche",
      "08078002": "Pital",
      "08078003": "Sibarco"
    },
    "Barranquilla": {
      "08001000": "Barranquilla (Cabecera Municipal)"
    },
    "Campo De La Cruz": {
      "08137000": "Campo De La Cruz (Cabecera Municipal)",
      "08137001": "Bohorquez"
    },
    "Candelaria": {
      "08141000": "Candelaria (Cabecera Municipal)",
      "08141001": "San Jose Del Carretal",
      "08141002": "Buenaventura De Leña"
    },
    "Galapa": {
      "08296000": "Galapa (Cabecera Municipal)",
      "08296001": "Paluato"
    },
    "Juan De Acosta": {
      "08372000": "Juan De Acosta (Cabecera Municipal)",
      "08372001": "Bocatocino",
      "08372002": "Chorrera",
      "08372003": "San Jose De Saco",
      "08372004": "Santa Veronica",
      "08372007": "Urbanizacion Punta Cangrejo"
    },
    "Luruaco": {
      "08421000": "Luruaco (Cabecera Municipal)",
      "08421001": "Arroyo De Piedra",
      "08421002": "Palmar De Candelaria",
      "08421003": "Los Pendales",
      "08421004": "San Juan De Tocagua",
      "08421006": "Los Limites",
      "08421007": "La Puntica",
      "08421012": "Barrigon",
      "08421013": "Socavon"
    },
    "Malambo": {
      "08433000": "Malambo (Cabecera Municipal)",
      "08433001": "Caracoli",
      "08433004": "La Aguada",
      "08433005": "Pitalito"
    },
    "Manatí": {
      "08436000": "Manati (Cabecera Municipal)",
      "08436001": "El Porvenir (Las Compuertas)"
    },
    "Palmar De Varela": {
      "08520000": "Palmar De Varela (Cabecera Municipal)",
      "08520001": "Burruscos"
    },
    "Piojó": {
      "08549000": "Piojo (Cabecera Municipal)",
      "08549001": "Aguas Vivas",
      "08549003": "Hibacharo"
    },
    "Polonuevo": {
      "08558000": "Polonuevo (Cabecera Municipal)",
      "08558001": "Pital Del Carlin (Pitalito)"
    },
    "Ponedera": {
      "08560000": "Ponedera (Cabecera Municipal)",
      "08560001": "La Retirada",
      "08560002": "Martillo",
      "08560003": "Puerto Giraldo",
      "08560004": "Santa Rita"
    },
    "Puerto Colombia": {
      "08573000": "Puerto Colombia (Cabecera Municipal)",
      "08573002": "Salgar",
      "08573003": "Sabanilla (Monte Carmelo)"
    },
    "Repelón": {
      "08606000": "Repelon (Cabecera Municipal)",
      "08606001": "Arroyo Negro",
      "08606002": "Cien Pesos",
      "08606003": "Las Tablas",
      "08606004": "Rotinet",
      "08606005": "Villa Rosa"
    },
    "Sabanagrande": {
      "08634000": "Sabanagrande (Cabecera Municipal)"
    },
    "Sabanalarga": {
      "08638000": "Sabanalarga (Cabecera Municipal)",
      "08638003": "Colombia",
      "08638004": "Isabel Lopez",
      "08638005": "La Peña",
      "08638007": "Mirador",
      "08638008": "Gallego",
      "08638010": "Patilla"
    },
    "Santa Lucía": {
      "08675000": "Santa Lucia (Cabecera Municipal)",
      "08675001": "Algodonal"
    },
    "Santo Tomás": {
      "08685000": "Santo Tomas (Cabecera Municipal)"
    },
    "Soledad": {
      "08758000": "Soledad (Cabecera Municipal)"
    },
    "Suan": {
      "08770000": "Suan (Cabecera Municipal)"
    },
    "Tubará": {
      "08832000": "Tubara (Cabecera Municipal)",
      "08832001": "Cuatro Bocas",
      "08832002": "El Morro",
      "08832003": "Guaimaral",
      "08832004": "Juaruco",
      "08832010": "Playa Mendoza",
      "08832011": "Playas De Edriman",
      "08832012": "Villas De Palmarito"
    },
    "Usiacurí": {
      "08849000": "Usiacuri (Cabecera Municipal)"
    }
  },
  "Bolívar": {
    "Achí": {
      "13006000": "Achi (Cabecera Municipal)",
      "13006002": "Boyaca",
      "13006003": "Buenavista",
      "13006005": "Algarrobo",
      "13006007": "Guacamayo",
      "13006011": "Playa Alta",
      "13006015": "Tacuya Alta",
      "13006017": "Tres Cruces",
      "13006019": "Payande",
      "13006020": "Rio Nuevo",
      "13006021": "Buenos Aires",
      "13006022": "Puerto Isabel",
      "13006030": "Centro Alegre",
      "13006033": "Puerto Venecia",
      "13006035": "Santa Lucia",
      "13006039": "Los Nisperos",
      "13006041": "Paraiso Sincerin",
      "13006042": "Providencia"
    },
    "Altos Del Rosario": {
      "13030000": "Altos Del Rosario (Cabecera Municipal)",
      "13030001": "El Rubio",
      "13030002": "La Pacha",
      "13030003": "San Isidro",
      "13030004": "Santa Lucia"
    },
    "Arenal": {
      "13042000": "Arenal (Cabecera Municipal)",
      "13042001": "Buenavista",
      "13042002": "Carnizala",
      "13042003": "San Rafael",
      "13042007": "Santo Domingo"
    },
    "Arjona": {
      "13052000": "Arjona (Cabecera Municipal)",
      "13052001": "Puerto Badel (Caño Salado)",
      "13052003": "Rocha",
      "13052004": "Sincerin",
      "13052005": "San Rafael De La Cruz"
    },
    "Arroyohondo": {
      "13062000": "Arroyohondo (Cabecera Municipal)",
      "13062001": "Machado",
      "13062002": "Monroy",
      "13062003": "Pilon",
      "13062004": "Sato",
      "13062006": "San Francisco (Solabanda)"
    },
    "Barranco De Loba": {
      "13074000": "Barranco De Loba (Cabecera Municipal)",
      "13074003": "Rionuevo",
      "13074004": "San Antonio",
      "13074005": "Los Cerritos",
      "13074006": "Las Delicias"
    },
    "Calamar": {
      "13140000": "Calamar (Cabecera Municipal)",
      "13140002": "Barranca Nueva",
      "13140003": "Barranca Vieja",
      "13140004": "Hato Viejo",
      "13140009": "Yucal"
    },
    "Cantagallo": {
      "13160000": "Cantagallo (Cabecera Municipal)",
      "13160001": "San Lorenzo",
      "13160002": "Brisas De Bolivar",
      "13160015": "Los Paticos",
      "13160017": "No Hay Como Dios",
      "13160019": "Sinzona"
    },
    "Cartagena": {
      "13001000": "Cartagena (Cabecera Municipal)"
    },
    "Cartagena De Indias": {
      "13001001": "Arroyo De Piedra",
      "13001002": "Arroyo Grande",
      "13001004": "Bayunca",
      "13001005": "Bocachica",
      "13001006": "Caño Del Oro",
      "13001007": "Isla Fuerte",
      "13001008": "La Boquilla",
      "13001010": "Punta Canoa",
      "13001013": "Tierra Bomba",
      "13001014": "Punta Arena",
      "13001015": "Ararca",
      "13001017": "Santa Cruz Del Islote (Archipielago De San Bernardo)",
      "13001018": "El Recreo",
      "13001019": "Puerto Rey",
      "13001020": "Pontezuela",
      "13001026": "Arroyo De Las Canoas",
      "13001027": "El Pueblito",
      "13001028": "Las Europas",
      "13001029": "Manzanillo Del Mar",
      "13001030": "Tierra Baja"
    },
    "Cicuco": {
      "13188000": "Cicuco (Cabecera Municipal)",
      "13188001": "Campo Sereno",
      "13188002": "La Peña",
      "13188003": "San Francisco De Loba",
      "13188005": "Pueblo Nuevo"
    },
    "Clemencia": {
      "13222000": "Clemencia (Cabecera Municipal)",
      "13222001": "Las Caras",
      "13222002": "El Peñique"
    },
    "Córdoba": {
      "13212000": "Cordoba (Cabecera Municipal)",
      "13212001": "Guaimaral",
      "13212003": "La Montaña De Alonso (Martin Alonso)",
      "13212005": "San Andres",
      "13212006": "Sincelejito",
      "13212007": "Tacamochito",
      "13212008": "Tacamocho",
      "13212009": "Santa Lucia",
      "13212010": "La Sierra",
      "13212011": "Las Marias",
      "13212012": "Pueblo Nuevo",
      "13212013": "Sanahuare",
      "13212014": "Socorro 1"
    },
    "El Carmen De Bolívar": {
      "13244000": "El Carmen De Bolivar (Cabecera Municipal)",
      "13244001": "Bajo Grande",
      "13244002": "Caracoli Grande",
      "13244003": "El Salado",
      "13244004": "Jesus Del Monte",
      "13244005": "Macayepos",
      "13244006": "San Carlos",
      "13244007": "San Isidro",
      "13244008": "Hato Nuevo",
      "13244011": "El Raizal",
      "13244014": "Santa Lucia",
      "13244017": "Santo Domingo De Meza",
      "13244018": "El Hobo"
    },
    "El Guamo": {
      "13248000": "El Guamo (Cabecera Municipal)",
      "13248001": "La Enea",
      "13248002": "San Jose De Lata",
      "13248003": "Nerviti",
      "13248004": "Robles",
      "13248005": "Tasajera"
    },
    "El Peñón": {
      "13268000": "El Peñon (Cabecera Municipal)",
      "13268003": "Buenos Aires",
      "13268004": "Castañal",
      "13268006": "La Chapetona",
      "13268008": "Japon",
      "13268013": "La Humareda",
      "13268017": "Peñoncito"
    },
    "Hatillo De Loba": {
      "13300000": "Hatillo De Loba (Cabecera Municipal)",
      "13300001": "El Pozon",
      "13300002": "Juana Sanchez",
      "13300003": "La Ribona",
      "13300005": "Pueblo Nuevo",
      "13300006": "San Miguel",
      "13300007": "Cerro De Las Aguadas",
      "13300008": "Las Brisas",
      "13300009": "Guali"
    },
    "Magangué": {
      "13430000": "Magangue (Cabecera Municipal)",
      "13430001": "Barbosa",
      "13430002": "Barranca De Yuca",
      "13430003": "Betania",
      "13430004": "Boca De San Antonio",
      "13430007": "Ceibal",
      "13430008": "Coyongal",
      "13430009": "El Retiro",
      "13430010": "Guazo",
      "13430011": "Henequen",
      "13430014": "La Pascuala",
      "13430015": "La Ventura",
      "13430016": "Las Brisas",
      "13430017": "Madrid",
      "13430018": "Palmarito",
      "13430019": "Pansegüita",
      "13430020": "Piñalito",
      "13430021": "San Rafael De Cortina",
      "13430022": "San Jose De Las Martas",
      "13430023": "San Sebastian De Buenavista",
      "13430024": "Santa Fe",
      "13430025": "Santa Lucia",
      "13430026": "Santa Monica",
      "13430027": "Santa Pabla",
      "13430028": "Sitio Nuevo",
      "13430029": "Puerto Kennedy",
      "13430030": "Tacaloa",
      "13430031": "Tacasaluma",
      "13430032": "Tolu",
      "13430036": "Playa De Las Flores",
      "13430038": "El Cuatro",
      "13430039": "Boca De Guamal",
      "13430040": "Tres Puntas",
      "13430041": "Emaus",
      "13430047": "Puerto Nariño",
      "13430051": "San Antoñito",
      "13430052": "Santa Coita"
    },
    "Mahates": {
      "13433000": "Mahates (Cabecera Municipal)",
      "13433001": "Evitar",
      "13433002": "Gamero",
      "13433003": "Malagana",
      "13433004": "San Basilio De Palenque",
      "13433005": "San Joaquin",
      "13433009": "Mandinga",
      "13433010": "Cruz Del Vizo"
    },
    "Margarita": {
      "13440000": "Margarita (Cabecera Municipal)",
      "13440001": "Boton De Leiva",
      "13440002": "Cantera",
      "13440003": "Causado",
      "13440004": "Chilloa",
      "13440005": "Doña Juana",
      "13440007": "Mamoncito",
      "13440008": "Sandoval",
      "13440010": "San Jose De Los Trapiches",
      "13440011": "Corocito",
      "13440014": "Caño Mono",
      "13440017": "La Montaña"
    },
    "María La Baja": {
      "13442000": "Maria La Baja (Cabecera Municipal)",
      "13442001": "Correa",
      "13442002": "El Nispero",
      "13442003": "Flamenco",
      "13442004": "Manpujan",
      "13442005": "Ñanguma",
      "13442006": "Retiro Nuevo",
      "13442007": "San Jose Del Playon",
      "13442009": "El Majagua",
      "13442011": "Los Bellos",
      "13442012": "Matuya",
      "13442014": "Colu",
      "13442017": "Arroyo Grande",
      "13442020": "Pueblo Nuevo",
      "13442022": "Primero De Julio",
      "13442023": "El Sena",
      "13442024": "La Curva",
      "13442025": "La Pista",
      "13442026": "Marquez",
      "13442027": "Munguia",
      "13442030": "Cedrito",
      "13442031": "El Guamo",
      "13442034": "Guarismo",
      "13442035": "La Suprema",
      "13442040": "Nuevo Porvenir",
      "13442043": "Sucesion",
      "13442044": "Toma Razon"
    },
    "Morales": {
      "13473000": "Morales (Cabecera Municipal)",
      "13473002": "Bodega Central",
      "13473003": "El Dique",
      "13473004": "Las Pailas",
      "13473012": "Boca De La Honda",
      "13473013": "Micoahumado",
      "13473014": "Paredes De Ororia"
    },
    "Pinillos": {
      "13549001": "Armenia",
      "13549004": "La Rufina",
      "13549005": "La Union",
      "13549007": "Las Flores",
      "13549009": "Mantequera",
      "13549010": "Palenquito",
      "13549011": "Palomino",
      "13549012": "Puerto Lopez",
      "13549014": "Santa Coa",
      "13549015": "Santa Rosa",
      "13549018": "Rufina Nueva"
    },
    "Regidor": {
      "13580000": "Regidor (Cabecera Municipal)"
    },
    "Río Viejo": {
      "13600000": "Rio Viejo (Cabecera Municipal)",
      "13600007": "Caimital",
      "13600009": "Cobadillo",
      "13600010": "Hatillo",
      "13600011": "Macedonia"
    },
    "San Estanislao": {
      "13647000": "San Estanislao (Cabecera Municipal)",
      "13647002": "Las Piedras"
    },
    "San Fernando": {
      "13650000": "San Fernando (Cabecera Municipal)",
      "13650001": "Guasimal",
      "13650002": "Menchiquejo",
      "13650004": "Punta De Hornos",
      "13650005": "Santa Rosa",
      "13650008": "El Porvenir",
      "13650009": "Cuatro Bocas",
      "13650010": "El Contadero",
      "13650013": "La Guadua",
      "13650014": "Las Cuevas",
      "13650015": "Pampanillo"
    },
    "San Jacinto": {
      "13654000": "San Jacinto (Cabecera Municipal)",
      "13654001": "Arenas",
      "13654002": "Bajo Grande",
      "13654003": "Las Palmas",
      "13654006": "Las Charquitas",
      "13654007": "Paraiso",
      "13654008": "Las Mercedes"
    },
    "San Jacinto Del Cauca": {
      "13655001": "Tenche",
      "13655003": "Caimital",
      "13655004": "La Raya",
      "13655005": "Galindo",
      "13655006": "Mejico",
      "13655007": "Astilleros"
    },
    "San Juan Nepomuceno": {
      "13657000": "San Juan Nepomuceno (Cabecera Municipal)",
      "13657001": "Corralito",
      "13657002": "La Haya",
      "13657003": "San Jose Del Peñon (Las Porqueras)",
      "13657004": "San Agustin",
      "13657005": "San Cayetano",
      "13657006": "San Pedro Consolado"
    },
    "San Martín De Loba": {
      "13667000": "San Martin De Loba (Cabecera Municipal)",
      "13667002": "Chimi",
      "13667009": "Papayal",
      "13667010": "Las Playitas",
      "13667014": "Pueblo Nuevo Cerro De Julio",
      "13667015": "El Jobo",
      "13667016": "El Varal"
    },
    "San Pablo": {
      "13670000": "San Pablo (Cabecera Municipal)",
      "13670002": "Canaletal",
      "13670003": "Santo Domingo",
      "13670004": "El Carmen",
      "13670007": "Pozo Azul",
      "13670010": "Agua Sucia",
      "13670011": "Cerro Azul",
      "13670012": "Vallecito",
      "13670013": "Villa Nueva",
      "13670014": "La Virgencita"
    },
    "Santa Catalina": {
      "13673000": "Santa Catalina (Cabecera Municipal)"
    },
    "Santa Cruz De Mompox": {
      "13468000": "Santa Cruz De Mompox (Cabecera Municipal)",
      "13468001": "Caldera",
      "13468002": "Candelaria",
      "13468008": "Guaimaral",
      "13468009": "Guataca",
      "13468010": "La Jagua",
      "13468011": "La Lobata",
      "13468013": "La Rinconada",
      "13468014": "Las Boquillas",
      "13468015": "Loma De Simon",
      "13468016": "Los Piñones",
      "13468020": "San Ignacio",
      "13468022": "San Nicolas",
      "13468023": "Santa Cruz",
      "13468024": "Santa Rosa",
      "13468025": "Santa Teresita",
      "13468028": "Ancon",
      "13468030": "La Travesia",
      "13468031": "Pueblo Nuevo",
      "13468033": "Bomba",
      "13468036": "El Rosario",
      "13468038": "Santa Elena",
      "13468039": "San Luis"
    },
    "Santa Rosa": {
      "13683000": "Santa Rosa (Cabecera Municipal)"
    },
    "Santa Rosa Del Sur": {
      "13688000": "Santa Rosa Del Sur (Cabecera Municipal)",
      "13688002": "Buenavista",
      "13688005": "Fatima",
      "13688007": "Canelos",
      "13688009": "San Jose",
      "13688011": "San Lucas",
      "13688013": "Villa Flor",
      "13688015": "San Francisco",
      "13688016": "San Isidro"
    },
    "Simití": {
      "13744000": "Simiti (Cabecera Municipal)",
      "13744001": "Campo Pallares",
      "13744006": "Veracruz",
      "13744007": "San Blas",
      "13744008": "San Luis",
      "13744010": "Las Brisas",
      "13744011": "Monterrey",
      "13744013": "Animas Altas",
      "13744014": "Animas Bajas",
      "13744015": "Diamante",
      "13744016": "Garzal",
      "13744017": "Paraiso",
      "13744019": "San Joaquin"
    },
    "Soplaviento": {
      "13760000": "Soplaviento (Cabecera Municipal)"
    },
    "Talaigua Nuevo": {
      "13780000": "Talaigua Nuevo (Cabecera Municipal)",
      "13780005": "Cañohondo",
      "13780009": "Porvenir",
      "13780011": "Vesubio",
      "13780017": "Patico",
      "13780023": "Talaigua Viejo",
      "13780024": "Ladera De San Martin",
      "13780025": "Peñon De Duran",
      "13780026": "Los Mangos",
      "13780027": "Tupe"
    },
    "Tiquisio": {
      "13810002": "Bocas De Solis",
      "13810003": "Colorado",
      "13810004": "Dos Bocas",
      "13810005": "El Sudan",
      "13810008": "Puerto Coca",
      "13810009": "Quebrada Del Medio",
      "13810010": "Sabanas Del Firme"
    },
    "Turbaco": {
      "13836000": "Turbaco (Cabecera Municipal)",
      "13836001": "Cañaveral",
      "13836002": "San Jose De Chiquito"
    },
    "Turbaná": {
      "13838000": "Turbana (Cabecera Municipal)",
      "13838001": "Ballestas",
      "13838002": "Lomas De Matunilla"
    },
    "Villanueva": {
      "13873000": "Villanueva (Cabecera Municipal)"
    },
    "Zambrano": {
      "13894000": "Zambrano (Cabecera Municipal)"
    }
  },
  "Boyacá": {
    "Aquitania": {
      "15047000": "Aquitania (Cabecera Municipal)",
      "15047010": "Daito",
      "15047012": "Primavera",
      "15047014": "Perez"
    },
    "Arcabuco": {
      "15051000": "Arcabuco (Cabecera Municipal)"
    },
    "Belén": {
      "15087000": "Belen (Cabecera Municipal)"
    },
    "Betéitiva": {
      "15092000": "Beteitiva (Cabecera Municipal)",
      "15092001": "Otenga"
    },
    "Boavita": {
      "15097000": "Boavita (Cabecera Municipal)"
    },
    "Boyacá": {
      "15104000": "Boyaca (Cabecera Municipal)"
    },
    "Briceño": {
      "15106000": "Briceño (Cabecera Municipal)"
    },
    "Buenavista": {
      "15109000": "Buenavista (Cabecera Municipal)"
    },
    "Busbanzá": {
      "15114000": "Busbanza (Cabecera Municipal)"
    },
    "Caldas": {
      "15131000": "Caldas (Cabecera Municipal)",
      "15131001": "Nariño"
    },
    "Campohermoso": {
      "15135000": "Campohermoso (Cabecera Municipal)",
      "15135002": "Vistahermosa",
      "15135003": "Los Cedros"
    },
    "Chinavita": {
      "15172000": "Chinavita (Cabecera Municipal)"
    },
    "Chiquinquirá": {
      "15176000": "Chiquinquira (Cabecera Municipal)"
    },
    "Chiscas": {
      "15180000": "Chiscas (Cabecera Municipal)",
      "15180005": "Mercedes"
    },
    "Chita": {
      "15183000": "Chita (Cabecera Municipal)",
      "15183002": "El Moral"
    },
    "Chitaraque": {
      "15185000": "Chitaraque (Cabecera Municipal)"
    },
    "Chivatá": {
      "15187000": "Chivata (Cabecera Municipal)"
    },
    "Chivor": {
      "15236000": "Chivor (Cabecera Municipal)"
    },
    "Chíquiza": {
      "15232001": "Chiquiza Corregimiento"
    },
    "Ciénega": {
      "15189000": "Cienega (Cabecera Municipal)"
    },
    "Corrales": {
      "15215000": "Corrales (Cabecera Municipal)"
    },
    "Covarachía": {
      "15218000": "Covarachia (Cabecera Municipal)"
    },
    "Cubará": {
      "15223000": "Cubara (Cabecera Municipal)",
      "15223005": "El Guamo",
      "15223011": "Gibraltar"
    },
    "Cucaita": {
      "15224000": "Cucaita (Cabecera Municipal)"
    },
    "Cuítiva": {
      "15226000": "Cuitiva (Cabecera Municipal)"
    },
    "Cómbita": {
      "15204000": "Combita (Cabecera Municipal)",
      "15204001": "El Barne",
      "15204006": "San Onofre"
    },
    "Duitama": {
      "15238000": "Duitama (Cabecera Municipal)",
      "15238008": "San Lorenzo Abajo",
      "15238009": "San Antonio Norte",
      "15238012": "Ciudadela Industrial",
      "15238013": "Santa Clara",
      "15238014": "Tocogua"
    },
    "El Cocuy": {
      "15244000": "El Cocuy (Cabecera Municipal)"
    },
    "El Espino": {
      "15248000": "El Espino (Cabecera Municipal)"
    },
    "Firavitoba": {
      "15272000": "Firavitoba (Cabecera Municipal)"
    },
    "Floresta": {
      "15276000": "Floresta (Cabecera Municipal)",
      "15276001": "Tobasia"
    },
    "Gachantivá": {
      "15293000": "Gachantiva (Cabecera Municipal)"
    },
    "Garagoa": {
      "15299000": "Garagoa (Cabecera Municipal)"
    },
    "Guacamayas": {
      "15317000": "Guacamayas (Cabecera Municipal)"
    },
    "Guateque": {
      "15322000": "Guateque (Cabecera Municipal)"
    },
    "Guayatá": {
      "15325000": "Guayata (Cabecera Municipal)"
    },
    "Gámeza": {
      "15296000": "Gameza (Cabecera Municipal)"
    },
    "Güican De La Sierra": {
      "15332000": "Güican De La Sierra (Cabecera Municipal)"
    },
    "Iza": {
      "15362000": "Iza (Cabecera Municipal)"
    },
    "Jenesano": {
      "15367000": "Jenesano (Cabecera Municipal)"
    },
    "Jericó": {
      "15368000": "Jerico (Cabecera Municipal)"
    },
    "La Capilla": {
      "15380000": "La Capilla (Cabecera Municipal)"
    },
    "La Uvita": {
      "15403000": "La Uvita (Cabecera Municipal)",
      "15403001": "Cusagüi"
    },
    "La Victoria": {
      "15401000": "La Victoria (Cabecera Municipal)"
    },
    "Labranzagrande": {
      "15377000": "Labranzagrande (Cabecera Municipal)"
    },
    "Macanal": {
      "15425000": "Macanal (Cabecera Municipal)",
      "15425004": "San Pedro De Muceño"
    },
    "Maripí": {
      "15442000": "Maripi (Cabecera Municipal)",
      "15442001": "Santa Rosa",
      "15442002": "Zulia"
    },
    "Miraflores": {
      "15455000": "Miraflores (Cabecera Municipal)"
    },
    "Mongua": {
      "15464000": "Mongua (Cabecera Municipal)"
    },
    "Monguí": {
      "15466000": "Mongui (Cabecera Municipal)"
    },
    "Moniquirá": {
      "15469000": "Moniquira (Cabecera Municipal)",
      "15469007": "Los Cayenos"
    },
    "Motavita": {
      "15476000": "Motavita (Cabecera Municipal)"
    },
    "Muzo": {
      "15480000": "Muzo (Cabecera Municipal)"
    },
    "Nobsa": {
      "15491000": "Nobsa (Cabecera Municipal)",
      "15491001": "Belencito",
      "15491002": "Chameza Mayor",
      "15491003": "Dicho",
      "15491004": "Punta Larga",
      "15491005": "Ucuenga",
      "15491006": "Caleras",
      "15491007": "Nazareth",
      "15491009": "Chameza Menor",
      "15491010": "Guaquira",
      "15491012": "Santana"
    },
    "Nuevo Colón": {
      "15494000": "Nuevo Colon (Cabecera Municipal)"
    },
    "Oicatá": {
      "15500000": "Oicata (Cabecera Municipal)"
    },
    "Otanche": {
      "15507000": "Otanche (Cabecera Municipal)",
      "15507001": "Betania",
      "15507004": "Pizarra",
      "15507009": "San Jose De Nazareth"
    },
    "Pachavita": {
      "15511000": "Pachavita (Cabecera Municipal)"
    },
    "Paipa": {
      "15516000": "Paipa (Cabecera Municipal)",
      "15516001": "Palermo",
      "15516005": "Pantano De Vargas"
    },
    "Pajarito": {
      "15518000": "Pajarito (Cabecera Municipal)",
      "15518001": "Corinto"
    },
    "Panqueba": {
      "15522000": "Panqueba (Cabecera Municipal)"
    },
    "Pauna": {
      "15531000": "Pauna (Cabecera Municipal)"
    },
    "Paya": {
      "15533000": "Paya (Cabecera Municipal)",
      "15533001": "Morcote"
    },
    "Paz De Río": {
      "15537000": "Paz De Rio (Cabecera Municipal)"
    },
    "Pesca": {
      "15542000": "Pesca (Cabecera Municipal)"
    },
    "Puerto Boyacá": {
      "15572000": "Puerto Boyaca (Cabecera Municipal)",
      "15572001": "Guanegro",
      "15572006": "Cruce Palagua",
      "15572007": "Puerto Serviez",
      "15572008": "El Pescado",
      "15572009": "Kilometro Dos Y Medio",
      "15572010": "Kilometro 25",
      "15572011": "El Marfil",
      "15572012": "Puerto Pinzon",
      "15572013": "Puerto Romero",
      "15572017": "Cruce El Chaparro",
      "15572018": "El Ermitaño",
      "15572019": "El Okal",
      "15572020": "El Trique",
      "15572021": "Kilometro 11",
      "15572023": "Muelle Velasquez",
      "15572024": "Puerto Niño",
      "15572026": "Kilometro Uno Y Medio"
    },
    "Páez": {
      "15514000": "Paez (Cabecera Municipal)",
      "15514001": "La Ururia",
      "15514002": "Sirasi"
    },
    "Quípama": {
      "15580000": "Quipama (Cabecera Municipal)",
      "15580001": "Cormal",
      "15580002": "El Parque",
      "15580003": "Humbo"
    },
    "Ramiriquí": {
      "15599000": "Ramiriqui (Cabecera Municipal)",
      "15599001": "Guayabal (Fatima)",
      "15599004": "El Escobal"
    },
    "Rondón": {
      "15621000": "Rondon (Cabecera Municipal)",
      "15621001": "Ranchogrande"
    },
    "Ráquira": {
      "15600000": "Raquira (Cabecera Municipal)",
      "15600002": "La Candelaria"
    },
    "Saboyá": {
      "15632000": "Saboya (Cabecera Municipal)"
    },
    "Samacá": {
      "15646000": "Samaca (Cabecera Municipal)",
      "15646001": "La Cumbre",
      "15646002": "La Fabrica"
    },
    "San Eduardo": {
      "15660000": "San Eduardo (Cabecera Municipal)"
    },
    "San José De Pare": {
      "15664000": "San Jose De Pare (Cabecera Municipal)"
    },
    "San Luis De Gaceno": {
      "15667000": "San Luis De Gaceno (Cabecera Municipal)",
      "15667001": "Santa Teresa",
      "15667003": "Horizontes",
      "15667005": "San Carlos Del Guavio"
    },
    "San Mateo": {
      "15673000": "San Mateo (Cabecera Municipal)"
    },
    "San Miguel De Sema": {
      "15676000": "San Miguel De Sema (Cabecera Municipal)"
    },
    "San Pablo De Borbur": {
      "15681000": "San Pablo De Borbur (Cabecera Municipal)",
      "15681005": "Santa Barbara",
      "15681006": "San Martin",
      "15681007": "Coscuez"
    },
    "Santa María": {
      "15690000": "Santa Maria (Cabecera Municipal)"
    },
    "Santa Rosa De Viterbo": {
      "15693000": "Santa Rosa De Viterbo (Cabecera Municipal)"
    },
    "Santa Sofía": {
      "15696000": "Santa Sofia (Cabecera Municipal)"
    },
    "Santana": {
      "15686000": "Santana (Cabecera Municipal)"
    },
    "Sativanorte": {
      "15720000": "Sativanorte (Cabecera Municipal)",
      "15720001": "Sativa Viejo"
    },
    "Sativasur": {
      "15723000": "Sativasur (Cabecera Municipal)"
    },
    "Siachoque": {
      "15740000": "Siachoque (Cabecera Municipal)"
    },
    "Soatá": {
      "15753000": "Soata (Cabecera Municipal)"
    },
    "Socha": {
      "15757000": "Socha (Cabecera Municipal)"
    },
    "Socotá": {
      "15755000": "Socota (Cabecera Municipal)",
      "15755004": "Los Pinos"
    },
    "Sogamoso": {
      "15759000": "Sogamoso (Cabecera Municipal)",
      "15759001": "Morca",
      "15759003": "Vanegas",
      "15759005": "El Crucero",
      "15759006": "Alcaparral",
      "15759007": "Milagro Y Playita"
    },
    "Somondoco": {
      "15761000": "Somondoco (Cabecera Municipal)"
    },
    "Sora": {
      "15762000": "Sora (Cabecera Municipal)"
    },
    "Soracá": {
      "15764000": "Soraca (Cabecera Municipal)"
    },
    "Sotaquirá": {
      "15763000": "Sotaquira (Cabecera Municipal)",
      "15763002": "Bosigas",
      "15763003": "Carreño"
    },
    "Susacón": {
      "15774000": "Susacon (Cabecera Municipal)"
    },
    "Sutamarchán": {
      "15776000": "Sutamarchan (Cabecera Municipal)"
    },
    "Sutatenza": {
      "15778000": "Sutatenza (Cabecera Municipal)"
    },
    "Sáchica": {
      "15638000": "Sachica (Cabecera Municipal)"
    },
    "Tasco": {
      "15790000": "Tasco (Cabecera Municipal)",
      "15790001": "Libertadores"
    },
    "Tenza": {
      "15798000": "Tenza (Cabecera Municipal)"
    },
    "Tibaná": {
      "15804000": "Tibana (Cabecera Municipal)"
    },
    "Tibasosa": {
      "15806000": "Tibasosa (Cabecera Municipal)",
      "15806002": "El Paraiso",
      "15806003": "Santa Teresa"
    },
    "Tinjacá": {
      "15808000": "Tinjaca (Cabecera Municipal)"
    },
    "Tipacoque": {
      "15810000": "Tipacoque (Cabecera Municipal)"
    },
    "Toca": {
      "15814000": "Toca (Cabecera Municipal)"
    },
    "Togüí": {
      "15816000": "Togüi (Cabecera Municipal)"
    },
    "Tota": {
      "15822000": "Tota (Cabecera Municipal)"
    },
    "Tunja": {
      "15001000": "Tunja (Cabecera Municipal)"
    },
    "Tununguá": {
      "15832000": "Tunungua (Cabecera Municipal)"
    },
    "Turmequé": {
      "15835000": "Turmeque (Cabecera Municipal)"
    },
    "Tuta": {
      "15837000": "Tuta (Cabecera Municipal)"
    },
    "Tutazá": {
      "15839000": "Tutaza (Cabecera Municipal)"
    },
    "Tópaga": {
      "15820000": "Topaga (Cabecera Municipal)",
      "15820001": "Bado Castro"
    },
    "Ventaquemada": {
      "15861000": "Ventaquemada (Cabecera Municipal)",
      "15861006": "Estancia Grande",
      "15861007": "Puente Boyaca",
      "15861008": "Tierra Negra",
      "15861009": "El Carpi",
      "15861010": "El Manzano"
    },
    "Villa De Leyva": {
      "15407000": "Villa De Leyva (Cabecera Municipal)",
      "15407003": "El Roble"
    },
    "Viracachá": {
      "15879000": "Viracacha (Cabecera Municipal)"
    },
    "Zetaquira": {
      "15897000": "Zetaquira (Cabecera Municipal)"
    },
    "Úmbita": {
      "15842000": "Umbita (Cabecera Municipal)"
    }
  },
  "Caldas": {
    "Aguadas": {
      "17013000": "Aguadas (Cabecera Municipal)",
      "17013001": "Arma",
      "17013004": "La Mermita",
      "17013010": "Eden",
      "17013011": "San Nicolas",
      "17013012": "Alto De Pito",
      "17013014": "Alto De La Montaña",
      "17013016": "Viboral",
      "17013017": "Pore"
    },
    "Anserma": {
      "17042000": "Anserma (Cabecera Municipal)",
      "17042004": "Marapra",
      "17042007": "San Pedro"
    },
    "Aranzazu": {
      "17050000": "Aranzazu (Cabecera Municipal)",
      "17050006": "San Rafael"
    },
    "Belalcázar": {
      "17088000": "Belalcazar (Cabecera Municipal)",
      "17088001": "El Madroño",
      "17088002": "La Habana",
      "17088003": "San Isidro",
      "17088008": "Asentamiento Indigena Totumal"
    },
    "Chinchiná": {
      "17174000": "Chinchina (Cabecera Municipal)",
      "17174001": "El Trebol",
      "17174002": "La Floresta",
      "17174006": "Alto De La Mina",
      "17174007": "La Quiebra Del Naranjal",
      "17174011": "La Estrella",
      "17174012": "El Reposo",
      "17174013": "Guayabal",
      "17174015": "San Andres"
    },
    "Filadelfia": {
      "17272000": "Filadelfia (Cabecera Municipal)",
      "17272002": "El Verso",
      "17272003": "La Paila",
      "17272007": "San Luis",
      "17272008": "Balmoral",
      "17272009": "La Marina"
    },
    "La Dorada": {
      "17380000": "La Dorada (Cabecera Municipal)",
      "17380001": "Buenavista",
      "17380003": "Purnio",
      "17380007": "Camelias",
      "17380008": "Doña Juana",
      "17380010": "La Agustina",
      "17380015": "Prosocial La Humareda"
    },
    "La Merced": {
      "17388000": "La Merced (Cabecera Municipal)",
      "17388002": "La Felisa",
      "17388007": "Llanadas"
    },
    "Manizales": {
      "17001000": "Manizales (Cabecera Municipal)",
      "17001001": "Alto De Lisboa",
      "17001002": "Kilometro 41 - Colombia",
      "17001003": "Bajo Tablazo",
      "17001004": "La Cabaña",
      "17001005": "La Cuchilla Del Salado",
      "17001009": "San Peregrino",
      "17001010": "Alto Tablazo",
      "17001011": "Alto Del Naranjo",
      "17001012": "El Arenillo",
      "17001015": "La Aurora",
      "17001022": "Alto Bonito",
      "17001023": "Mina Rica",
      "17001024": "La Garrucha",
      "17001034": "El Aguila"
    },
    "Manzanares": {
      "17433000": "Manzanares (Cabecera Municipal)",
      "17433001": "Aguabonita",
      "17433004": "Las Margaritas",
      "17433005": "Los Planes"
    },
    "Marmato": {
      "17442000": "Marmato (Cabecera Municipal)",
      "17442001": "Cabras",
      "17442002": "El Llano",
      "17442003": "San Juan",
      "17442005": "La Cuchilla",
      "17442008": "Jimenez Alto",
      "17442009": "Jimenez Bajo",
      "17442012": "Loaiza"
    },
    "Marquetalia": {
      "17444000": "Marquetalia (Cabecera Municipal)",
      "17444001": "Santa Elena"
    },
    "Marulanda": {
      "17446000": "Marulanda (Cabecera Municipal)"
    },
    "Neira": {
      "17486000": "Neira (Cabecera Municipal)",
      "17486004": "Pueblo Rico",
      "17486005": "Tapias",
      "17486009": "Barrio Medellin",
      "17486010": "La Isla",
      "17486011": "Agrovilla",
      "17486012": "San Jose"
    },
    "Norcasia": {
      "17495000": "Norcasia (Cabecera Municipal)",
      "17495002": "La Quiebra"
    },
    "Palestina": {
      "17524000": "Palestina (Cabecera Municipal)",
      "17524001": "Arauca"
    },
    "Pensilvania": {
      "17541000": "Pensilvania (Cabecera Municipal)",
      "17541001": "Arboleda",
      "17541004": "El Higueron",
      "17541006": "La Linda",
      "17541008": "La Rioja",
      "17541009": "Pueblonuevo",
      "17541011": "San Daniel",
      "17541015": "La Soledad Alta",
      "17541016": "Aguabonita"
    },
    "Pácora": {
      "17513000": "Pacora (Cabecera Municipal)",
      "17513001": "Castilla",
      "17513002": "Las Coles",
      "17513003": "San Bartolome",
      "17513012": "Buenos Aires",
      "17513013": "El Morro"
    },
    "Riosucio": {
      "17614000": "Riosucio (Cabecera Municipal)",
      "17614001": "Bonafont",
      "17614003": "El Salado",
      "17614004": "Florencia",
      "17614005": "Quiebralomo",
      "17614006": "San Lorenzo",
      "17614008": "Iberia",
      "17614010": "Sipirra",
      "17614014": "San Jeronimo",
      "17614017": "Pueblo Viejo",
      "17614021": "Las Estancias",
      "17614022": "La Playa - Imurra",
      "17614023": "Tumbabarreto"
    },
    "Risaralda": {
      "17616000": "Risaralda (Cabecera Municipal)",
      "17616004": "Quiebra Santa Barbara",
      "17616008": "Quiebra Varillas",
      "17616011": "Calle Larga"
    },
    "Salamina": {
      "17653000": "Salamina (Cabecera Municipal)",
      "17653004": "Vereda La Union",
      "17653007": "San Felix"
    },
    "Samaná": {
      "17662000": "Samana (Cabecera Municipal)",
      "17662001": "Berlin",
      "17662003": "Florencia",
      "17662004": "Encimadas",
      "17662005": "Los Pomos",
      "17662007": "San Diego",
      "17662008": "Rancholargo"
    },
    "San José": {
      "17665000": "San Jose (Cabecera Municipal)",
      "17665002": "Primavera Alta",
      "17665004": "Condominios Valles De Acapulco Y Los Seis Y Punto"
    },
    "Supía": {
      "17777000": "Supia (Cabecera Municipal)",
      "17777003": "La Quinta",
      "17777005": "Hojas Anchas",
      "17777008": "Guamal",
      "17777010": "Puerto Nuevo"
    },
    "Victoria": {
      "17867000": "Victoria (Cabecera Municipal)",
      "17867001": "Cañaveral",
      "17867003": "Isaza",
      "17867004": "La Pradera",
      "17867005": "El Llano",
      "17867007": "La Fe"
    },
    "Villamaría": {
      "17873000": "Villamaria (Cabecera Municipal)",
      "17873001": "Alto De La Cruz - Los Cuervos",
      "17873003": "Llanitos",
      "17873004": "Rioclaro",
      "17873006": "San Julian",
      "17873007": "Miraflores",
      "17873008": "Alto Villarazo",
      "17873010": "Gallinazo",
      "17873011": "La Nueva Primavera",
      "17873014": "La Floresta",
      "17873016": "Corozal",
      "17873017": "Partidas",
      "17873018": "Granja Agricola La Paz",
      "17873019": "Nuevo Rio Claro"
    },
    "Viterbo": {
      "17877000": "Viterbo (Cabecera Municipal)"
    }
  },
  "Caquetá": {
    "Albania": {
      "18029000": "Albania (Cabecera Municipal)",
      "18029003": "Dorado",
      "18029004": "Versalles",
      "18029005": "El Paraiso"
    },
    "Belén De Los Andaquíes": {
      "18094000": "Belen De Los Andaquies (Cabecera Municipal)",
      "18094001": "El Portal La Mono",
      "18094003": "Puerto Torres",
      "18094008": "Aletones"
    },
    "Cartagena Del Chairá": {
      "18150000": "Cartagena Del Chaira (Cabecera Municipal)",
      "18150001": "Remolino Del Caguan",
      "18150002": "Santa Fe Del Caguan",
      "18150003": "Monserrate",
      "18150004": "Peñas Coloradas",
      "18150005": "El Guamo",
      "18150006": "Puerto Camelia",
      "18150007": "Santo Domingo",
      "18150008": "Los Cristales",
      "18150009": "Risaralda",
      "18150011": "Cumarales",
      "18150012": "El Cafe",
      "18150013": "Napoles (Puerto Napoles)",
      "18150014": "Peñas Blancas"
    },
    "Curillo": {
      "18205000": "Curillo (Cabecera Municipal)",
      "18205001": "Salamina",
      "18205002": "Novia Puerto Valdivia",
      "18205003": "Palizadas"
    },
    "El Doncello": {
      "18247000": "El Doncello (Cabecera Municipal)",
      "18247001": "Maguare",
      "18247002": "Puerto Manrique"
    },
    "El Paujíl": {
      "18256000": "El Paujil (Cabecera Municipal)",
      "18256001": "Versalles",
      "18256002": "Bolivia"
    },
    "Florencia": {
      "18001000": "Florencia (Cabecera Municipal)",
      "18001004": "San Antonio De Atenas",
      "18001005": "Santana Las Hermosas",
      "18001006": "La Esperanza",
      "18001007": "Norcacia",
      "18001009": "El Para",
      "18001024": "Puerto Arango"
    },
    "La Montañita": {
      "18410000": "La Montañita (Cabecera Municipal)",
      "18410001": "Santuario",
      "18410002": "La Union Peneya",
      "18410005": "El Triunfo",
      "18410006": "Mateguadua",
      "18410007": "San Isidro",
      "18410008": "Miramar",
      "18410009": "Puerto Brasilia",
      "18410010": "Puerto Gaitan"
    },
    "Milán": {
      "18460000": "Milan (Cabecera Municipal)",
      "18460001": "San Antonio De Getucha",
      "18460003": "Maticuru - Granario",
      "18460004": "La Rastra",
      "18460005": "Remolinos De Aricunti",
      "18460008": "Agua Blanca"
    },
    "Morelia": {
      "18479000": "Morelia (Cabecera Municipal)"
    },
    "Puerto Rico": {
      "18592000": "Puerto Rico (Cabecera Municipal)",
      "18592003": "Lusitania",
      "18592004": "Santana Ramos",
      "18592005": "La Esmeralda",
      "18592006": "La Aguililla"
    },
    "San José Del Fragua": {
      "18610000": "San Jose Del Fragua (Cabecera Municipal)",
      "18610001": "Fraguita",
      "18610002": "Yurayaco",
      "18610003": "Sabaleta"
    },
    "San Vicente Del Caguán": {
      "18753000": "San Vicente Del Caguan (Cabecera Municipal)",
      "18753002": "Guacamayas",
      "18753003": "Balsillas",
      "18753007": "Tres Esquinas",
      "18753009": "Puerto Betania",
      "18753010": "Gibraltar",
      "18753012": "Santa Rosa",
      "18753013": "Troncales",
      "18753015": "Guayabal"
    },
    "Solano": {
      "18756000": "Solano (Cabecera Municipal)",
      "18756001": "Araracuara",
      "18756004": "El Danubio - Campo Alegre",
      "18756005": "Peñas Blancas",
      "18756006": "Cuemani",
      "18756007": "Mononguete",
      "18756008": "Puerto Tejada"
    },
    "Solita": {
      "18785000": "Solita (Cabecera Municipal)",
      "18785002": "Kilometro 30 (Campo Lejano)",
      "18785005": "Union Sincelejo"
    },
    "Valparaíso": {
      "18860000": "Valparaiso (Cabecera Municipal)",
      "18860001": "Santiago De La Selva",
      "18860002": "Kilometro 18",
      "18860005": "Playa Rica"
    }
  },
  "Casanare": {
    "Aguazul": {
      "85010000": "Aguazul (Cabecera Municipal)",
      "85010001": "Cupiagua",
      "85010002": "Monterralo",
      "85010003": "San Benito",
      "85010005": "San Jose",
      "85010006": "Unete",
      "85010010": "Puente Cusiana"
    },
    "Chámeza": {
      "85015000": "Chameza (Cabecera Municipal)"
    },
    "Hato Corozal": {
      "85125000": "Hato Corozal (Cabecera Municipal)",
      "85125002": "Chire",
      "85125003": "La Frontera - La Chapa",
      "85125005": "Puerto Colombia",
      "85125010": "Santa Rita",
      "85125011": "San Jose De Ariporo"
    },
    "La Salina": {
      "85136000": "La Salina (Cabecera Municipal)"
    },
    "Maní": {
      "85139001": "Guafalpintado",
      "85139003": "Gaviotas",
      "85139005": "Santa Helena De Cusiva"
    },
    "Monterrey": {
      "85162000": "Monterrey (Cabecera Municipal)",
      "85162002": "Brisas De Llano",
      "85162004": "El Porvenir",
      "85162006": "Villa Carola"
    },
    "Nunchía": {
      "85225000": "Nunchia (Cabecera Municipal)",
      "85225016": "La Yopalosa"
    },
    "Orocué": {
      "85230000": "Orocue (Cabecera Municipal)",
      "85230003": "El Algarrobo"
    },
    "Paz De Ariporo": {
      "85250000": "Paz De Ariporo (Cabecera Municipal)",
      "85250001": "Bocas De La Hermosa",
      "85250002": "Centro Gaitan",
      "85250003": "Caño Chiquito",
      "85250004": "La Aguada",
      "85250006": "Montaña Del Totumo"
    },
    "Pore": {
      "85263000": "Pore (Cabecera Municipal)",
      "85263001": "El Banco"
    },
    "Recetor": {
      "85279000": "Recetor (Cabecera Municipal)"
    },
    "Sabanalarga": {
      "85300000": "Sabanalarga (Cabecera Municipal)",
      "85300001": "Aguaclara",
      "85300003": "El Secreto"
    },
    "San Luis De Palenque": {
      "85325000": "San Luis De Palenque (Cabecera Municipal)",
      "85325002": "Miramar De Guanapalo"
    },
    "Sácama": {
      "85315000": "Sacama (Cabecera Municipal)"
    },
    "Tauramena": {
      "85410000": "Tauramena (Cabecera Municipal)",
      "85410004": "Tunupe",
      "85410005": "Paso Cusiana"
    },
    "Trinidad": {
      "85430000": "Trinidad (Cabecera Municipal)",
      "85430001": "Bocas Del Pauto"
    },
    "Támara": {
      "85400000": "Tamara (Cabecera Municipal)",
      "85400002": "Tablon De Tamara",
      "85400004": "Teislandia"
    },
    "Villanueva": {
      "85440000": "Villanueva (Cabecera Municipal)",
      "85440001": "Caribayona",
      "85440002": "Santa Helena De Upia",
      "85440003": "San Agustin"
    },
    "Yopal": {
      "85001000": "Yopal (Cabecera Municipal)",
      "85001001": "El Morro",
      "85001002": "La Chaparrera",
      "85001003": "Tilodiran",
      "85001006": "Santafe De Morichal",
      "85001010": "La Guafilla",
      "85001011": "La Llanerita"
    }
  },
  "Cauca": {
    "Almaguer": {
      "19022000": "Almaguer (Cabecera Municipal)",
      "19022003": "Tablon",
      "19022004": "Llacuanas",
      "19022013": "San Jorge Herradura",
      "19022014": "La Honda"
    },
    "Argelia": {
      "19050000": "Argelia (Cabecera Municipal)",
      "19050001": "El Mango",
      "19050002": "La Belleza",
      "19050005": "El Diviso",
      "19050007": "Sinai",
      "19050016": "Puerto Rico",
      "19050017": "San Juan Guadua"
    },
    "Balboa": {
      "19075000": "Balboa (Cabecera Municipal)",
      "19075001": "La Planada",
      "19075002": "Olaya",
      "19075003": "San Alfonso",
      "19075005": "La Bermeja",
      "19075006": "Pureto",
      "19075008": "La Lomita",
      "19075009": "El Vijal",
      "19075011": "Paraiso"
    },
    "Bolívar": {
      "19100000": "Bolivar (Cabecera Municipal)",
      "19100001": "Capellanias",
      "19100005": "El Carmen",
      "19100006": "El Rodeo",
      "19100007": "Guachicono",
      "19100013": "Lerma",
      "19100015": "Los Milagros",
      "19100018": "Melchor",
      "19100020": "San Juan",
      "19100021": "San Lorenzo",
      "19100041": "La Carbonera",
      "19100042": "El Morro"
    },
    "Buenos Aires": {
      "19110000": "Buenos Aires (Cabecera Municipal)"
    },
    "Cajibío": {
      "19130000": "Cajibio (Cabecera Municipal)",
      "19130004": "El Carmelo",
      "19130005": "El Rosario",
      "19130006": "La Capilla",
      "19130007": "La Pedregosa",
      "19130008": "La Venta",
      "19130010": "Ortega"
    },
    "Caldono": {
      "19137000": "Caldono (Cabecera Municipal)",
      "19137001": "Cerro Alto",
      "19137002": "El Pital",
      "19137004": "Pescador",
      "19137007": "Pueblo Nuevo",
      "19137008": "Siberia"
    },
    "Caloto": {
      "19142000": "Caloto (Cabecera Municipal)",
      "19142004": "El Palo",
      "19142007": "Huasano",
      "19142011": "Quintero",
      "19142015": "La Arrobleda",
      "19142030": "Crucero De Guali",
      "19142031": "Huellas",
      "19142032": "Alto El Palo",
      "19142034": "Bodega Arriba",
      "19142038": "El Nilo",
      "19142039": "El Guasimo",
      "19142045": "Toez"
    },
    "Corinto": {
      "19212000": "Corinto (Cabecera Municipal)",
      "19212001": "El Jagual",
      "19212004": "Media Naranja",
      "19212005": "Rionegro",
      "19212008": "San Rafael",
      "19212009": "El Barranco",
      "19212010": "Quebraditas"
    },
    "El Tambo": {
      "19256000": "El Tambo (Cabecera Municipal)",
      "19256001": "Alto Del Rey",
      "19256004": "Cuatro Esquinas",
      "19256005": "Chapa",
      "19256007": "El Placer",
      "19256009": "El Zarzal",
      "19256012": "Huisito",
      "19256013": "La Alianza",
      "19256014": "La Paz",
      "19256015": "Los Anayes",
      "19256016": "Los Andes",
      "19256019": "Pandiguando",
      "19256020": "Piagua",
      "19256022": "Quilcace",
      "19256025": "San Joaquin",
      "19256027": "Seguengue",
      "19256028": "Uribe",
      "19256029": "Fondas",
      "19256031": "Buena Vista",
      "19256032": "Las Botas",
      "19256033": "Cabuyal",
      "19256034": "El Crucero Del Pueblo",
      "19256036": "Playa Rica"
    },
    "Florencia": {
      "19290000": "Florencia (Cabecera Municipal)",
      "19290001": "El Rosario",
      "19290002": "Marsella"
    },
    "Guachené": {
      "19300000": "Guachene (Cabecera Municipal)"
    },
    "Guapí": {
      "19318000": "Guapi (Cabecera Municipal)",
      "19318002": "Benjamin Herrera (San Vicente)",
      "19318003": "Callelarga",
      "19318005": "El Carmelo",
      "19318008": "Limones",
      "19318011": "El Rosario",
      "19318012": "San Agustin",
      "19318013": "San Antonio De Guajui",
      "19318015": "Uribe Uribe (El Naranjo)",
      "19318024": "Quiroga",
      "19318025": "Chuare",
      "19318027": "Belen"
    },
    "Inzá": {
      "19355000": "Inza (Cabecera Municipal)",
      "19355001": "Calderas",
      "19355002": "Pedregal",
      "19355003": "Puerto Valencia",
      "19355004": "San Andres",
      "19355008": "Tumbichucue",
      "19355009": "Turmina"
    },
    "Jambaló": {
      "19364000": "Jambalo (Cabecera Municipal)"
    },
    "La Sierra": {
      "19392000": "La Sierra (Cabecera Municipal)"
    },
    "La Vega": {
      "19397000": "La Vega (Cabecera Municipal)",
      "19397001": "Altamira",
      "19397002": "Arbela",
      "19397004": "El Palmar",
      "19397005": "Guachicono",
      "19397006": "Los Uvos",
      "19397007": "Pancitara",
      "19397009": "San Miguel",
      "19397010": "Santa Barbara",
      "19397011": "Santa Juana",
      "19397012": "Albania",
      "19397018": "Barbillas",
      "19397019": "Santa Rita"
    },
    "López De Micay": {
      "19418000": "Lopez De Micay (Cabecera Municipal)",
      "19418009": "Noanamito",
      "19418010": "Playa Grande",
      "19418012": "San Antonio De Chuare",
      "19418018": "Taparal",
      "19418019": "Zaragoza",
      "19418024": "Betania",
      "19418032": "San Antonio De Gurumendy",
      "19418035": "Santa Cruz De Sigui"
    },
    "Mercaderes": {
      "19450000": "Mercaderes (Cabecera Municipal)",
      "19450002": "Arboledas",
      "19450003": "El Pilon",
      "19450004": "Esmeraldas",
      "19450006": "San Joaquin",
      "19450007": "San Juanito",
      "19450015": "El Bado",
      "19450016": "Tabloncito",
      "19450019": "Mojarras",
      "19450020": "Los Llanos"
    },
    "Miranda": {
      "19455000": "Miranda (Cabecera Municipal)",
      "19455005": "Ortigal",
      "19455007": "Santa Ana",
      "19455009": "Tulipan"
    },
    "Morales": {
      "19473000": "Morales (Cabecera Municipal)",
      "19473002": "Carpintero",
      "19473009": "San Isidro",
      "19473014": "La Estacion",
      "19473017": "El Rosario"
    },
    "Padilla": {
      "19513000": "Padilla (Cabecera Municipal)",
      "19513001": "Yarumales",
      "19513003": "La Paila",
      "19513004": "El Chamizo",
      "19513007": "Los Robles",
      "19513008": "Cuernavaca"
    },
    "Patía": {
      "19532000": "Patia (Cabecera Municipal)",
      "19532001": "Brisas",
      "19532003": "Don Alonso",
      "19532004": "Galindez",
      "19532005": "La Fonda",
      "19532006": "La Mesa",
      "19532009": "Piedrasentada",
      "19532010": "Pan De Azucar",
      "19532012": "Sajandi",
      "19532014": "El Hoyo",
      "19532025": "Santa Cruz"
    },
    "Piamonte": {
      "19533000": "Piamonte (Cabecera Municipal)",
      "19533002": "El Remanso",
      "19533003": "Miraflor",
      "19533004": "Yapura"
    },
    "Piendamo - Tunia": {
      "19548000": "Piendamo - Tunia (Cabecera Municipal)",
      "19548001": "Tunia"
    },
    "Popayán": {
      "19001000": "Popayan (Cabecera Municipal)",
      "19001001": "Cajete",
      "19001002": "Calibio",
      "19001007": "Julumito",
      "19001008": "La Rejoya",
      "19001013": "Pueblillo",
      "19001014": "Puelenje",
      "19001025": "Poblazon",
      "19001026": "Samuel Silverio",
      "19001027": "Crucero De Puelenje",
      "19001028": "El Salvador",
      "19001029": "El Tunel",
      "19001030": "Julumito Alto",
      "19001031": "La Cabuyera",
      "19001032": "La Playa",
      "19001033": "Lame",
      "19001035": "Vereda De Torres",
      "19001037": "La Esperanza (Jardines De Paz)",
      "19001038": "La Fortaleza",
      "19001039": "Parcelacion Atardeceres De La Pradera"
    },
    "Puerto Tejada": {
      "19573000": "Puerto Tejada (Cabecera Municipal)",
      "19573001": "Bocas Del Palo",
      "19573002": "Las Brisas",
      "19573003": "San Carlos"
    },
    "Puracé": {
      "19585004": "Purace Corregimiento",
      "19585007": "Santa Leticia"
    },
    "Rosas": {
      "19622000": "Rosas (Cabecera Municipal)",
      "19622002": "Parraga",
      "19622007": "Cefiro",
      "19622011": "Sauce"
    },
    "San Sebastián": {
      "19693000": "San Sebastian (Cabecera Municipal)",
      "19693001": "El Rosal",
      "19693005": "Valencia"
    },
    "Santa Rosa": {
      "19701000": "Santa Rosa (Cabecera Municipal)",
      "19701001": "Descanse",
      "19701002": "El Carmelo",
      "19701006": "San Juan De Villalobos"
    },
    "Santander De Quilichao": {
      "19698000": "Santander De Quilichao (Cabecera Municipal)",
      "19698001": "El Palmar",
      "19698002": "El Turco",
      "19698004": "La Arrobleda",
      "19698007": "Mondomo",
      "19698009": "San Rafael",
      "19698010": "Tres Quebradas",
      "19698013": "San Antonio",
      "19698014": "San Pedro",
      "19698017": "Dominguillo",
      "19698018": "El Crucero",
      "19698020": "Quinamayo",
      "19698022": "Llano De Alegrias",
      "19698026": "El Llanito",
      "19698027": "El Tajo",
      "19698028": "La Agustina",
      "19698029": "La Capilla",
      "19698030": "La Chapa",
      "19698032": "La Quebrada",
      "19698033": "Lomitas Abajo",
      "19698034": "Lomitas Arriba",
      "19698037": "San Jose",
      "19698043": "Bellavista"
    },
    "Silvia": {
      "19743000": "Silvia (Cabecera Municipal)",
      "19743002": "Pitayo",
      "19743003": "Quichaya",
      "19743005": "Usenda"
    },
    "Sotara - Paispamba": {
      "19760000": "Sotara - Paispamba (Cabecera Municipal)",
      "19760007": "Rio Blanco"
    },
    "Sucre": {
      "19785000": "Sucre (Cabecera Municipal)",
      "19785001": "El Paraiso",
      "19785008": "La Ceja"
    },
    "Suárez": {
      "19780000": "Suarez (Cabecera Municipal)",
      "19780007": "La Toma",
      "19780008": "La Betulia"
    },
    "Timbiquí": {
      "19809000": "Timbiqui (Cabecera Municipal)",
      "19809001": "Bubuey",
      "19809002": "Camarones",
      "19809003": "Coteje",
      "19809006": "San Bernardo",
      "19809007": "San Jose",
      "19809008": "Santa Maria",
      "19809009": "Santa Rosa De Saija",
      "19809010": "Chete",
      "19809011": "Boca De Patia",
      "19809012": "El Charco",
      "19809013": "El Realito",
      "19809018": "Cupi",
      "19809020": "San Miguel",
      "19809021": "Corozal",
      "19809022": "Cabecital",
      "19809023": "Puerto Saija",
      "19809024": "Angostura",
      "19809025": "Guangui"
    },
    "Timbío": {
      "19807000": "Timbio (Cabecera Municipal)",
      "19807007": "Cruces"
    },
    "Toribío": {
      "19821000": "Toribio (Cabecera Municipal)",
      "19821005": "San Francisco",
      "19821007": "Tacueyo"
    },
    "Totoró": {
      "19824000": "Totoro (Cabecera Municipal)",
      "19824002": "Gabriel Lopez",
      "19824004": "Paniquita"
    },
    "Villa Rica": {
      "19845000": "Villa Rica (Cabecera Municipal)",
      "19845005": "Juan Ignacio",
      "19845006": "Primavera"
    }
  },
  "Cesar": {
    "Aguachica": {
      "20011000": "Aguachica (Cabecera Municipal)",
      "20011001": "Barrancalebrija",
      "20011006": "Loma De Corredor",
      "20011009": "Puerto Patiño",
      "20011010": "Buturama",
      "20011011": "Norean",
      "20011012": "Santa Lucia",
      "20011014": "Villa De San Andres",
      "20011025": "El Juncal",
      "20011026": "La Campana"
    },
    "Agustín Codazzi": {
      "20013000": "Agustin Codazzi (Cabecera Municipal)",
      "20013002": "Casacara",
      "20013003": "Llerasca",
      "20013006": "Punta Arrecha",
      "20013007": "San Ramon"
    },
    "Astrea": {
      "20032000": "Astrea (Cabecera Municipal)",
      "20032001": "Arjona",
      "20032003": "El Yucal",
      "20032005": "Santa Cecilia",
      "20032006": "El Hebron",
      "20032007": "El Jobo"
    },
    "Becerril": {
      "20045000": "Becerril (Cabecera Municipal)",
      "20045001": "Estados Unidos",
      "20045004": "La Guajirita"
    },
    "Bosconia": {
      "20060000": "Bosconia (Cabecera Municipal)",
      "20060004": "Loma Colorada",
      "20060010": "Puerto Lajas"
    },
    "Chimichagua": {
      "20175000": "Chimichagua (Cabecera Municipal)",
      "20175004": "Candelaria",
      "20175005": "El Guamo",
      "20175008": "Las Flores",
      "20175009": "Las Vegas",
      "20175010": "Mandinguilla",
      "20175011": "Saloa",
      "20175013": "Sempegua",
      "20175014": "Soledad",
      "20175017": "El Canal",
      "20175018": "Santo Domingo",
      "20175020": "Plata Perdida",
      "20175022": "Higo Amarillo"
    },
    "Chiriguaná": {
      "20178000": "Chiriguana (Cabecera Municipal)",
      "20178006": "Poponte",
      "20178008": "Rincon Hondo",
      "20178014": "La Aurora",
      "20178015": "Estacion Chiriguana",
      "20178016": "La Sierra",
      "20178017": "Agua Fria",
      "20178018": "El Cruce De La Sierra",
      "20178019": "Arenas Blancas"
    },
    "Curumaní": {
      "20228000": "Curumani (Cabecera Municipal)",
      "20228001": "Sabanagrande",
      "20228002": "San Roque",
      "20228003": "San Sebastian",
      "20228004": "Santa Isabel",
      "20228007": "Guaimaral",
      "20228008": "Barrio Acosta",
      "20228011": "El Mamey"
    },
    "El Copey": {
      "20238000": "El Copey (Cabecera Municipal)",
      "20238002": "Caracolicito",
      "20238003": "Chimila",
      "20238004": "San Francisco De Asis"
    },
    "El Paso": {
      "20250000": "El Paso (Cabecera Municipal)",
      "20250001": "El Vallito",
      "20250002": "La Loma",
      "20250003": "Potrerillo",
      "20250004": "Cuatro Vientos",
      "20250006": "El Carmen"
    },
    "Gamarra": {
      "20295000": "Gamarra (Cabecera Municipal)",
      "20295001": "La Estacion",
      "20295002": "El Contento",
      "20295004": "Palenquillo",
      "20295005": "Puerto Mosquito",
      "20295006": "Puerto Viejo",
      "20295007": "Cascajal"
    },
    "González": {
      "20310000": "Gonzalez (Cabecera Municipal)",
      "20310002": "Burbura",
      "20310003": "Culebrita",
      "20310006": "Montera",
      "20310007": "San Isidro"
    },
    "La Gloria": {
      "20383000": "La Gloria (Cabecera Municipal)",
      "20383001": "Ayacucho",
      "20383002": "Carolina",
      "20383003": "Molina",
      "20383005": "Simaña",
      "20383006": "Besote",
      "20383010": "La Mata",
      "20383011": "Estacion Ferrocarril"
    },
    "La Jagua De Ibirico": {
      "20400000": "La Jagua De Ibirico (Cabecera Municipal)",
      "20400001": "Las Palmitas"
    },
    "La Paz": {
      "20621000": "La Paz (Cabecera Municipal)",
      "20621001": "Los Encantos",
      "20621006": "San Jose Del Oriente",
      "20621011": "Varas Blancas",
      "20621012": "San Jose De Oriente - Betania"
    },
    "Manaure Balcón Del Cesar": {
      "20443000": "Manaure Balcon Del Cesar (Cabecera Municipal)"
    },
    "Pailitas": {
      "20517000": "Pailitas (Cabecera Municipal)",
      "20517001": "La Floresta",
      "20517002": "Rivera",
      "20517004": "Palestina",
      "20517006": "El Burro"
    },
    "Pelaya": {
      "20550000": "Pelaya (Cabecera Municipal)",
      "20550001": "Costilla",
      "20550012": "San Bernardo"
    },
    "Pueblo Bello": {
      "20570000": "Pueblo Bello (Cabecera Municipal)",
      "20570001": "La Caja",
      "20570002": "Las Minas De Iracal",
      "20570003": "Nuevo Colon",
      "20570004": "Nabusimake"
    },
    "Río De Oro": {
      "20614000": "Rio De Oro (Cabecera Municipal)",
      "20614001": "El Marquez",
      "20614004": "Los Angeles",
      "20614006": "Montecitos",
      "20614010": "Puerto Nuevo",
      "20614012": "Morrison"
    },
    "San Alberto": {
      "20710000": "San Alberto (Cabecera Municipal)",
      "20710001": "La Llana",
      "20710002": "La Palma",
      "20710005": "Libano",
      "20710008": "Puerto Carreño"
    },
    "San Diego": {
      "20750000": "San Diego (Cabecera Municipal)",
      "20750001": "Los Tupes",
      "20750002": "Media Luna",
      "20750006": "El Rincon",
      "20750007": "Las Pitillas",
      "20750009": "Los Brasiles",
      "20750011": "Tocaimo",
      "20750012": "Nuevas Flores"
    },
    "San Martín": {
      "20770000": "San Martin (Cabecera Municipal)",
      "20770003": "Minas",
      "20770004": "Puerto Oculto",
      "20770005": "San Jose De Las Americas",
      "20770006": "Candelia",
      "20770007": "Terraplen",
      "20770008": "La Curva",
      "20770009": "La Banca Torcoroma",
      "20770010": "Cuatro Bocas",
      "20770012": "Pita Limon"
    },
    "Tamalameque": {
      "20787000": "Tamalameque (Cabecera Municipal)",
      "20787001": "Palestina La Nueva",
      "20787002": "La Boca",
      "20787005": "Zapatosa",
      "20787007": "Antequera",
      "20787009": "Las Palmas",
      "20787011": "Las Brisas",
      "20787012": "Pasacorriendo",
      "20787013": "Pueblo Nuevo"
    },
    "Valledupar": {
      "20001000": "Valledupar (Cabecera Municipal)",
      "20001001": "Aguas Blancas",
      "20001002": "Atanquez",
      "20001003": "Badillo",
      "20001005": "Caracoli",
      "20001006": "Chemesquemena",
      "20001007": "Guatapuri",
      "20001009": "Guacoche",
      "20001010": "Guaymaral",
      "20001011": "La Mina",
      "20001012": "Los Venados",
      "20001013": "Mariangola",
      "20001014": "Patillal",
      "20001018": "Valencia De Jesus",
      "20001022": "Guacochito",
      "20001024": "Los Calabazos",
      "20001025": "Los Corazones",
      "20001026": "Los Haticos  I",
      "20001027": "La Mesa - Azucar Buena",
      "20001028": "Raices",
      "20001031": "Rio Seco",
      "20001032": "La Vega  Arriba",
      "20001034": "Villa Germania",
      "20001036": "El Jabo",
      "20001037": "El Alto De La Vuelta",
      "20001038": "Haticos Ii",
      "20001039": "El Perro",
      "20001040": "Las Mercedes",
      "20001041": "Sabana De Crespo",
      "20001042": "Las Casitas"
    }
  },
  "Chocó": {
    "Acandí": {
      "27006000": "Acandi (Cabecera Municipal)",
      "27006003": "Capurgana",
      "27006005": "La Caleta",
      "27006007": "San Francisco",
      "27006009": "Chigandi",
      "27006010": "Sapzurro",
      "27006016": "Peñalosa"
    },
    "Alto Baudó": {
      "27025000": "Alto Baudo (Cabecera Municipal)",
      "27025003": "Apartado",
      "27025004": "Chachajo",
      "27025006": "Naucas",
      "27025007": "San Francisco De Cugucho",
      "27025008": "Santa Catalina De Catru",
      "27025011": "Batatal",
      "27025013": "Chigorodo"
    },
    "Atrato": {
      "27050000": "Atrato (Cabecera Municipal)",
      "27050001": "Arenal",
      "27050002": "Doña Josefa",
      "27050003": "Samurindo",
      "27050005": "Motoldo",
      "27050006": "San Jose De Purre",
      "27050007": "San Martin De Purre",
      "27050008": "La Molana",
      "27050009": "Puente De Tanando",
      "27050010": "Puente De Paimado",
      "27050013": "La Toma"
    },
    "Bagadó": {
      "27073000": "Bagado (Cabecera Municipal)",
      "27073004": "Engrivado",
      "27073005": "La Sierra",
      "27073006": "Piedra Honda",
      "27073009": "El Salto",
      "27073010": "Playa Bonita",
      "27073011": "Vivicora",
      "27073012": "Pescadito"
    },
    "Bahía Solano": {
      "27075000": "Bahia Solano (Cabecera Municipal)",
      "27075002": "El Valle",
      "27075003": "Huaca",
      "27075004": "Huina",
      "27075006": "Mecana",
      "27075007": "Nabuga"
    },
    "Bajo Baudó": {
      "27077000": "Bajo Baudo (Cabecera Municipal)",
      "27077002": "Belen De Docampodo",
      "27077005": "Cuevita",
      "27077006": "Dotenedo",
      "27077007": "Hijua",
      "27077008": "Orpua",
      "27077009": "Pavasa",
      "27077011": "Piliza",
      "27077012": "Playita",
      "27077014": "Punta Purricha",
      "27077016": "Siviru",
      "27077019": "Virudo",
      "27077024": "Villa Maria",
      "27077026": "Guineal",
      "27077029": "Usaraga",
      "27077032": "Puerto Abadia"
    },
    "Bojayá": {
      "27099000": "Bojaya (Cabecera Municipal)",
      "27099001": "Alfonso Lopez",
      "27099002": "La Loma De Bojaya",
      "27099003": "Isla De Los Palacios",
      "27099004": "La Boba",
      "27099005": "Napipi",
      "27099006": "Boca De Opogado",
      "27099008": "Puerto Conto",
      "27099009": "San Jose",
      "27099011": "Veracruz",
      "27099012": "Pogue",
      "27099013": "Mesopotamia",
      "27099015": "El Tigre",
      "27099021": "Corazon De Jesus",
      "27099029": "Pichicora",
      "27099030": "Piedra Candela"
    },
    "Carmen Del Darién": {
      "27150002": "Domingodo",
      "27150003": "La Grande",
      "27150004": "Puerto Lleras",
      "27150006": "Vigia De Curbado",
      "27150007": "Villa Nueva De Montaño",
      "27150012": "Chicao",
      "27150014": "La Madre"
    },
    "Condoto": {
      "27205000": "Condoto (Cabecera Municipal)",
      "27205007": "Opogodo",
      "27205008": "Santa Ana",
      "27205014": "La Planta",
      "27205015": "Ilaria",
      "27205016": "Consuelo Andrapeda",
      "27205017": "El Paso"
    },
    "Cértegui": {
      "27160000": "Certegui (Cabecera Municipal)",
      "27160002": "Parecito"
    },
    "El Cantón Del San Pablo": {
      "27135000": "El Canton Del San Pablo (Cabecera Municipal)",
      "27135001": "Boca De Raspadura",
      "27135003": "Puerto Pervel",
      "27135004": "Tarido",
      "27135005": "Guapando",
      "27135007": "La Isla"
    },
    "El Carmen De Atrato": {
      "27245000": "El Carmen De Atrato (Cabecera Municipal)",
      "27245004": "La Mansa",
      "27245005": "El Porvenir",
      "27245006": "El Siete"
    },
    "El Litoral Del San Juan": {
      "27250001": "Copoma",
      "27250002": "Cucurrupi",
      "27250003": "Quebrada De Togoroma",
      "27250005": "Pichima",
      "27250006": "Palestina",
      "27250010": "El Coco",
      "27250012": "Quicharo",
      "27250017": "Las Peñitas",
      "27250018": "Los Perea",
      "27250019": "Munguido",
      "27250020": "Chappien",
      "27250021": "Burujon",
      "27250022": "Pangalita",
      "27250026": "Puerto Murillo",
      "27250029": "Pangala",
      "27250030": "San Jose",
      "27250031": "Taparal",
      "27250032": "Taparalito",
      "27250034": "Tordo",
      "27250039": "Union Valsalito"
    },
    "Istmina": {
      "27361000": "Istmina (Cabecera Municipal)",
      "27361004": "Basuru",
      "27361009": "Primavera",
      "27361029": "San Antonio",
      "27361032": "Suruco Santa Monica",
      "27361037": "Carmelita",
      "27361040": "Guiniguini",
      "27361041": "Juana Marcela",
      "27361042": "Paito",
      "27361043": "Playa Grande",
      "27361044": "Chigorodo (Puerto Salazar)"
    },
    "Juradó": {
      "27372000": "Jurado (Cabecera Municipal)",
      "27372004": "Punta Ardita",
      "27372007": "Punta Piña"
    },
    "Lloró": {
      "27413000": "Lloro (Cabecera Municipal)",
      "27413007": "Boraudo",
      "27413011": "Villa Claret"
    },
    "Medio Atrato": {
      "27425001": "Boca De Ame",
      "27425002": "Boca De Bebara",
      "27425003": "Campoalegre",
      "27425004": "El Llano De Bebara",
      "27425005": "El Llano De Bebarama",
      "27425006": "San Antonio Del Buey (Campo Santo)",
      "27425007": "San Jose De Buey",
      "27425008": "San Roque",
      "27425009": "Tangüi"
    },
    "Medio Baudó": {
      "27430002": "Arenal",
      "27430003": "Boca De Baudocito",
      "27430006": "Curundo La Banca",
      "27430009": "Pie De Pepe",
      "27430010": "Puerto Adan",
      "27430013": "San Miguel Baudocito"
    },
    "Medio San Juan": {
      "27450000": "Medio San Juan (Cabecera Municipal)",
      "27450001": "Bebedo",
      "27450007": "La Rancha",
      "27450008": "Noanama",
      "27450013": "Fujiado",
      "27450015": "La Union",
      "27450017": "Puerto Murillo"
    },
    "Nuquí": {
      "27495000": "Nuqui (Cabecera Municipal)",
      "27495001": "Arusi",
      "27495002": "Coqui",
      "27495003": "Jurubira",
      "27495004": "Pangui",
      "27495005": "Tribuga",
      "27495007": "Partado",
      "27495008": "Jovi",
      "27495010": "Termales"
    },
    "Nóvita": {
      "27491000": "Novita (Cabecera Municipal)",
      "27491001": "El Cajon",
      "27491002": "El Tigre",
      "27491006": "San Lorenzo",
      "27491007": "Sesego",
      "27491010": "El Tambito",
      "27491014": "Santa Rosa"
    },
    "Quibdó": {
      "27001000": "Quibdo (Cabecera Municipal)",
      "27001008": "Boca De Tanando",
      "27001011": "Calahorra",
      "27001013": "Campobonito",
      "27001015": "Guarando",
      "27001016": "Guayabal",
      "27001017": "La Troje",
      "27001018": "Las Mercedes",
      "27001020": "San Rafael De Negua",
      "27001024": "San Francisco De Icho",
      "27001029": "Tagachi",
      "27001032": "Tutunendo",
      "27001035": "Guadalupe",
      "27001038": "Sanceno",
      "27001044": "Boca De Naurita",
      "27001047": "El Fuerte",
      "27001048": "San Antonio De Icho",
      "27001052": "Boca De Nemota (Nemota)",
      "27001054": "Pacurita (Cabi)",
      "27001060": "Villa Del Rosario",
      "27001061": "Winando"
    },
    "Riosucio": {
      "27615000": "Riosucio (Cabecera Municipal)",
      "27615006": "La Honda",
      "27615022": "Peranchito",
      "27615027": "Puente America - Cacarica"
    },
    "Río Iró": {
      "27580000": "Rio Iro (Cabecera Municipal)",
      "27580004": "Encharcazon",
      "27580005": "San Jose De Viro Viro",
      "27580006": "Santa Barbara"
    },
    "Río Quito": {
      "27600001": "Boca De Apartado",
      "27600003": "San Isidro",
      "27600004": "Villa Conto",
      "27600006": "Chiguarando Alto",
      "27600007": "Chiviguido",
      "27600010": "La Soledad",
      "27600011": "Loma De Los Gamboa"
    },
    "San José Del Palmar": {
      "27660000": "San Jose Del Palmar (Cabecera Municipal)",
      "27660003": "San Pedro Ingara",
      "27660006": "La Italia"
    },
    "Sipí": {
      "27745000": "Sipi (Cabecera Municipal)",
      "27745001": "Cañaveral",
      "27745003": "San Agustin",
      "27745009": "Tanando",
      "27745010": "Buenas Brisas",
      "27745012": "Loma De Chupey",
      "27745013": "Marqueza",
      "27745014": "Santa Rosa",
      "27745015": "Teatino"
    },
    "Tadó": {
      "27787000": "Tado (Cabecera Municipal)",
      "27787002": "Carmelo",
      "27787004": "Tapon",
      "27787005": "Guarato",
      "27787009": "Mumbu",
      "27787010": "Playa De Oro",
      "27787015": "Corcobado",
      "27787016": "Manungara"
    },
    "Unguía": {
      "27800000": "Unguia (Cabecera Municipal)",
      "27800001": "Balboa",
      "27800002": "Gilgal",
      "27800003": "Santa Maria Del Darien",
      "27800004": "Tanela",
      "27800005": "Titumate",
      "27800008": "Marriaga",
      "27800011": "El Puerto"
    },
    "Unión Panamericana": {
      "27810001": "El Plan De Raspadura",
      "27810002": "La Ye",
      "27810003": "San Rafael Del Dos"
    }
  },
  "Cundinamarca": {
    "Agua De Dios": {
      "25001000": "Agua De Dios (Cabecera Municipal)"
    },
    "Albán": {
      "25019000": "Alban (Cabecera Municipal)",
      "25019001": "Chimbe (Danubio)",
      "25019002": "Pantanillo",
      "25019003": "La Maria"
    },
    "Anapoima": {
      "25035000": "Anapoima (Cabecera Municipal)",
      "25035001": "La Paz",
      "25035002": "San Antonio De Anapoima",
      "25035003": "Patio Bonito"
    },
    "Anolaima": {
      "25040000": "Anolaima (Cabecera Municipal)",
      "25040002": "La Florida",
      "25040003": "Reventones",
      "25040006": "Corralejas"
    },
    "Apulo": {
      "25599000": "Apulo (Cabecera Municipal)"
    },
    "Arbeláez": {
      "25053000": "Arbelaez (Cabecera Municipal)",
      "25053003": "Tisince"
    },
    "Beltrán": {
      "25086000": "Beltran (Cabecera Municipal)",
      "25086001": "Paquilo",
      "25086002": "La Popa",
      "25086003": "Puerto Gramalotal"
    },
    "Bituima": {
      "25095000": "Bituima (Cabecera Municipal)",
      "25095002": "Boqueron De Ilo",
      "25095003": "La Sierra"
    },
    "Bojacá": {
      "25099000": "Bojaca (Cabecera Municipal)",
      "25099002": "Santa Barbara"
    },
    "Cabrera": {
      "25120000": "Cabrera (Cabecera Municipal)"
    },
    "Cachipay": {
      "25123000": "Cachipay (Cabecera Municipal)"
    },
    "Cajicá": {
      "25126000": "Cajica (Cabecera Municipal)",
      "25126003": "Rincon Santo",
      "25126004": "Rio Grande",
      "25126006": "Los Sereneos",
      "25126007": "Los Pasos",
      "25126008": "La Florida",
      "25126009": "Calahorra",
      "25126010": "Aguanica",
      "25126011": "La Palma",
      "25126013": "La Esperanza",
      "25126014": "Camino Los Vargas",
      "25126015": "Los Leon"
    },
    "Caparrapí": {
      "25148000": "Caparrapi (Cabecera Municipal)",
      "25148001": "Cambras",
      "25148003": "El Dindal",
      "25148005": "San Pedro",
      "25148006": "Tati",
      "25148007": "Cordoba",
      "25148009": "San Carlos",
      "25148010": "Cambulo",
      "25148012": "San Pablo",
      "25148016": "San Ramon Alto"
    },
    "Carmen De Carupa": {
      "25154000": "Carmen De Carupa (Cabecera Municipal)"
    },
    "Chaguaní": {
      "25168000": "Chaguani (Cabecera Municipal)"
    },
    "Chipaque": {
      "25178000": "Chipaque (Cabecera Municipal)",
      "25178013": "Abasticos"
    },
    "Choachí": {
      "25181000": "Choachi (Cabecera Municipal)",
      "25181003": "Potrero Grande"
    },
    "Chocontá": {
      "25183000": "Choconta (Cabecera Municipal)"
    },
    "Chía": {
      "25175000": "Chia (Cabecera Municipal)",
      "25175002": "Sindamanoy I",
      "25175003": "Cuatro Esquinas",
      "25175005": "Cerca De Piedra"
    },
    "Cogua": {
      "25200000": "Cogua (Cabecera Municipal)",
      "25200002": "Rodamontal",
      "25200004": "El Mortiño",
      "25200005": "La Plazuela",
      "25200006": "La Chapa",
      "25200008": "El Cascajal",
      "25200009": "El Durazno",
      "25200010": "El Olivo",
      "25200012": "San Antonio",
      "25200013": "El Atico - Sector Alvarez",
      "25200014": "Rincon Santo - Sector Zamora"
    },
    "Cota": {
      "25214000": "Cota (Cabecera Municipal)"
    },
    "Cucunubá": {
      "25224000": "Cucunuba (Cabecera Municipal)"
    },
    "Cáqueza": {
      "25151000": "Caqueza (Cabecera Municipal)"
    },
    "El Colegio": {
      "25245000": "El Colegio (Cabecera Municipal)",
      "25245001": "El Triunfo",
      "25245002": "La Victoria",
      "25245003": "Pradilla"
    },
    "El Peñón": {
      "25258000": "El Peñon (Cabecera Municipal)",
      "25258001": "Guayabal De Toledo",
      "25258002": "Talauta"
    },
    "El Rosal": {
      "25260000": "El Rosal (Cabecera Municipal)"
    },
    "Facatativá": {
      "25269000": "Facatativa (Cabecera Municipal)",
      "25269001": "San Rafael  Bajo",
      "25269007": "Los Andes",
      "25269008": "La Yerbabuena",
      "25269009": "Alto De Cordoba",
      "25269012": "Los Manzanos",
      "25269013": "Paso Ancho",
      "25269014": "Pueblo Viejo",
      "25269017": "Santa Martha - La Esperanza",
      "25269019": "Sagrado Corazon",
      "25269020": "Villa Myriam",
      "25269021": "Los Robles",
      "25269022": "San Isidro",
      "25269023": "Tierra Grata Alta",
      "25269024": "Tierra Grata (El Cruce)"
    },
    "Fosca": {
      "25281000": "Fosca (Cabecera Municipal)"
    },
    "Funza": {
      "25286000": "Funza (Cabecera Municipal)"
    },
    "Fusagasugá": {
      "25290000": "Fusagasuga (Cabecera Municipal)",
      "25290001": "La Aguadita",
      "25290012": "El Triunfo Boqueron",
      "25290015": "Rio Blanco - Los Puentes",
      "25290016": "Chinauta"
    },
    "Fómeque": {
      "25279000": "Fomeque (Cabecera Municipal)",
      "25279001": "La Union"
    },
    "Fúquene": {
      "25288000": "Fuquene (Cabecera Municipal)",
      "25288001": "Capellania",
      "25288003": "Nuevo Fuquene"
    },
    "Gachalá": {
      "25293000": "Gachala (Cabecera Municipal)",
      "25293003": "Santa Rita Del Rio Negro",
      "25293006": "Palomas"
    },
    "Gachancipá": {
      "25295000": "Gachancipa (Cabecera Municipal)",
      "25295005": "El Roble Sur"
    },
    "Gachetá": {
      "25297000": "Gacheta (Cabecera Municipal)"
    },
    "Gama": {
      "25299000": "Gama (Cabecera Municipal)",
      "25299001": "San Roque"
    },
    "Girardot": {
      "25307000": "Girardot (Cabecera Municipal)",
      "25307004": "Berlin",
      "25307005": "Barzalosa",
      "25307006": "Piamonte"
    },
    "Granada": {
      "25312000": "Granada (Cabecera Municipal)",
      "25312013": "San Raimundo"
    },
    "Guachetá": {
      "25317000": "Guacheta (Cabecera Municipal)"
    },
    "Guaduas": {
      "25320000": "Guaduas (Cabecera Municipal)",
      "25320001": "Guaduero",
      "25320002": "La Paz De Calamoima",
      "25320008": "Alto Del Trigo",
      "25320009": "La Cabaña"
    },
    "Guasca": {
      "25322000": "Guasca (Cabecera Municipal)",
      "25322002": "La Cabrerita"
    },
    "Guataquí": {
      "25324000": "Guataqui (Cabecera Municipal)",
      "25324001": "El Porvenir",
      "25324002": "Las Islas"
    },
    "Guatavita": {
      "25326000": "Guatavita (Cabecera Municipal)"
    },
    "Guayabal De Síquima": {
      "25328000": "Guayabal De Siquima (Cabecera Municipal)",
      "25328001": "Alto Del Trigo"
    },
    "Guayabetal": {
      "25335000": "Guayabetal (Cabecera Municipal)",
      "25335002": "Monterredondo",
      "25335003": "Las Mesas",
      "25335005": "San Antonio"
    },
    "Gutiérrez": {
      "25339000": "Gutierrez (Cabecera Municipal)",
      "25339001": "Pascote",
      "25339002": "San Antonio"
    },
    "Jerusalén": {
      "25368000": "Jerusalen (Cabecera Municipal)"
    },
    "Junín": {
      "25372000": "Junin (Cabecera Municipal)",
      "25372001": "Claraval",
      "25372002": "Chuscales",
      "25372004": "Sueva",
      "25372006": "Puente Lisio",
      "25372007": "Ramal"
    },
    "La Calera": {
      "25377000": "La Calera (Cabecera Municipal)",
      "25377002": "Mundonuevo",
      "25377003": "El Salitre",
      "25377008": "Treinta Y Seis"
    },
    "La Mesa": {
      "25386000": "La Mesa (Cabecera Municipal)",
      "25386001": "La Esperanza",
      "25386002": "San Javier",
      "25386003": "San Joaquin"
    },
    "La Palma": {
      "25394000": "La Palma (Cabecera Municipal)"
    },
    "La Peña": {
      "25398000": "La Peña (Cabecera Municipal)"
    },
    "La Vega": {
      "25402000": "La Vega (Cabecera Municipal)",
      "25402002": "El Vino"
    },
    "Lenguazaque": {
      "25407000": "Lenguazaque (Cabecera Municipal)"
    },
    "Machetá": {
      "25426000": "Macheta (Cabecera Municipal)"
    },
    "Madrid": {
      "25430000": "Madrid (Cabecera Municipal)",
      "25430003": "El Corzo",
      "25430004": "Puente De Piedra",
      "25430005": "Chauta",
      "25430006": "Moyano"
    },
    "Manta": {
      "25436000": "Manta (Cabecera Municipal)"
    },
    "Medina": {
      "25438000": "Medina (Cabecera Municipal)",
      "25438003": "San Pedro De Guajaray",
      "25438004": "Santa Teresita",
      "25438005": "Mesa De Los Reyes",
      "25438006": "Los Alpes",
      "25438010": "La Esmeralda",
      "25438011": "Gazaduje"
    },
    "Mosquera": {
      "25473000": "Mosquera (Cabecera Municipal)",
      "25473004": "Los Puentes"
    },
    "Nariño": {
      "25483000": "Nariño (Cabecera Municipal)"
    },
    "Nemocón": {
      "25486000": "Nemocon (Cabecera Municipal)",
      "25486001": "Patio Bonito",
      "25486002": "El Oratorio",
      "25486003": "La Puerta",
      "25486005": "Camacho"
    },
    "Nilo": {
      "25488000": "Nilo (Cabecera Municipal)",
      "25488001": "La Esmeralda",
      "25488002": "Pueblo Nuevo"
    },
    "Nimaima": {
      "25489000": "Nimaima (Cabecera Municipal)",
      "25489001": "Tobia"
    },
    "Nocaima": {
      "25491000": "Nocaima (Cabecera Municipal)",
      "25491001": "Tobia Chica"
    },
    "Pacho": {
      "25513000": "Pacho (Cabecera Municipal)",
      "25513001": "Pasuncha"
    },
    "Paime": {
      "25518000": "Paime (Cabecera Municipal)",
      "25518001": "Cuatro Caminos",
      "25518002": "Tudela",
      "25518004": "Venecia"
    },
    "Pandi": {
      "25524000": "Pandi (Cabecera Municipal)"
    },
    "Paratebueno": {
      "25530000": "Paratebueno (Cabecera Municipal)",
      "25530001": "Maya",
      "25530002": "Santa Cecilia",
      "25530003": "El Engaño",
      "25530006": "El Japon"
    },
    "Pasca": {
      "25535000": "Pasca (Cabecera Municipal)",
      "25535002": "Guchipas"
    },
    "Puerto Salgar": {
      "25572000": "Puerto Salgar (Cabecera Municipal)",
      "25572001": "Colorados",
      "25572003": "Puerto Libre",
      "25572005": "Morro Colorado"
    },
    "Pulí": {
      "25580000": "Puli (Cabecera Municipal)",
      "25580002": "Palestina"
    },
    "Quebradanegra": {
      "25592000": "Quebradanegra (Cabecera Municipal)",
      "25592001": "La Magdalena",
      "25592003": "Tobia - La Milagrosa"
    },
    "Quetame": {
      "25594000": "Quetame (Cabecera Municipal)",
      "25594002": "Puente Quetame"
    },
    "Quipile": {
      "25596000": "Quipile (Cabecera Municipal)",
      "25596001": "La Sierra",
      "25596002": "La Virgen",
      "25596003": "Santa Marta",
      "25596004": "La Botica"
    },
    "Ricaurte": {
      "25612000": "Ricaurte (Cabecera Municipal)",
      "25612001": "Manuel Sur",
      "25612002": "El Paso",
      "25612003": "El Portal",
      "25612004": "Las Varas",
      "25612006": "San Marcos Poblado",
      "25612007": "San Martin"
    },
    "San Antonio Del Tequendama": {
      "25645000": "San Antonio Del Tequendama (Cabecera Municipal)",
      "25645001": "Santandercito",
      "25645011": "Pueblo Nuevo",
      "25645016": "Bellavista",
      "25645017": "Pradilla",
      "25645018": "Los Naranjos",
      "25645019": "Villa Pradilla",
      "25645020": "Villa Shyn (Casas Moviles)"
    },
    "San Bernardo": {
      "25649000": "San Bernardo (Cabecera Municipal)",
      "25649003": "Portones"
    },
    "San Cayetano": {
      "25653000": "San Cayetano (Cabecera Municipal)",
      "25653001": "Camancha",
      "25653002": "Cuibuco",
      "25653003": "Las Mercedes",
      "25653005": "Albergue"
    },
    "San Francisco": {
      "25658000": "San Francisco (Cabecera Municipal)"
    },
    "San Juan De Rioseco": {
      "25662000": "San Juan De Rioseco (Cabecera Municipal)",
      "25662001": "Cambao",
      "25662002": "San Nicolas"
    },
    "Sasaima": {
      "25718000": "Sasaima (Cabecera Municipal)",
      "25718001": "Santa Ines",
      "25718002": "Santa Cruz"
    },
    "Sesquilé": {
      "25736000": "Sesquile (Cabecera Municipal)",
      "25736002": "La Playa",
      "25736003": "Boitiva San Roque",
      "25736004": "Siatoya"
    },
    "Sibaté": {
      "25740000": "Sibate (Cabecera Municipal)",
      "25740004": "San Benito Centro",
      "25740005": "Chacua Centro",
      "25740007": "Perico Sector La Honda",
      "25740008": "Perico Sector La Macarena",
      "25740010": "San Fortunato Sector Los Zorros",
      "25740011": "San Miguel"
    },
    "Silvania": {
      "25743000": "Silvania (Cabecera Municipal)",
      "25743002": "Azafranal",
      "25743005": "Subia",
      "25743006": "Agua Bonita"
    },
    "Simijaca": {
      "25745000": "Simijaca (Cabecera Municipal)"
    },
    "Soacha": {
      "25754000": "Soacha (Cabecera Municipal)",
      "25754001": "Charquito",
      "25754011": "Chacua Cabrera"
    },
    "Sopó": {
      "25758000": "Sopo (Cabecera Municipal)",
      "25758008": "Hatogrande",
      "25758009": "Gratamira",
      "25758010": "Mercenario",
      "25758011": "La Diana",
      "25758012": "Pueblo Viejo Sector Niño"
    },
    "Subachoque": {
      "25769000": "Subachoque (Cabecera Municipal)",
      "25769002": "La Pradera",
      "25769003": "Galdamez"
    },
    "Suesca": {
      "25772000": "Suesca (Cabecera Municipal)",
      "25772001": "Hato Grande",
      "25772002": "Santa Rosita",
      "25772004": "Cacicazgo"
    },
    "Supatá": {
      "25777000": "Supata (Cabecera Municipal)",
      "25777001": "La Magola"
    },
    "Susa": {
      "25779000": "Susa (Cabecera Municipal)"
    },
    "Sutatausa": {
      "25781000": "Sutatausa (Cabecera Municipal)",
      "25781002": "Las Peñas"
    },
    "Tabio": {
      "25785000": "Tabio (Cabecera Municipal)",
      "25785001": "Carron",
      "25785003": "Parcelacion Termales",
      "25785005": "Chicu"
    },
    "Tausa": {
      "25793000": "Tausa (Cabecera Municipal)",
      "25793003": "Boqueron",
      "25793005": "Divino Niño"
    },
    "Tena": {
      "25797000": "Tena (Cabecera Municipal)",
      "25797001": "La Gran Via"
    },
    "Tenjo": {
      "25799000": "Tenjo (Cabecera Municipal)",
      "25799001": "La Punta",
      "25799007": "Pan De Azucar"
    },
    "Tibacuy": {
      "25805000": "Tibacuy (Cabecera Municipal)",
      "25805001": "Bateas",
      "25805002": "Cumaca"
    },
    "Tibirita": {
      "25807000": "Tibirita (Cabecera Municipal)"
    },
    "Tocaima": {
      "25815000": "Tocaima (Cabecera Municipal)",
      "25815001": "Pubenza",
      "25815003": "La Salada",
      "25815007": "La Colorada"
    },
    "Tocancipá": {
      "25817000": "Tocancipa (Cabecera Municipal)",
      "25817001": "Chauta",
      "25817002": "Dulcinea",
      "25817003": "Pelpak",
      "25817004": "San Javier",
      "25817005": "Tolima - Milenion",
      "25817006": "La Fuente",
      "25817007": "Cetina",
      "25817008": "Antonia Santos",
      "25817012": "Chicala"
    },
    "Topaipí": {
      "25823000": "Topaipi (Cabecera Municipal)"
    },
    "Ubalá": {
      "25839000": "Ubala (Cabecera Municipal)",
      "25839002": "Laguna Azul",
      "25839003": "Mambita",
      "25839004": "San Pedro De Jagua",
      "25839005": "Santa Rosa",
      "25839006": "La Playa"
    },
    "Ubaque": {
      "25841000": "Ubaque (Cabecera Municipal)"
    },
    "Une": {
      "25845000": "Une (Cabecera Municipal)"
    },
    "Venecia": {
      "25506000": "Venecia (Cabecera Municipal)",
      "25506001": "Aposentos",
      "25506005": "El Trebol"
    },
    "Vergara": {
      "25862000": "Vergara (Cabecera Municipal)",
      "25862002": "Guacamayas",
      "25862004": "Villa Olarte",
      "25862005": "Cerinza",
      "25862006": "Corcega"
    },
    "Vianí": {
      "25867000": "Viani (Cabecera Municipal)",
      "25867001": "Alto El Rosario"
    },
    "Villa De San Diego De Ubaté": {
      "25843000": "Villa De San Diego De Ubate (Cabecera Municipal)",
      "25843001": "Guatancuy",
      "25843005": "Volcan Bajo",
      "25843007": "San Luis",
      "25843009": "Palogordo"
    },
    "Villagómez": {
      "25871000": "Villagomez (Cabecera Municipal)"
    },
    "Villapinzón": {
      "25873000": "Villapinzon (Cabecera Municipal)"
    },
    "Villeta": {
      "25875000": "Villeta (Cabecera Municipal)",
      "25875001": "Bagazal",
      "25875004": "El Puente"
    },
    "Viotá": {
      "25878000": "Viota (Cabecera Municipal)",
      "25878002": "San Gabriel",
      "25878003": "El Piñal",
      "25878004": "Liberia"
    },
    "Yacopí": {
      "25885000": "Yacopi (Cabecera Municipal)",
      "25885002": "Guadualito",
      "25885004": "Ibama",
      "25885006": "Llano Mateo",
      "25885008": "Teran",
      "25885009": "Aposentos",
      "25885018": "Patevaca",
      "25885021": "El Castillo"
    },
    "Zipacón": {
      "25898000": "Zipacon (Cabecera Municipal)",
      "25898001": "El Ocaso",
      "25898004": "La Capilla",
      "25898005": "La Estacion",
      "25898006": "Cartagena",
      "25898007": "La Cabaña"
    },
    "Zipaquirá": {
      "25899000": "Zipaquira (Cabecera Municipal)",
      "25899001": "La Granja",
      "25899005": "Rio Frio",
      "25899007": "San Jorge Palo Bajo",
      "25899008": "San Jorge Palo Alto",
      "25899009": "Alto Del Aguila",
      "25899010": "Aposentos Altos",
      "25899014": "El Empalizado",
      "25899017": "Loteo La Paz - Bomba Terpel - Loteo Susagua",
      "25899025": "San Miguel",
      "25899028": "La Mariela",
      "25899029": "El Codito",
      "25899030": "El Kiosko La Granja",
      "25899031": "La Escuela"
    },
    "Útica": {
      "25851000": "Utica (Cabecera Municipal)"
    }
  },
  "Córdoba": {
    "Ayapel": {
      "23068000": "Ayapel (Cabecera Municipal)",
      "23068001": "Alfonso Lopez",
      "23068003": "Cecilia",
      "23068004": "El Cedro",
      "23068006": "Nariño",
      "23068007": "Palotal",
      "23068009": "Sincelejito",
      "23068012": "Marralu",
      "23068014": "Pueblo Nuevo - Popales",
      "23068015": "Las Delicias"
    },
    "Buenavista": {
      "23079000": "Buenavista (Cabecera Municipal)",
      "23079001": "Tierra Santa",
      "23079002": "Villa Fatima",
      "23079003": "Belen",
      "23079004": "Nueva Estacion",
      "23079005": "Puerto Cordoba",
      "23079010": "Mejor Esquina",
      "23079012": "El Viajano",
      "23079014": "Veracruz",
      "23079015": "Santa Clara",
      "23079016": "Santa Fe Del Arcial 1",
      "23079017": "Coyonpo",
      "23079019": "Las Marias"
    },
    "Canalete": {
      "23090000": "Canalete (Cabecera Municipal)",
      "23090001": "El Limon",
      "23090002": "Popayan",
      "23090007": "Cadillo",
      "23090013": "El Guineo",
      "23090020": "Tierradentro",
      "23090021": "Quebrada De Urango",
      "23090022": "Buenos Aires - Las Pavas",
      "23090023": "El Tomate"
    },
    "Cereté": {
      "23162000": "Cerete (Cabecera Municipal)",
      "23162001": "Martinez",
      "23162002": "Mateo Gomez",
      "23162003": "Rabolargo",
      "23162004": "Severa",
      "23162005": "Cuero Curtido",
      "23162006": "Retiro De Los Indios",
      "23162012": "San Antonio",
      "23162018": "El Quemado",
      "23162025": "Buenavista Del Retiro",
      "23162026": "Buenavista El Quemado",
      "23162027": "El Carmen"
    },
    "Chimá": {
      "23168000": "Chima (Cabecera Municipal)",
      "23168001": "Arache",
      "23168002": "Campo Bello",
      "23168003": "Carolina",
      "23168004": "Corozalito",
      "23168005": "Punta Verde",
      "23168006": "Sitio Viejo",
      "23168008": "Sabanacosta"
    },
    "Chinú": {
      "23182000": "Chinu (Cabecera Municipal)",
      "23182002": "Cacaotal",
      "23182003": "Carbonero",
      "23182005": "Heredia",
      "23182006": "Los Angeles",
      "23182007": "Nuevo Oriente",
      "23182008": "San Mateo",
      "23182009": "San Rafael",
      "23182011": "Santa Fe",
      "23182012": "Santa Rosa",
      "23182013": "Flechas Sevilla",
      "23182014": "Tierra Grata",
      "23182015": "Flechas Sabanas",
      "23182016": "Garbado",
      "23182017": "La Panama",
      "23182018": "La Pilona",
      "23182019": "Retiro De Los Perez",
      "23182020": "Andalucia",
      "23182021": "Los Algarrobos",
      "23182022": "El Tigre",
      "23182024": "Villa Fatima",
      "23182027": "El Deseo",
      "23182031": "Paraiso",
      "23182033": "Las Jarabas",
      "23182035": "Pajonal",
      "23182036": "Pisa Bonito",
      "23182041": "Lomas De Piedra",
      "23182043": "Bajo De Piedra"
    },
    "Ciénaga De Oro": {
      "23189000": "Cienaga De Oro (Cabecera Municipal)",
      "23189001": "Berastegui",
      "23189003": "Laguneta",
      "23189004": "Los Mimbres",
      "23189005": "Punta De Yañez",
      "23189007": "Puerto De La Cruz",
      "23189008": "Malagana",
      "23189016": "El Salado",
      "23189018": "Las Piedras",
      "23189019": "Pijiguayal",
      "23189021": "Santiago Pobre",
      "23189023": "San Antonio Del Tachira",
      "23189024": "Rosa Vieja",
      "23189025": "Las Palmitas",
      "23189028": "Las Balsas",
      "23189029": "Egipto",
      "23189030": "Barro Prieto",
      "23189034": "La Draga"
    },
    "Cotorra": {
      "23300000": "Cotorra (Cabecera Municipal)",
      "23300006": "Paso De Las Flores",
      "23300010": "El Binde",
      "23300016": "Trementino",
      "23300021": "San Jose"
    },
    "La Apartada": {
      "23350000": "La Apartada (Cabecera Municipal)",
      "23350003": "La Balsa",
      "23350007": "Sitio Nuevo",
      "23350015": "Campo Alegre",
      "23350017": "Puerto Cordoba"
    },
    "Lorica": {
      "23417000": "Lorica (Cabecera Municipal)",
      "23417002": "El Carito",
      "23417003": "La Doctrina",
      "23417004": "Las Flores",
      "23417006": "Los Monos",
      "23417007": "Nariño",
      "23417008": "Palo De Agua",
      "23417009": "San Sebastian",
      "23417010": "Tierralta",
      "23417012": "El Lazo",
      "23417014": "Campo Alegre",
      "23417017": "El Campano De Los Indios",
      "23417018": "Cotoca Arriba",
      "23417019": "El Rodeo",
      "23417021": "Remolino",
      "23417022": "Villa Concepcion",
      "23417023": "Mata De Caña",
      "23417024": "Castilleral",
      "23417025": "Cotoca Abajo",
      "23417027": "San Nicolas De Bari",
      "23417029": "La Subida",
      "23417030": "El Playon",
      "23417031": "La Peinada",
      "23417034": "Santa Lucia",
      "23417036": "La Palma",
      "23417037": "Los Morales",
      "23417039": "El Guanabano"
    },
    "Los Córdobas": {
      "23419000": "Los Cordobas (Cabecera Municipal)",
      "23419002": "El Ebano",
      "23419004": "Puerto Rey",
      "23419005": "Santa Rosa La Caña",
      "23419010": "Buenavista",
      "23419011": "La Salada",
      "23419012": "Morindo Santana",
      "23419013": "Jalisco",
      "23419019": "El Guaimaro",
      "23419020": "La Aponderancia",
      "23419025": "Los Esquimales",
      "23419026": "Minuto De Dios",
      "23419030": "Nuevo Nariño"
    },
    "Momil": {
      "23464000": "Momil (Cabecera Municipal)",
      "23464001": "Sabaneta",
      "23464002": "Sacana",
      "23464003": "Trementino",
      "23464005": "Pueblecito",
      "23464006": "Guaymaral",
      "23464007": "Betulia"
    },
    "Montelíbano": {
      "23466000": "Montelibano (Cabecera Municipal)",
      "23466028": "El Palmar",
      "23466033": "Puerto Nuevo"
    },
    "Montería": {
      "23001000": "Monteria (Cabecera Municipal)",
      "23001001": "Buenos Aires",
      "23001002": "Palotal",
      "23001003": "El Cerrito",
      "23001004": "El Sabanal",
      "23001005": "Guasimal",
      "23001006": "Jaraquiel",
      "23001007": "La Manta",
      "23001008": "Las Palomas",
      "23001009": "Leticia - El Tronco",
      "23001010": "Loma Verde",
      "23001012": "Nuevo Paraiso",
      "23001013": "Nueva Lucia",
      "23001014": "Patio Bonito",
      "23001015": "San Isidro",
      "23001016": "Pueblo Buho",
      "23001017": "San Anterito",
      "23001018": "Santa Clara",
      "23001019": "Santa Isabel",
      "23001020": "Santa Lucia",
      "23001021": "Tres Palmas",
      "23001022": "Tres Piedras",
      "23001028": "El Barsal",
      "23001029": "Nueva Esperanza",
      "23001031": "Martinica",
      "23001032": "Guateque",
      "23001033": "Tenerife",
      "23001034": "La Victoria",
      "23001035": "Morindo Central",
      "23001036": "Boca De La Ceiba",
      "23001037": "Broquelito",
      "23001038": "El Limon",
      "23001039": "El Quince",
      "23001040": "El Vidrial",
      "23001041": "Ensenada De La Hamaca",
      "23001042": "Galilea",
      "23001043": "La Esperanza",
      "23001044": "La Florida",
      "23001045": "Maquencal",
      "23001046": "Maracayo",
      "23001047": "Matamoros",
      "23001048": "Mochilas",
      "23001049": "Nuevos Horizontes",
      "23001050": "Palmito Picao",
      "23001051": "Pereira",
      "23001052": "Villavicencio",
      "23001053": "Ya La Lleva",
      "23001054": "Agua Vivas",
      "23001064": "La Poza"
    },
    "Moñitos": {
      "23500000": "Moñitos (Cabecera Municipal)",
      "23500001": "Rio Cedro",
      "23500002": "Santander De La Cruz",
      "23500006": "Broqueles",
      "23500010": "La Rada",
      "23500011": "Las Mujeres",
      "23500023": "Perpetuo Socorro",
      "23500024": "Pueblito"
    },
    "Planeta Rica": {
      "23555000": "Planeta Rica (Cabecera Municipal)",
      "23555001": "Arenoso",
      "23555002": "Campo Bello",
      "23555003": "Carolina",
      "23555004": "Santana (Centro Alegre)",
      "23555005": "El Almendro",
      "23555006": "Marañonal",
      "23555007": "Plaza Bonita",
      "23555008": "Providencia",
      "23555010": "Medio Rancho",
      "23555011": "Pamplona",
      "23555015": "Las Pelonas",
      "23555019": "Nuevo Paraiso",
      "23555020": "Santa Rosa",
      "23555022": "Planetica"
    },
    "Pueblo Nuevo": {
      "23570000": "Pueblo Nuevo (Cabecera Municipal)",
      "23570002": "San Jose De Cintura",
      "23570003": "Corcovao",
      "23570004": "El Varal",
      "23570005": "El Poblado",
      "23570006": "La Granjita",
      "23570007": "Los Limones",
      "23570008": "Puerto Santo",
      "23570009": "La Magdalena",
      "23570011": "Palmira",
      "23570013": "Neiva",
      "23570014": "Arroyo De Arenas",
      "23570020": "El Campano",
      "23570021": "Pueblo Regao",
      "23570024": "Nueva Esperanza",
      "23570026": "Cafe Pisao",
      "23570028": "Loma De Piedra"
    },
    "Puerto Escondido": {
      "23574000": "Puerto Escondido (Cabecera Municipal)",
      "23574001": "Cristo Rey",
      "23574002": "El Pantano",
      "23574003": "San Jose De Canalete",
      "23574004": "Villa Ester",
      "23574005": "Arizal",
      "23574006": "San Luis",
      "23574009": "Las Mujeres",
      "23574011": "El Silencio",
      "23574012": "San Miguel"
    },
    "Puerto Libertador": {
      "23580000": "Puerto Libertador (Cabecera Municipal)",
      "23580001": "La Rica",
      "23580002": "Pica Pica Viejo",
      "23580003": "Villanueva",
      "23580004": "Juan Jose",
      "23580006": "Buenos Aires",
      "23580009": "Santa Fe De Las Claras",
      "23580010": "San Juan",
      "23580011": "Puerto Belen",
      "23580012": "El Brillante"
    },
    "Purísima De La Concepción": {
      "23586000": "Purisima De La Concepcion (Cabecera Municipal)",
      "23586001": "Aserradero",
      "23586002": "El Hueso",
      "23586003": "Los Corrales",
      "23586004": "San Pedro De Arroyo Hondo"
    },
    "Sahagún": {
      "23660000": "Sahagun (Cabecera Municipal)",
      "23660001": "Arenas Del Norte",
      "23660002": "Bajo Grande",
      "23660003": "Catalina",
      "23660004": "Colomboy",
      "23660005": "El Crucero",
      "23660006": "El Viajano",
      "23660007": "Llanadas",
      "23660008": "La Ye",
      "23660009": "Morrocoy",
      "23660010": "Rodania",
      "23660011": "Salitral",
      "23660012": "San Antonio",
      "23660013": "Santiago Abajo",
      "23660014": "Sabaneta",
      "23660015": "Aguas Vivas",
      "23660016": "Las Bocas",
      "23660017": "Pisa Flores",
      "23660020": "El Roble",
      "23660022": "El Olivo",
      "23660029": "Trementino",
      "23660030": "Guaimaro",
      "23660031": "La Balsa",
      "23660032": "Las Aguaditas",
      "23660037": "Dividivi",
      "23660040": "Salguerito",
      "23660047": "Kilometro 32",
      "23660048": "Kilometro 34",
      "23660061": "San Francisco"
    },
    "San Andrés De Sotavento": {
      "23670000": "San Andres De Sotavento (Cabecera Municipal)",
      "23670002": "Calle Larga",
      "23670003": "El Banco",
      "23670005": "Los Carretos",
      "23670009": "Pueblecito Sur",
      "23670013": "Plaza Bonita",
      "23670014": "Las Casitas",
      "23670015": "Los Castillos",
      "23670021": "El Contento",
      "23670023": "Jejen",
      "23670025": "Cruz De Guayabo",
      "23670026": "El Hoyal"
    },
    "San Antero": {
      "23672000": "San Antero (Cabecera Municipal)",
      "23672003": "Nuevo Agrado",
      "23672004": "Santa Rosa Del Balsamo",
      "23672005": "Tijeretas",
      "23672006": "Bijaito"
    },
    "San Bernardo Del Viento": {
      "23675000": "San Bernardo Del Viento (Cabecera Municipal)",
      "23675001": "Jose Manuel De Altamira",
      "23675003": "Paso Nuevo",
      "23675005": "Playas Del Viento",
      "23675007": "Trementino",
      "23675009": "San Blas De Junin",
      "23675012": "Chiqui",
      "23675013": "Pajonal",
      "23675014": "San Jose De Las Cañas",
      "23675015": "Miramar",
      "23675018": "Camino Real",
      "23675019": "El Castillo",
      "23675021": "Tinajones"
    },
    "San Carlos": {
      "23678000": "San Carlos (Cabecera Municipal)",
      "23678001": "El Campano",
      "23678002": "Carrizal",
      "23678003": "Guacharacal",
      "23678004": "Santa Rosa",
      "23678005": "Remedio Pobre",
      "23678006": "Cabuya",
      "23678008": "Callemar",
      "23678009": "Cienaguita",
      "23678010": "El Hato",
      "23678011": "San Miguel",
      "23678012": "El Charco"
    },
    "San Pelayo": {
      "23686000": "San Pelayo (Cabecera Municipal)",
      "23686001": "Buenos Aires",
      "23686002": "Carrillo",
      "23686003": "La Madera",
      "23686004": "Las Guamas",
      "23686005": "Sabana Nueva",
      "23686006": "San Isidro",
      "23686007": "Valparaiso",
      "23686008": "Puerto Nuevo",
      "23686009": "Pelayito",
      "23686011": "Las Lauras",
      "23686018": "El Chiqui",
      "23686020": "Retiro",
      "23686021": "El Obligado",
      "23686022": "Bongas Mellas",
      "23686025": "Corocito",
      "23686027": "El Balsamo",
      "23686029": "El Corozo",
      "23686034": "Morrocoy",
      "23686036": "Providencia"
    },
    "Tierralta": {
      "23807000": "Tierralta (Cabecera Municipal)",
      "23807002": "Caramelo",
      "23807004": "Mantagordal",
      "23807005": "Nueva Granada",
      "23807006": "El Saiza",
      "23807007": "Santa Fe Ralito",
      "23807008": "Severinera",
      "23807010": "Volador",
      "23807017": "Frasquillo Nuevo",
      "23807026": "Los Morales",
      "23807027": "Santa Marta",
      "23807028": "Villa Providencia",
      "23807029": "Crucito",
      "23807032": "Pueblo Cedro"
    },
    "Tuchín": {
      "23815000": "Tuchin (Cabecera Municipal)"
    },
    "Valencia": {
      "23855000": "Valencia (Cabecera Municipal)",
      "23855001": "Rio Nuevo",
      "23855003": "Villanueva",
      "23855006": "Mata De Maiz",
      "23855009": "El Reposo",
      "23855015": "Santo Domingo",
      "23855016": "Manzanares",
      "23855017": "San Rafael",
      "23855019": "Guadual Central",
      "23855020": "Jerico",
      "23855021": "La Libertad"
    }
  },
 /*  "Guainía": {
    "Barranco Minas": {
      "94343000": "Barrancominas (Cabecera Municipal)",
      "94343002": "Arrecifal"
    },
    "Inírida": {
      "94001000": "Inirida (Cabecera Municipal)",
      "94001003": "Coco Viejo",
      "94001009": "Resguardo Cacahual Rio Atabapo",
      "94001010": "Coco Nuevo",
      "94001011": "Inspeccion Barranco Tigre",
      "94001012": "Coayare",
      "94001013": "Yuri"
    },
    "Pana Pana": {
      "94887002": "Venado Isana"
    }
  }, */
 /*  "Guaviare": {
    "Miraflores": {
      "95200009": "Puerto Nare",
      "95200010": "Puerto Santander"
    }
  }, */
  "Huila": {
    "Acevedo": {
      "41006000": "Acevedo (Cabecera Municipal)",
      "41006001": "San Adolfo",
      "41006003": "Pueblo Viejo",
      "41006005": "San Marcos",
      "41006011": "El Carmen"
    },
    "Agrado": {
      "41013000": "Agrado (Cabecera Municipal)",
      "41013001": "La Cañada",
      "41013003": "San Jose De Belen"
    },
    "Aipe": {
      "41016000": "Aipe (Cabecera Municipal)",
      "41016001": "Praga",
      "41016002": "Santa Rita",
      "41016003": "El Pata",
      "41016004": "Cruce De Guacirco"
    },
    "Algeciras": {
      "41020000": "Algeciras (Cabecera Municipal)",
      "41020002": "La Arcadia",
      "41020003": "El Toro",
      "41020006": "El Paraiso Nuevo"
    },
    "Altamira": {
      "41026000": "Altamira (Cabecera Municipal)",
      "41026004": "Llano De La Virgen",
      "41026005": "Puente"
    },
    "Baraya": {
      "41078000": "Baraya (Cabecera Municipal)"
    },
    "Campoalegre": {
      "41132000": "Campoalegre (Cabecera Municipal)",
      "41132001": "La Vega",
      "41132002": "Otas",
      "41132003": "Bajo Piravante",
      "41132004": "Rio Neiva"
    },
    "Colombia": {
      "41206000": "Colombia (Cabecera Municipal)",
      "41206002": "Santana",
      "41206005": "San Marcos"
    },
    "Elías": {
      "41244000": "Elias (Cabecera Municipal)",
      "41244001": "El Viso",
      "41244002": "Oritoguaz"
    },
    "Garzón": {
      "41298000": "Garzon (Cabecera Municipal)",
      "41298002": "La Jagua"
    },
    "Gigante": {
      "41306000": "Gigante (Cabecera Municipal)",
      "41306001": "La Chiquita",
      "41306002": "La Gran Via",
      "41306003": "Potrerillos",
      "41306004": "Rioloro",
      "41306006": "El Meson",
      "41306007": "Pueblo Nuevo",
      "41306009": "Vueltas Arriba",
      "41306010": "Silvania",
      "41306011": "Tres Esquinas",
      "41306013": "La Gran Via El Porvenir",
      "41306014": "El Recreo",
      "41306015": "La Bodega"
    },
    "Guadalupe": {
      "41319000": "Guadalupe (Cabecera Municipal)",
      "41319001": "Resina",
      "41319002": "Miraflores",
      "41319003": "Los Cauchos",
      "41319004": "Potrerillos"
    },
    "Hobo": {
      "41349000": "Hobo (Cabecera Municipal)"
    },
    "Isnos": {
      "41359003": "El Salto De Bordones"
    },
    "La Argentina": {
      "41378000": "La Argentina (Cabecera Municipal)",
      "41378001": "Buenos Aires",
      "41378002": "El Pensil"
    },
    "La Plata": {
      "41396000": "La Plata (Cabecera Municipal)",
      "41396001": "Belen",
      "41396002": "Monserrate",
      "41396004": "San Andres",
      "41396005": "Villa Losada",
      "41396006": "San Vicente",
      "41396009": "Gallego"
    },
    "Neiva": {
      "41001000": "Neiva (Cabecera Municipal)",
      "41001001": "Caguan",
      "41001003": "Fortalecillas",
      "41001007": "Palacios",
      "41001008": "Peñas Blancas",
      "41001011": "San Luis",
      "41001013": "El Triunfo",
      "41001014": "San Francisco",
      "41001016": "El Colegio",
      "41001017": "San Antonio De Anaconia",
      "41001022": "El Venado",
      "41001024": "Piedra Marcada"
    },
    "Nátaga": {
      "41483000": "Nataga (Cabecera Municipal)",
      "41483001": "Patio Bonito",
      "41483002": "Llano Buco",
      "41483003": "Yarumal"
    },
    "Oporapa": {
      "41503000": "Oporapa (Cabecera Municipal)",
      "41503001": "San Roque",
      "41503002": "El Carmen"
    },
    "Paicol": {
      "41518000": "Paicol (Cabecera Municipal)"
    },
    "Palermo": {
      "41524000": "Palermo (Cabecera Municipal)",
      "41524001": "Betania",
      "41524004": "Ospina Perez",
      "41524005": "San Juan",
      "41524006": "El Juncal",
      "41524009": "Amborco"
    },
    "Palestina": {
      "41530000": "Palestina (Cabecera Municipal)"
    },
    "Pital": {
      "41548000": "Pital (Cabecera Municipal)",
      "41548001": "El Socorro",
      "41548002": "Minas"
    },
    "Pitalito": {
      "41551000": "Pitalito (Cabecera Municipal)",
      "41551001": "Bruselas",
      "41551002": "Guacacayo",
      "41551003": "La Laguna",
      "41551005": "Regueros",
      "41551006": "Chillurco (Villas Del Norte)",
      "41551008": "Criollo",
      "41551009": "Charguayaco",
      "41551010": "Palmarito"
    },
    "Rivera": {
      "41615000": "Rivera (Cabecera Municipal)",
      "41615001": "La Ulloa",
      "41615002": "Riverita",
      "41615006": "Rio Frio",
      "41615007": "El Guadual"
    },
    "Saladoblanco": {
      "41660000": "Saladoblanco (Cabecera Municipal)",
      "41660001": "La Cabaña",
      "41660007": "Morelia"
    },
    "San Agustín": {
      "41668000": "San Agustin (Cabecera Municipal)",
      "41668002": "Obando",
      "41668003": "Villa Fatima",
      "41668004": "Puerto Quinchana",
      "41668006": "El Palmar",
      "41668007": "Pradera",
      "41668009": "El Rosario"
    },
    "San Jose De Isnos": {
      "41359000": "San Jose De Isnos (Cabecera Municipal)"
    },
    "Santa María": {
      "41676000": "Santa Maria (Cabecera Municipal)",
      "41676001": "San Joaquin"
    },
    "Suaza": {
      "41770000": "Suaza (Cabecera Municipal)",
      "41770001": "Gallardo",
      "41770002": "Guayabal"
    },
    "Tarqui": {
      "41791000": "Tarqui (Cabecera Municipal)",
      "41791001": "El Vergel",
      "41791002": "Maito",
      "41791003": "Quituro"
    },
    "Tello": {
      "41799000": "Tello (Cabecera Municipal)",
      "41799001": "Anacleto Garcia",
      "41799002": "Sierra Del Gramal",
      "41799003": "San Andres Tello",
      "41799004": "Sierra De La Cañada"
    },
    "Teruel": {
      "41801000": "Teruel (Cabecera Municipal)"
    },
    "Tesalia": {
      "41797000": "Tesalia (Cabecera Municipal)",
      "41797001": "Pacarni"
    },
    "Timaná": {
      "41807000": "Timana (Cabecera Municipal)",
      "41807001": "Naranjal",
      "41807004": "San Antonio",
      "41807005": "Montañita",
      "41807006": "Quinche",
      "41807007": "Cosanza",
      "41807009": "San Isidro"
    },
    "Villavieja": {
      "41872000": "Villavieja (Cabecera Municipal)",
      "41872001": "Potosi",
      "41872002": "San Alfonso",
      "41872003": "Hato Nuevo",
      "41872004": "Polonia",
      "41872005": "La Victoria"
    },
    "Yaguará": {
      "41885000": "Yaguara (Cabecera Municipal)"
    },
    "Íquira": {
      "41357000": "Iquira (Cabecera Municipal)",
      "41357003": "Rio Negro",
      "41357004": "Valencia La Paz"
    }
  },
  "Magdalena": {
    "Algarrobo": {
      "47030000": "Algarrobo (Cabecera Municipal)",
      "47030001": "Bella Vista",
      "47030002": "Estacion Del Ferrocarril",
      "47030003": "Estacion Lleras",
      "47030004": "Loma Del Balsamo"
    },
    "Aracataca": {
      "47053000": "Aracataca (Cabecera Municipal)",
      "47053001": "Buenos Aires",
      "47053011": "Cauca",
      "47053013": "Sampues"
    },
    "Ariguaní": {
      "47058000": "Ariguani (Cabecera Municipal)",
      "47058001": "Alejandria",
      "47058003": "Pueblo Nuevo",
      "47058005": "San Jose De Ariguani",
      "47058008": "Vadelco",
      "47058009": "Carmen De Ariguani"
    },
    "Cerro De San Antonio": {
      "47161002": "Candelaria (Caiman)",
      "47161003": "Concepcion (Coco)",
      "47161005": "Jesus Del Monte (Mico)",
      "47161006": "Puerto Niño (Charanga)"
    },
    "Chivolo": {
      "47170000": "Chivolo (Cabecera Municipal)",
      "47170001": "La China",
      "47170002": "Pueblo Nuevo",
      "47170003": "La Estrella"
    },
    "Ciénaga": {
      "47189000": "Cienaga (Cabecera Municipal)",
      "47189004": "San Pedro De La Sierra",
      "47189006": "Sevillano",
      "47189018": "Palmor",
      "47189022": "Cordobita",
      "47189023": "Siberia",
      "47189024": "La Isabel",
      "47189025": "Maya"
    },
    "Concordia": {
      "47205000": "Concordia (Cabecera Municipal)",
      "47205001": "Balsamo",
      "47205002": "Bellavista",
      "47205003": "Rosario Del Chengue"
    },
    "El Banco": {
      "47245000": "El Banco (Cabecera Municipal)",
      "47245001": "Aguaestrada",
      "47245002": "Algarrobal",
      "47245003": "El Barranco De Chilloa",
      "47245004": "Los Negritos",
      "47245005": "Belen",
      "47245006": "Caño De Palma",
      "47245007": "El Cerrito",
      "47245008": "El Trebol",
      "47245010": "Menchiquejo",
      "47245011": "Hatillo De La Sabana",
      "47245012": "San Jose",
      "47245013": "San Roque",
      "47245014": "Tamalamequito",
      "47245016": "San Felipe Y San Eduardo",
      "47245018": "Guacamayal",
      "47245019": "Malpica",
      "47245020": "Garzon",
      "47245022": "Islitas",
      "47245025": "Botillero",
      "47245028": "Pueblo Nuevo",
      "47245032": "Mata De Caña",
      "47245033": "El Cedro"
    },
    "El Piñón": {
      "47258000": "El Piñon (Cabecera Municipal)",
      "47258001": "Campo Alegre",
      "47258002": "Cantagallar",
      "47258003": "Carreto",
      "47258004": "Playon De Orozco",
      "47258006": "San Basilio",
      "47258007": "Tio Gollo",
      "47258009": "Veranillo",
      "47258010": "Los Patos",
      "47258011": "Vasquez",
      "47258012": "Las Palmas",
      "47258013": "Las Pavitas"
    },
    "El Retén": {
      "47268000": "El Reten (Cabecera Municipal)",
      "47268001": "San Sebastian Del Bongo",
      "47268002": "La Colombia",
      "47268003": "Las Flores",
      "47268006": "La Polvorita",
      "47268007": "Parate Bien (El Pleito)",
      "47268008": "San Jose De Honduras"
    },
    "Fundación": {
      "47288000": "Fundacion (Cabecera Municipal)",
      "47288003": "Doña Maria",
      "47288004": "Santa Rosa",
      "47288013": "Santa Clara"
    },
    "Guamal": {
      "47318000": "Guamal (Cabecera Municipal)",
      "47318001": "Casa De Tabla",
      "47318002": "Guaimaral",
      "47318003": "Hato Viejo",
      "47318004": "Pedregosa",
      "47318005": "Los Andes",
      "47318006": "Murillo",
      "47318008": "Ricaurte",
      "47318009": "Salvadora",
      "47318010": "Hurquijo",
      "47318011": "Playas Blancas",
      "47318013": "Carretero",
      "47318014": "Bellavista",
      "47318016": "Santa Teresita",
      "47318017": "San Pedro",
      "47318018": "Las Flores",
      "47318019": "San Antonio",
      "47318020": "La Ceiba",
      "47318023": "San Isidro",
      "47318024": "Villa Nueva",
      "47318025": "El Veintiocho"
    },
    "Nueva Granada": {
      "47460000": "Nueva Granada (Cabecera Municipal)",
      "47460001": "El Bajo",
      "47460002": "La Gloria",
      "47460003": "Las Tinas",
      "47460004": "Los Andes",
      "47460006": "San Jose De Ballestero"
    },
    "Pedraza": {
      "47541000": "Pedraza (Cabecera Municipal)"
    },
    "Pijiño Del Carmen": {
      "47545001": "Cabrera",
      "47545002": "Filadelfia",
      "47545003": "San Jose De Prevencion",
      "47545004": "Casa Blanca",
      "47545005": "La Lucha",
      "47545007": "El Dividivi"
    },
    "Pivijay": {
      "47551000": "Pivijay (Cabecera Municipal)",
      "47551001": "La Avianca",
      "47551002": "Caraballo",
      "47551003": "Chinoblas",
      "47551005": "San Jose De La Montaña (Garrapata)",
      "47551006": "Las Canoas",
      "47551007": "Las Piedras",
      "47551008": "Medialuna",
      "47551010": "Carmen Del Magdalena (Paraco)",
      "47551011": "Paraiso",
      "47551012": "Piñuelas",
      "47551013": "Placitas"
    },
    "Plato": {
      "47555000": "Plato (Cabecera Municipal)",
      "47555001": "Apure",
      "47555002": "Carmen Del Magdalena",
      "47555005": "Zarate",
      "47555006": "Aguas Vivas",
      "47555007": "Cienegueta",
      "47555008": "Cerro Grande",
      "47555011": "San Jose Del Purgatorio",
      "47555015": "Disciplina",
      "47555017": "San Antonio Del Rio",
      "47555018": "Buena Vista",
      "47555020": "Los Pozos",
      "47555021": "Cinco Y Seis"
    },
    "Puebloviejo": {
      "47570000": "Puebloviejo (Cabecera Municipal)",
      "47570002": "Isla Del Rosario",
      "47570003": "Palmira",
      "47570005": "Tierra Nueva",
      "47570007": "El Triunfo",
      "47570009": "Nueva Frontera",
      "47570010": "San Juan De Palos Prietos (La Montaña)"
    },
    "Remolino": {
      "47605000": "Remolino (Cabecera Municipal)",
      "47605002": "Corral Viejo",
      "47605003": "El Dividivi",
      "47605004": "San Rafael De Buenavista",
      "47605005": "Santa Rita",
      "47605006": "El Salao",
      "47605007": "Martinete",
      "47605008": "Las Casitas"
    },
    "Sabanas De San Ángel": {
      "47660002": "Casa De Tabla",
      "47660003": "Cespedes",
      "47660005": "Flores De Maria",
      "47660007": "La Horqueta",
      "47660009": "San Roque",
      "47660011": "Pueblito De Los Barrios",
      "47660013": "Estacion Villa",
      "47660014": "Monterrubio"
    },
    "Salamina": {
      "47675000": "Salamina (Cabecera Municipal)",
      "47675001": "Guaimaro",
      "47675005": "El Salao",
      "47675006": "La Loma"
    },
    "San Sebastián De Buenavista": {
      "47692000": "San Sebastian De Buenavista (Cabecera Municipal)",
      "47692001": "Buenavista",
      "47692002": "El Coco",
      "47692003": "La Pacha",
      "47692004": "Las Margaritas",
      "47692005": "Los Galvis",
      "47692006": "Maria Antonia",
      "47692007": "San Rafael",
      "47692008": "Santa Rosa",
      "47692009": "Troncosito",
      "47692010": "Troncoso",
      "47692011": "Venero",
      "47692013": "El Seis",
      "47692018": "San Valentin",
      "47692019": "Pueblo Nuevo"
    },
    "San Zenón": {
      "47703000": "San Zenon (Cabecera Municipal)",
      "47703001": "Angostura",
      "47703002": "Bermejal",
      "47703003": "El Palomar",
      "47703004": "Janeiro",
      "47703005": "La Montaña",
      "47703006": "Peñoncito",
      "47703007": "Santa Teresa",
      "47703008": "Guinea",
      "47703009": "El Horno",
      "47703010": "Puerto Arturo"
    },
    "Santa Ana": {
      "47707000": "Santa Ana (Cabecera Municipal)",
      "47707001": "Barro Blanco",
      "47707006": "San Fernando",
      "47707009": "Jaraba",
      "47707011": "Santa Rosa"
    },
    "Santa Bárbara De Pinto": {
      "47720000": "Santa Barbara De Pinto (Cabecera Municipal)",
      "47720001": "Cundinamarca",
      "47720002": "San Pedro",
      "47720003": "Veladero"
    },
    "Santa Marta": {
      "47001000": "Santa Marta (Cabecera Municipal)",
      "47001001": "Bonda",
      "47001002": "Calabazo",
      "47001009": "Minca",
      "47001013": "Tigrera",
      "47001022": "Cabañas De Buritaca",
      "47001023": "Cañaveral (Agua Fria)",
      "47001025": "Curvalito",
      "47001026": "Guacoche (La Llanta)",
      "47001027": "Marketalia (Palomino)",
      "47001028": "Paz Del Caribe",
      "47001029": "Perico Aguao",
      "47001032": "La Revuelta",
      "47001034": "El Trompito",
      "47001035": "La Aguacatera",
      "47001036": "Machete Pelao",
      "47001037": "Nuevo Mejico"
    },
    "Sitionuevo": {
      "47745000": "Sitionuevo (Cabecera Municipal)",
      "47745006": "San Antonio"
    },
    "Tenerife": {
      "47798000": "Tenerife (Cabecera Municipal)",
      "47798004": "Real Del Obispo",
      "47798005": "San Luis",
      "47798007": "El Juncal",
      "47798008": "Santa Ines"
    },
    "Zapayán": {
      "47960000": "Zapayan (Cabecera Municipal)",
      "47960001": "Caño De Aguas",
      "47960002": "Capucho",
      "47960003": "Piedras De Moler",
      "47960004": "Piedras Pintadas",
      "47960005": "Los Cerritos"
    },
    "Zona Bananera": {
      "47980001": "Guacamayal",
      "47980002": "Guamachito",
      "47980003": "La Gran Via",
      "47980004": "Orihueca",
      "47980005": "Palomar",
      "47980006": "Rio Frio",
      "47980009": "Soplador",
      "47980010": "Tucurinca",
      "47980011": "Varela",
      "47980012": "Zawady",
      "47980013": "Estacion Sevilla",
      "47980014": "La Candelaria",
      "47980015": "San Jose De Kennedy",
      "47980016": "Caño Mocho",
      "47980017": "El Mamon"
    }
  },
  "Meta": {
    "Acacías": {
      "50006000": "Acacias (Cabecera Municipal)",
      "50006001": "Dinamarca",
      "50006003": "San Isidro De Chichimene"
    },
    "Barranca De Upía": {
      "50110000": "Barranca De Upia (Cabecera Municipal)",
      "50110001": "San Ignacio"
    },
    "Cabuyaro": {
      "50124000": "Cabuyaro (Cabecera Municipal)",
      "50124002": "Guayabal De Upia",
      "50124003": "Viso De Upia",
      "50124004": "Los Mangos"
    },
    "Castilla La Nueva": {
      "50150000": "Castilla La Nueva (Cabecera Municipal)",
      "50150001": "San Lorenzo",
      "50150002": "Pueblo Viejo",
      "50150003": "El Toro"
    },
    "Cubarral": {
      "50223000": "Cubarral (Cabecera Municipal)",
      "50223003": "Puerto Ariari"
    },
    "Cumaral": {
      "50226000": "Cumaral (Cabecera Municipal)",
      "50226002": "Guacavia",
      "50226004": "San Nicolas",
      "50226005": "Veracruz",
      "50226010": "Presentado"
    },
    "El Calvario": {
      "50245000": "El Calvario (Cabecera Municipal)",
      "50245001": "Montfort",
      "50245002": "San Francisco"
    },
    "El Castillo": {
      "50251000": "El Castillo (Cabecera Municipal)",
      "50251001": "Medellin Del Ariari",
      "50251003": "Miravalles",
      "50251004": "Puerto Esperanza"
    },
    "El Dorado": {
      "50270000": "El Dorado (Cabecera Municipal)",
      "50270001": "Pueblo Sanchez",
      "50270002": "San Isidro"
    },
    "Fuente De Oro": {
      "50287000": "Fuente De Oro (Cabecera Municipal)",
      "50287001": "Puerto Aljure",
      "50287002": "Puerto Limon",
      "50287003": "Puerto Santander",
      "50287004": "Union Del Ariari",
      "50287005": "La Cooperativa",
      "50287006": "Caño Blanco",
      "50287007": "Puerto Nuevo"
    },
    "Granada": {
      "50313000": "Granada (Cabecera Municipal)",
      "50313001": "Canaguaro",
      "50313002": "Dos Quebradas",
      "50313005": "Puerto Caldas",
      "50313006": "Aguas Claras"
    },
    "Guamal": {
      "50318000": "Guamal (Cabecera Municipal)",
      "50318001": "Humadea"
    },
    "La Macarena": {
      "50350000": "La Macarena (Cabecera Municipal)",
      "50350001": "San Francisco De La Sombra",
      "50350007": "La Cristalina",
      "50350008": "El Rubi"
    },
    "Lejanías": {
      "50400000": "Lejanias (Cabecera Municipal)",
      "50400001": "Cacayal"
    },
    "Mapiripán": {
      "50325000": "Mapiripan (Cabecera Municipal)",
      "50325001": "Puerto Alvira",
      "50325002": "Mielon",
      "50325004": "Anzuelo",
      "50325006": "La Cooperativa",
      "50325007": "Puerto Siare"
    },
    "Mesetas": {
      "50330000": "Mesetas (Cabecera Municipal)",
      "50330002": "Jardin De Las Peñas",
      "50330005": "Oriente",
      "50330007": "La Argentina",
      "50330009": "Puerto Nariño",
      "50330010": "San Isidro"
    },
    "Puerto Concordia": {
      "50450000": "Puerto Concordia (Cabecera Municipal)",
      "50450001": "El Pororio"
    },
    "Puerto Gaitán": {
      "50568000": "Puerto Gaitan (Cabecera Municipal)",
      "50568002": "San Pedro De Arimena",
      "50568004": "San Miguel",
      "50568005": "El Porvenir",
      "50568006": "Puerto Trujillo",
      "50568007": "Puente Arimena",
      "50568008": "Alto Tillava"
    },
    "Puerto Lleras": {
      "50577000": "Puerto Lleras (Cabecera Municipal)",
      "50577003": "Casibare",
      "50577004": "Caño Rayado",
      "50577005": "Villa La Paz"
    },
    "Puerto López": {
      "50573000": "Puerto Lopez (Cabecera Municipal)",
      "50573001": "La Balsa",
      "50573003": "Pachaquiaro",
      "50573004": "Altamira",
      "50573006": "Puerto Guadalupe",
      "50573007": "Puerto Porfia",
      "50573008": "Remolino",
      "50573010": "Bocas Del Guayuriba",
      "50573011": "Guichiral",
      "50573012": "Chaviva",
      "50573013": "El Tigre"
    },
    "Puerto Rico": {
      "50590000": "Puerto Rico (Cabecera Municipal)"
    },
    "Restrepo": {
      "50606000": "Restrepo (Cabecera Municipal)"
    },
    "San Carlos De Guaroa": {
      "50680000": "San Carlos De Guaroa (Cabecera Municipal)",
      "50680001": "Pajure",
      "50680002": "Surimena",
      "50680003": "La Palmera"
    },
    "San Juan De Arama": {
      "50683000": "San Juan De Arama (Cabecera Municipal)",
      "50683001": "El Vergel",
      "50683005": "Mesa Fernandez"
    },
    "San Juanito": {
      "50686000": "San Juanito (Cabecera Municipal)"
    },
    "San Martín": {
      "50689000": "San Martin (Cabecera Municipal)",
      "50689001": "El Merey"
    },
    "Uribe": {
      "50370000": "Uribe (Cabecera Municipal)",
      "50370002": "El Diviso"
    },
    "Villavicencio": {
      "50001000": "Villavicencio (Cabecera Municipal)",
      "50001001": "Concepcion",
      "50001002": "Rincon De Pompeya",
      "50001003": "Santa Rosa De Rio Negro",
      "50001004": "Buenavista",
      "50001005": "Cocuy",
      "50001007": "Servita",
      "50001013": "Pipiral",
      "50001014": "San Luis De Ocoa",
      "50001015": "Alto Pompeya",
      "50001016": "Cecilia",
      "50001017": "La Nohora",
      "50001019": "Apiay",
      "50001020": "Barcelona",
      "50001021": "Argentina"
    },
    "Vistahermosa": {
      "50711000": "Vistahermosa (Cabecera Municipal)",
      "50711001": "Campo Alegre",
      "50711002": "Piñalito",
      "50711003": "Maracaibo",
      "50711004": "Caño Amarillo",
      "50711005": "Puerto Lucas Margen Izquierdo",
      "50711006": "Puerto Lucas Margen Derecho",
      "50711008": "Puerto Esperanza Margen Izquierdo",
      "50711012": "Costa Rica",
      "50711014": "Palestina",
      "50711016": "Santo Domingo"
    }
  },
  "Nariño": {
    "Albán": {
      "52019004": "Campobello"
    },
    "Aldana": {
      "52022000": "Aldana (Cabecera Municipal)",
      "52022003": "San Luis"
    },
    "Ancuyá": {
      "52036000": "Ancuya (Cabecera Municipal)"
    },
    "Arboleda": {
      "52051007": "Rosa Florida Sur - Sector La Capilla",
      "52051012": "Rosaflorida Norte",
      "52051015": "El Pedregal"
    },
    "Barbacoas": {
      "52079000": "Barbacoas (Cabecera Municipal)",
      "52079006": "Junin",
      "52079018": "San Miguel Nambi"
    },
    "Belén": {
      "52083000": "Belen (Cabecera Municipal)",
      "52083001": "Santa Rosa"
    },
    "Buesaco": {
      "52110000": "Buesaco (Cabecera Municipal)",
      "52110001": "Palasinoy",
      "52110002": "Rosal Del Monte",
      "52110003": "San Antonio",
      "52110004": "San Ignacio",
      "52110005": "Santafe",
      "52110006": "Santamaria",
      "52110007": "Villamoreno",
      "52110008": "Veracruz",
      "52110009": "Altaclara",
      "52110022": "Juanambu",
      "52110030": "San Miguel Santafe"
    },
    "Chachagüí": {
      "52240000": "Chachagüi (Cabecera Municipal)",
      "52240001": "Arizona",
      "52240002": "Agrario",
      "52240003": "Caño Alto",
      "52240004": "Caño Bajo",
      "52240005": "Chorrillo",
      "52240006": "Guairabamba",
      "52240008": "La Loma",
      "52240011": "Santa Monica"
    },
    "Colón": {
      "52203000": "Colon (Cabecera Municipal)",
      "52203002": "La Plata",
      "52203004": "Villanueva"
    },
    "Consacá": {
      "52207000": "Consaca (Cabecera Municipal)",
      "52207004": "Bombona",
      "52207013": "El Hatillo"
    },
    "Contadero": {
      "52210000": "Contadero (Cabecera Municipal)",
      "52210001": "Aldea De Maria",
      "52210002": "La Josefina"
    },
    "Cuaspud Carlosama": {
      "52224000": "Cuaspud Carlosama (Cabecera Municipal)"
    },
    "Cumbal": {
      "52227000": "Cumbal (Cabecera Municipal)",
      "52227001": "Chiles",
      "52227004": "Panan",
      "52227006": "Nazate"
    },
    "Cumbitara": {
      "52233000": "Cumbitara (Cabecera Municipal)",
      "52233001": "Damasco",
      "52233002": "El Desierto",
      "52233003": "Pisanda",
      "52233004": "Sidon",
      "52233007": "La Esperanza",
      "52233008": "Santa Rosa",
      "52233011": "Santa Ana"
    },
    "Córdoba": {
      "52215000": "Cordoba (Cabecera Municipal)",
      "52215001": "Los Arrayanes",
      "52215004": "Santander",
      "52215005": "Pueblo Bajo"
    },
    "El Charco": {
      "52250000": "El Charco (Cabecera Municipal)",
      "52250003": "San Pedro",
      "52250022": "El Cuil",
      "52250023": "Bazan"
    },
    "El Peñol": {
      "52254000": "El Peñol (Cabecera Municipal)",
      "52254001": "Las Cochas",
      "52254002": "San Francisco",
      "52254003": "Peñol Viejo"
    },
    "El Rosario": {
      "52256000": "El Rosario (Cabecera Municipal)",
      "52256003": "La Esmeralda",
      "52256004": "La Sierra",
      "52256012": "Martin Perez",
      "52256024": "El Rincon"
    },
    "El Tablón De Gómez": {
      "52258000": "El Tablon De Gomez (Cabecera Municipal)",
      "52258001": "Aponte",
      "52258002": "La Cueva",
      "52258003": "Las Mesas",
      "52258005": "La Victoria",
      "52258015": "San Rafael"
    },
    "El Tambo": {
      "52260000": "El Tambo (Cabecera Municipal)"
    },
    "Francisco Pizarro": {
      "52520000": "Francisco Pizarro (Cabecera Municipal)",
      "52520007": "Bocas De Curay",
      "52520011": "Luis Avelino Perez",
      "52520012": "La Playa"
    },
    "Funes": {
      "52287000": "Funes (Cabecera Municipal)",
      "52287001": "Chapal"
    },
    "Guachucal": {
      "52317000": "Guachucal (Cabecera Municipal)",
      "52317001": "Colimba",
      "52317002": "El Consuelo De Chillanquer",
      "52317003": "San Diego De Muellamues",
      "52317004": "San Jose De Chillanquer",
      "52317005": "La Victoria"
    },
    "Guaitarilla": {
      "52320000": "Guaitarilla (Cabecera Municipal)"
    },
    "Gualmatán": {
      "52323000": "Gualmatan (Cabecera Municipal)",
      "52323001": "Cuatis"
    },
    "Iles": {
      "52352000": "Iles (Cabecera Municipal)",
      "52352003": "San Francisco"
    },
    "Imués": {
      "52354000": "Imues (Cabecera Municipal)",
      "52354002": "Pilcuan La Recta",
      "52354004": "Pilcuan Viejo",
      "52354012": "Santa Ana"
    },
    "Ipiales": {
      "52356000": "Ipiales (Cabecera Municipal)",
      "52356001": "La Victoria",
      "52356002": "Las Lajas",
      "52356003": "San Juan",
      "52356004": "Yaramal",
      "52356005": "Lomas De Suras",
      "52356009": "Las Cruces"
    },
    "La Cruz": {
      "52378000": "La Cruz (Cabecera Municipal)",
      "52378005": "San Gerardo",
      "52378009": "Tajumbina",
      "52378017": "La Estancia"
    },
    "La Florida": {
      "52381000": "La Florida (Cabecera Municipal)",
      "52381001": "Matituy",
      "52381002": "Robles",
      "52381003": "Tunja La Grande",
      "52381008": "El Rodeo"
    },
    "La Llanada": {
      "52385000": "La Llanada (Cabecera Municipal)",
      "52385001": "Vergel"
    },
    "La Tola": {
      "52390000": "La Tola (Cabecera Municipal)",
      "52390003": "Vigia De La Mar",
      "52390007": "Pioja",
      "52390008": "Pangamosa",
      "52390009": "Mulatos",
      "52390012": "Nerete"
    },
    "La Unión": {
      "52399000": "La Union (Cabecera Municipal)",
      "52399001": "Santander",
      "52399003": "La Caldera",
      "52399012": "La Playa",
      "52399018": "Olivos",
      "52399029": "La Betulia",
      "52399030": "Quiroz Alto"
    },
    "Leiva": {
      "52405000": "Leiva (Cabecera Municipal)",
      "52405008": "La Florida",
      "52405009": "El Tablon",
      "52405014": "Villa Baja"
    },
    "Linares": {
      "52411000": "Linares (Cabecera Municipal)",
      "52411001": "San Francisco"
    },
    "Los Andes": {
      "52418000": "Los Andes (Cabecera Municipal)"
    },
    "Magüí": {
      "52427003": "Nansalbid",
      "52427005": "Guilpi Piragua",
      "52427015": "Brisas De Hamburgo",
      "52427016": "Bella Vista",
      "52427017": "Campo Alegre"
    },
    "Mallama": {
      "52435002": "Chucunes",
      "52435008": "San Miguel",
      "52435009": "El Carmelo"
    },
    "Mosquera": {
      "52473000": "Mosquera (Cabecera Municipal)",
      "52473001": "Cocalito Jimenez (Gabriel Turbay)",
      "52473004": "Cocal De Los Payanes",
      "52473006": "Firme Cifuentes",
      "52473007": "Bocas De Guandipa",
      "52473008": "Pueblo Nuevo",
      "52473009": "El Garcero",
      "52473010": "El Bajito De Echandia",
      "52473014": "Pampa Chapila",
      "52473015": "Playa Nueva",
      "52473018": "El Tortugo"
    },
    "Nariño": {
      "52480000": "Nariño (Cabecera Municipal)"
    },
    "Olaya Herrera": {
      "52490003": "El Carmen",
      "52490008": "San Jose Calabazal"
    },
    "Ospina": {
      "52506000": "Ospina (Cabecera Municipal)",
      "52506002": "San Isidro",
      "52506005": "Cunchila O Moreno"
    },
    "Pasto": {
      "52001000": "Pasto (Cabecera Municipal)",
      "52001001": "Catambuco",
      "52001004": "Genoy",
      "52001005": "La Laguna",
      "52001007": "Obonuco",
      "52001009": "Jongovito",
      "52001012": "Mapachico - Aticance",
      "52001013": "El Socorro Cimarron",
      "52001016": "Motilon",
      "52001019": "Cerotal",
      "52001021": "La Victoria",
      "52001024": "San Jose",
      "52001025": "El Puerto",
      "52001027": "Cabrera",
      "52001029": "Dolores",
      "52001030": "Buesaquillo",
      "52001033": "Cujacal",
      "52001039": "Anganoy",
      "52001042": "Daza",
      "52001051": "Cubijan Bajo",
      "52001052": "San Fernando",
      "52001053": "Mocondino",
      "52001056": "Los Angeles",
      "52001059": "Jamondino",
      "52001063": "Botanilla",
      "52001064": "Charguayaco",
      "52001065": "Cruz De Amarillo",
      "52001066": "El Campanero",
      "52001068": "Jurado",
      "52001071": "La Merced",
      "52001072": "Las Encinas",
      "52001073": "Mapachico Alto",
      "52001074": "Mapachico San Jose",
      "52001076": "San Francisco",
      "52001078": "San Juan De Anganoy",
      "52001079": "Santa Lucia",
      "52001080": "Villa Maria",
      "52001086": "Gualmatan Alto",
      "52001087": "La Caldera"
    },
    "Policarpa": {
      "52540000": "Policarpa (Cabecera Municipal)"
    },
    "Potosí": {
      "52560000": "Potosi (Cabecera Municipal)",
      "52560001": "Cardenas",
      "52560002": "Bajo Sinai",
      "52560006": "San Pedro"
    },
    "Providencia": {
      "52565000": "Providencia (Cabecera Municipal)"
    },
    "Puerres": {
      "52573000": "Puerres (Cabecera Municipal)",
      "52573002": "Monopamba",
      "52573003": "San Mateo",
      "52573005": "Maicira",
      "52573006": "El Llano",
      "52573010": "San Miguel",
      "52573013": "Yanale"
    },
    "Pupiales": {
      "52585000": "Pupiales (Cabecera Municipal)",
      "52585004": "Jose Maria Hernandez"
    },
    "Ricaurte": {
      "52612000": "Ricaurte (Cabecera Municipal)",
      "52612004": "San Isidro",
      "52612008": "Chambu",
      "52612011": "San Francisco",
      "52612012": "Villa Nueva"
    },
    "Roberto Payán": {
      "52621000": "Roberto Payan (Cabecera Municipal)",
      "52621009": "Las Lajas Pumbi",
      "52621016": "San Antonio - Boca Telembi",
      "52621028": "Las Mercedes - Chimbuza"
    },
    "Samaniego": {
      "52678000": "Samaniego (Cabecera Municipal)",
      "52678007": "Tanama",
      "52678012": "Chuguldi",
      "52678013": "Turupamba",
      "52678015": "Puerchag",
      "52678017": "Cartagena",
      "52678024": "La Mesa",
      "52678025": "Obando"
    },
    "San Andrés De Tumaco": {
      "52835009": "Caunapi",
      "52835010": "Colorado",
      "52835011": "Descolgadero",
      "52835012": "Chajal",
      "52835016": "Pital",
      "52835017": "Espriella",
      "52835020": "Barro Colorado",
      "52835021": "San Jose Del Guayabo",
      "52835030": "Guayacana",
      "52835031": "Llorente",
      "52835036": "Palambi",
      "52835037": "Imbili Miraspalmas",
      "52835040": "El Progreso Santo Domingo",
      "52835042": "San Luis Robles",
      "52835047": "Salisvi",
      "52835050": "Villa San Juan",
      "52835051": "San Antonio",
      "52835058": "Teheran",
      "52835059": "Uribe Uribe (Chilvi)",
      "52835063": "El Bajito",
      "52835068": "Caleta Viento Libre",
      "52835069": "Ceibito",
      "52835071": "El Carmen Km 36",
      "52835075": "Bocana Nueva",
      "52835077": "Chilvicito",
      "52835083": "La Sirena",
      "52835085": "Palay",
      "52835087": "Pulgande",
      "52835088": "Retoño",
      "52835091": "Santa Rosa",
      "52835092": "Alto Agua Clara",
      "52835093": "Imbilpi Del Carmen",
      "52835099": "Inguapi Del Carmen",
      "52835100": "San Andres De Tumaco Corregimiento",
      "52835102": "El Coco",
      "52835104": "Albania",
      "52835107": "Bajo Jagua",
      "52835108": "Brisas Del Acueducto",
      "52835109": "Cacagual",
      "52835111": "Corriente Grande",
      "52835114": "Guabal",
      "52835115": "Guachal",
      "52835116": "Gualtal",
      "52835118": "El Retorno",
      "52835119": "Juan Domingo",
      "52835120": "Kilometro 28",
      "52835121": "Kilometro 35",
      "52835123": "Kilometro 58",
      "52835125": "La Chorrera",
      "52835127": "Piñuela Rio Mira",
      "52835129": "La Vega",
      "52835130": "Majagua",
      "52835133": "Pacora",
      "52835134": "Pindales",
      "52835136": "Pueblo Nuevo",
      "52835140": "Tambillo",
      "52835141": "Tangareal Carretera",
      "52835144": "Vuelta Candelilla",
      "52835146": "Firme De Los Coimes",
      "52835148": "Tablon Dulce La Pampa",
      "52835149": "Las Mercedes",
      "52835150": "Bellavista",
      "52835151": "Vaqueria Colombia Grande",
      "52835152": "Inguapi El Guadual",
      "52835153": "Congal",
      "52835154": "Bajo Guabal",
      "52835155": "Peña Colorada",
      "52835156": "Buchely",
      "52835157": "Cajapi",
      "52835158": "Variante",
      "52835159": "Dos Quebradas",
      "52835160": "Candelilla",
      "52835161": "Piñal Salado",
      "52835162": "Chontal",
      "52835163": "Imbili",
      "52835164": "San Pedro Del Vino",
      "52835166": "San Sebastian",
      "52835167": "Boca De Tulmo",
      "52835168": "Sagumbita",
      "52835174": "La Brava Rio Caunapi"
    },
    "San Bernardo": {
      "52685000": "San Bernardo (Cabecera Municipal)"
    },
    "San Lorenzo": {
      "52687000": "San Lorenzo (Cabecera Municipal)",
      "52687001": "El Carmen",
      "52687002": "Santa Cecilia",
      "52687003": "Santa Martha",
      "52687005": "San Vicente"
    },
    "San Pablo": {
      "52693000": "San Pablo (Cabecera Municipal)",
      "52693002": "Briceño",
      "52693017": "Chilcal Alto"
    },
    "San Pedro De Cartago": {
      "52694000": "San Pedro De Cartago (Cabecera Municipal)",
      "52694001": "La Comunidad"
    },
    "Sandoná": {
      "52683000": "Sandona (Cabecera Municipal)",
      "52683001": "Bolivar",
      "52683002": "El Ingenio",
      "52683003": "San Bernardo",
      "52683005": "Santa Rosa",
      "52683007": "Roma Chavez",
      "52683009": "Paraguay",
      "52683011": "San Gabriel",
      "52683012": "San Miguel",
      "52683014": "Altamira Cruz De Arada",
      "52683016": "Chavez",
      "52683017": "Tambillo",
      "52683022": "San Fernando",
      "52683023": "San Francisco Alto"
    },
    "Santa Bárbara": {
      "52696009": "Palomino",
      "52696012": "Cuerbal",
      "52696013": "Juanchillo",
      "52696014": "La Ensenada",
      "52696015": "Chico Perez",
      "52696017": "Santa Rita"
    },
    "Santacruz": {
      "52699001": "Balalaika",
      "52699004": "Manchag"
    },
    "Sapuyes": {
      "52720000": "Sapuyes (Cabecera Municipal)",
      "52720001": "El Espino",
      "52720002": "Uribe"
    },
    "Taminango": {
      "52786000": "Taminango (Cabecera Municipal)",
      "52786002": "El Tablon",
      "52786003": "Curiaco",
      "52786006": "Alto De Diego",
      "52786007": "El Manzano",
      "52786018": "La Granada",
      "52786019": "El Remolino",
      "52786021": "Guayacanal",
      "52786022": "San Isidro"
    },
    "Tangua": {
      "52788000": "Tangua (Cabecera Municipal)",
      "52788001": "Santander"
    },
    "Tumaco": {
      "52835000": "Tumaco (Cabecera Municipal)"
    },
    "Túquerres": {
      "52838000": "Tuquerres (Cabecera Municipal)",
      "52838002": "Cuatro Esquinas",
      "52838004": "Pinzon",
      "52838007": "Santander",
      "52838009": "Yascual",
      "52838012": "Los Arrayanes"
    },
    "Yacuanquer": {
      "52885000": "Yacuanquer (Cabecera Municipal)",
      "52885006": "Mejia",
      "52885007": "La Aguada"
    }
  },
  "Putumayo": {
    "Colón": {
      "86219000": "Colon (Cabecera Municipal)",
      "86219001": "San Pedro"
    },
    "Mocoa": {
      "86001000": "Mocoa (Cabecera Municipal)",
      "86001002": "El Pepino",
      "86001003": "Pueblo Viejo",
      "86001004": "Puerto Limon",
      "86001006": "San Antonio",
      "86001009": "Yunguillo",
      "86001014": "La Tebaida"
    },
    "Orito": {
      "86320000": "Orito (Cabecera Municipal)",
      "86320001": "Tesalia",
      "86320004": "Lucitania",
      "86320008": "Buenos Aires",
      "86320009": "San Vicente De Luzon",
      "86320010": "Siberia",
      "86320011": "Simon Bolivar"
    },
    "Puerto Asís": {
      "86568000": "Puerto Asis (Cabecera Municipal)",
      "86568006": "Piñuña Blanco",
      "86568019": "Santana",
      "86568020": "Puerto Vega",
      "86568021": "Teteye",
      "86568023": "Caña Brava",
      "86568026": "La Carmelita",
      "86568027": "La Libertad",
      "86568029": "Campo Alegre",
      "86568031": "Sinai (Achapos)"
    },
    "Puerto Caicedo": {
      "86569000": "Puerto Caicedo (Cabecera Municipal)",
      "86569001": "San Pedro",
      "86569002": "Villa Flor",
      "86569003": "El Cedral"
    },
    "Puerto Guzmán": {
      "86571000": "Puerto Guzman (Cabecera Municipal)",
      "86571001": "El Cedro",
      "86571002": "Santa Lucia",
      "86571003": "Jose Maria",
      "86571004": "Mayoyogue",
      "86571005": "El Gallinazo",
      "86571006": "San Roque",
      "86571007": "El Juano",
      "86571008": "Puerto Rosario",
      "86571009": "Galilea",
      "86571010": "El Recreo"
    },
    "Puerto Leguízamo": {
      "86573000": "Puerto Leguizamo (Cabecera Municipal)",
      "86573001": "La Tagua",
      "86573002": "Puerto Ospina",
      "86573003": "Sensella",
      "86573005": "El Mecaya",
      "86573009": "Piñuña Negro",
      "86573010": "Nueva Apaya",
      "86573011": "Puerto Nariño"
    },
    "San Francisco": {
      "86755000": "San Francisco (Cabecera Municipal)",
      "86755001": "San Antonio"
    },
    "San Miguel": {
      "86757000": "San Miguel (Cabecera Municipal)",
      "86757001": "Puerto Colon"
    },
    "Santiago": {
      "86760000": "Santiago (Cabecera Municipal)",
      "86760001": "San Andres"
    },
    "Sibundoy": {
      "86749000": "Sibundoy (Cabecera Municipal)"
    },
    "Valle Del Guamuez": {
      "86865003": "El Tigre",
      "86865004": "El Placer",
      "86865005": "San Antonio",
      "86865008": "Jordan De Guisia",
      "86865010": "Brisas Del Palmar",
      "86865011": "El Cairo",
      "86865012": "El Venado",
      "86865014": "La Concordia",
      "86865015": "La Esmeralda",
      "86865016": "Loro Uno",
      "86865018": "Nueva Palestina",
      "86865019": "San Andres",
      "86865021": "Villaduarte"
    },
    "Valle Del Guamuez La Hormiga": {
      "86865000": "Valle Del Guamuez La Hormiga (Cabecera Municipal)"
    },
    "Villagarzón": {
      "86885000": "Villagarzon (Cabecera Municipal)",
      "86885001": "Puerto Umbria",
      "86885002": "La Castellana",
      "86885004": "Albania",
      "86885007": "Kofania",
      "86885008": "Naranjito",
      "86885009": "Porvenir",
      "86885011": "Santa Rosa De Juanambu"
    }
  },
  "Quindio": {
    "Armenia": {
      "63001000": "Armenia (Cabecera Municipal)",
      "63001001": "El Caimo",
      "63001002": "Murillo"
    },
    "Buenavista": {
      "63111000": "Buenavista (Cabecera Municipal)",
      "63111001": "Rio Verde"
    },
    "Calarcá": {
      "63130000": "Calarca (Cabecera Municipal)",
      "63130001": "Barcelona",
      "63130003": "La Bella",
      "63130004": "La Virginia",
      "63130005": "Quebradanegra",
      "63130010": "La Maria"
    },
    "Circasia": {
      "63190000": "Circasia (Cabecera Municipal)",
      "63190001": "La Pola",
      "63190009": "El Triunfo",
      "63190010": "El Planazo",
      "63190011": "La 18 Guayabal",
      "63190012": "Urbanizacion El Caney",
      "63190013": "Condominio Bosques De Toscana",
      "63190017": "Condominio Los Robles",
      "63190018": "Condominio Los Rosales",
      "63190020": "Condominio Quintas Del Bosque"
    },
    "Córdoba": {
      "63212000": "Cordoba (Cabecera Municipal)"
    },
    "Filandia": {
      "63272000": "Filandia (Cabecera Municipal)",
      "63272002": "La India"
    },
    "Génova": {
      "63302000": "Genova (Cabecera Municipal)"
    },
    "La Tebaida": {
      "63401000": "La Tebaida (Cabecera Municipal)",
      "63401003": "La Silvia",
      "63401004": "Fundacion Amanecer"
    },
    "Montenegro": {
      "63470000": "Montenegro (Cabecera Municipal)",
      "63470003": "Pueblo Tapado",
      "63470004": "Once Casas",
      "63470008": "El Gigante",
      "63470009": "Baraya"
    },
    "Pijao": {
      "63548000": "Pijao (Cabecera Municipal)",
      "63548002": "La Mariela"
    },
    "Quimbaya": {
      "63594000": "Quimbaya (Cabecera Municipal)",
      "63594002": "El Laurel",
      "63594005": "Pueblo Rico",
      "63594006": "Puerto Alejandria",
      "63594007": "El Naranjal"
    },
    "Salento": {
      "63690000": "Salento (Cabecera Municipal)",
      "63690001": "Boquia",
      "63690007": "Condominio Las Colinas",
      "63690009": "San Juan De Carolina"
    }
  },
  "Risaralda": {
    "Apía": {
      "66045000": "Apia (Cabecera Municipal)",
      "66045009": "La Maria"
    },
    "Balboa": {
      "66075000": "Balboa (Cabecera Municipal)",
      "66075004": "Tambores",
      "66075005": "San Antonio",
      "66075009": "Tres Esquinas"
    },
    "Belén De Umbría": {
      "66088000": "Belen De Umbria (Cabecera Municipal)",
      "66088002": "Columbia",
      "66088004": "Puente Umbria",
      "66088005": "Taparcal",
      "66088010": "El Aguacate",
      "66088011": "El Congo"
    },
    "Dosquebradas": {
      "66170000": "Dosquebradas (Cabecera Municipal)",
      "66170006": "La Union",
      "66170008": "Aguazul",
      "66170009": "Buena Vista",
      "66170010": "Comuneros",
      "66170011": "El Estanquillo",
      "66170017": "La Playita",
      "66170020": "Naranjales",
      "66170021": "Santana Baja",
      "66170022": "Villa Carola"
    },
    "Guática": {
      "66318000": "Guatica (Cabecera Municipal)",
      "66318002": "San Clemente",
      "66318003": "Santa Ana",
      "66318006": "Travesias"
    },
    "La Celia": {
      "66383000": "La Celia (Cabecera Municipal)",
      "66383001": "Patio Bonito"
    },
    "La Virginia": {
      "66400000": "La Virginia (Cabecera Municipal)",
      "66400001": "La Palma"
    },
    "Marsella": {
      "66440000": "Marsella (Cabecera Municipal)",
      "66440001": "Alto Cauca",
      "66440008": "Plan De Vivienda El Rayo",
      "66440009": "Estacion Pereira",
      "66440013": "Plan De Vivienda Tacurrumbi"
    },
    "Mistrató": {
      "66456000": "Mistrato (Cabecera Municipal)",
      "66456002": "Puerto De Oro",
      "66456003": "San Antonio Del Chami",
      "66456010": "Pinar Del Rio",
      "66456011": "Quebrada Arriba"
    },
    "Pereira": {
      "66001000": "Pereira (Cabecera Municipal)",
      "66001001": "Altagracia",
      "66001002": "Arabia",
      "66001003": "Betulia",
      "66001004": "Caimalito",
      "66001005": "El Placer (Combia)",
      "66001006": "La Convencion",
      "66001007": "El Rocio",
      "66001009": "La Bella",
      "66001010": "La Florida",
      "66001015": "Morelia",
      "66001016": "Mundo Nuevo",
      "66001018": "Puerto Caldas",
      "66001021": "Tribunas Corcega",
      "66001028": "Yarumal",
      "66001029": "La Bananera",
      "66001030": "Alto Alegrias",
      "66001032": "Perez Alto",
      "66001035": "Huertas",
      "66001036": "Pital De Combia",
      "66001039": "Barrio El Bosque",
      "66001040": "La Cabañita",
      "66001041": "Belmonte Bajo",
      "66001043": "Betania",
      "66001044": "Brisas De Condina (La Graminea)",
      "66001045": "Calle Larga",
      "66001047": "Cestillal",
      "66001048": "El Contento",
      "66001049": "El Crucero De Combia",
      "66001050": "El Jazmin",
      "66001052": "El Porvenir",
      "66001053": "Esperanza Galicia",
      "66001054": "Estacion Azufral",
      "66001056": "Condina Guacary",
      "66001057": "Laguneta",
      "66001058": "La Estrella",
      "66001059": "Nuevo Sol",
      "66001060": "Plan De Vivienda La Union",
      "66001061": "Plan De Vivienda Yarumal",
      "66001062": "Pueblo Nuevo",
      "66001063": "San Carlos",
      "66001064": "Yarumito",
      "66001070": "El Jardin",
      "66001071": "Estacion Villegas",
      "66001072": "Galicia Alta",
      "66001074": "Heriberto Herrera",
      "66001075": "La Carbonera",
      "66001077": "La Renta",
      "66001080": "Libare",
      "66001082": "San Marino",
      "66001083": "Tribunas Consota"
    },
    "Pueblo Rico": {
      "66572000": "Pueblo Rico (Cabecera Municipal)",
      "66572001": "Santa Cecilia",
      "66572002": "Villa Claret"
    },
    "Quinchía": {
      "66594000": "Quinchia (Cabecera Municipal)",
      "66594002": "Irra",
      "66594006": "Naranjal",
      "66594007": "Santa Elena",
      "66594012": "Moreta",
      "66594019": "Villa Rica"
    },
    "Santa Rosa De Cabal": {
      "66682000": "Santa Rosa De Cabal (Cabecera Municipal)",
      "66682003": "El Español",
      "66682008": "La Capilla",
      "66682009": "La Estrella",
      "66682012": "Santa Barbara",
      "66682016": "Guaimaral",
      "66682017": "El Lembo",
      "66682019": "Bajo Samaria",
      "66682020": "La Florida",
      "66682022": "El Jazmin"
    },
    "Santuario": {
      "66687000": "Santuario (Cabecera Municipal)",
      "66687003": "Peralonso"
    }
  },
 /*  "San Andrés, Providencia Y Santa Catalina": {
    "Providencia": {
      "88564001": "Fresh Water Bay",
      "88564002": "South West Bay",
      "88564003": "Botton House",
      "88564004": "San Felipe",
      "88564005": "Rocky Point"
    },
    "San Andres": {
      "88001001": "La Loma",
      "88001002": "San Luis"
    },
    "San Andres ": {
      "88001000": "San Andres  (Cabecera Municipal)"
    }
  }, */
  "Santander": {
    "Aguada": {
      "68013000": "Aguada (Cabecera Municipal)"
    },
    "Albania": {
      "68020000": "Albania (Cabecera Municipal)",
      "68020001": "Carretero",
      "68020002": "El Hatillo",
      "68020003": "La Mesa"
    },
    "Aratoca": {
      "68051000": "Aratoca (Cabecera Municipal)",
      "68051001": "Chiflas",
      "68051012": "El Hoyo"
    },
    "Barbosa": {
      "68077000": "Barbosa (Cabecera Municipal)",
      "68077003": "Buenavista",
      "68077005": "Cristales",
      "68077006": "Francisco De Paula"
    },
    "Barichara": {
      "68079000": "Barichara (Cabecera Municipal)",
      "68079001": "Guane"
    },
    "Barrancabermeja": {
      "68081000": "Barrancabermeja (Cabecera Municipal)",
      "68081004": "Meseta San Rafael",
      "68081006": "San Rafael De Chucuri",
      "68081009": "Los Laureles",
      "68081010": "La Fortuna"
    },
    "Betulia": {
      "68092000": "Betulia (Cabecera Municipal)",
      "68092008": "Tienda Nueva",
      "68092010": "La Playa"
    },
    "Bolívar": {
      "68101000": "Bolivar (Cabecera Municipal)",
      "68101002": "Berbeo",
      "68101007": "Florez",
      "68101010": "Santa Rosa",
      "68101012": "Trapal",
      "68101014": "La Hermosura",
      "68101015": "La Melona",
      "68101016": "Gallegos"
    },
    "Bucaramanga": {
      "68001000": "Bucaramanga (Cabecera Municipal)"
    },
    "Cabrera": {
      "68121000": "Cabrera (Cabecera Municipal)"
    },
    "California": {
      "68132000": "California (Cabecera Municipal)"
    },
    "Capitanejo": {
      "68147000": "Capitanejo (Cabecera Municipal)"
    },
    "Carcasí": {
      "68152000": "Carcasi (Cabecera Municipal)",
      "68152001": "El Tobal"
    },
    "Cepitá": {
      "68160000": "Cepita (Cabecera Municipal)"
    },
    "Cerrito": {
      "68162000": "Cerrito (Cabecera Municipal)",
      "68162007": "Servita"
    },
    "Charalá": {
      "68167000": "Charala (Cabecera Municipal)",
      "68167003": "Riachuelo",
      "68167005": "Virolin"
    },
    "Charta": {
      "68169000": "Charta (Cabecera Municipal)"
    },
    "Chima": {
      "68176000": "Chima (Cabecera Municipal)"
    },
    "Chipatá": {
      "68179000": "Chipata (Cabecera Municipal)"
    },
    "Cimitarra": {
      "68190000": "Cimitarra (Cabecera Municipal)",
      "68190003": "Puerto Olaya",
      "68190004": "Zambito",
      "68190005": "Dos Hermanos",
      "68190006": "Santa Rosa",
      "68190009": "La Verde",
      "68190010": "Guayabito Bajo",
      "68190012": "Campo Seco",
      "68190014": "San Fernando",
      "68190018": "El Aterrado",
      "68190019": "La Carrilera - Km 28",
      "68190021": "Palmas Del Guayabito",
      "68190022": "Primavera",
      "68190023": "San Juan De La Carretera",
      "68190024": "San Pedro De La Paz"
    },
    "Concepción": {
      "68207000": "Concepcion (Cabecera Municipal)"
    },
    "Confines": {
      "68209000": "Confines (Cabecera Municipal)"
    },
    "Contratación": {
      "68211000": "Contratacion (Cabecera Municipal)",
      "68211001": "San Pablo"
    },
    "Coromoro": {
      "68217000": "Coromoro (Cabecera Municipal)",
      "68217001": "Cincelada"
    },
    "Curití": {
      "68229000": "Curiti (Cabecera Municipal)"
    },
    "El Carmen De Chucurí": {
      "68235000": "El Carmen De Chucuri (Cabecera Municipal)",
      "68235001": "Angosturas De Los Andes",
      "68235004": "El Centenario",
      "68235009": "Santo Domingo Del Ramo",
      "68235017": "La Explanacion"
    },
    "El Guacamayo": {
      "68245000": "El Guacamayo (Cabecera Municipal)",
      "68245003": "Santa Rita"
    },
    "El Peñón": {
      "68250000": "El Peñon (Cabecera Municipal)",
      "68250002": "Cruces",
      "68250003": "Otoval - Rio Blanco"
    },
    "El Playón": {
      "68255000": "El Playon (Cabecera Municipal)",
      "68255001": "Barrio Nuevo",
      "68255007": "Estacion Laguna",
      "68255014": "San Pedro De Tigra"
    },
    "Encino": {
      "68264000": "Encino (Cabecera Municipal)"
    },
    "Enciso": {
      "68266000": "Enciso (Cabecera Municipal)",
      "68266002": "Peña Colorada"
    },
    "Floridablanca": {
      "68276000": "Floridablanca (Cabecera Municipal)",
      "68276012": "Montearroyo Condominio",
      "68276013": "Ruitoque Country Club Condominio",
      "68276014": "Valle De Ruitoque",
      "68276016": "Villas De Guadalquivir"
    },
    "Florián": {
      "68271000": "Florian (Cabecera Municipal)",
      "68271001": "La Venta",
      "68271003": "San Antonio De Leones"
    },
    "Galán": {
      "68296000": "Galan (Cabecera Municipal)"
    },
    "Girón": {
      "68307000": "Giron (Cabecera Municipal)",
      "68307003": "Marta",
      "68307007": "Acapulco"
    },
    "Guaca": {
      "68318000": "Guaca (Cabecera Municipal)"
    },
    "Guadalupe": {
      "68320000": "Guadalupe (Cabecera Municipal)",
      "68320005": "El Tirano"
    },
    "Guapotá": {
      "68322000": "Guapota (Cabecera Municipal)"
    },
    "Guavatá": {
      "68324000": "Guavata (Cabecera Municipal)"
    },
    "Gámbita": {
      "68298000": "Gambita (Cabecera Municipal)",
      "68298002": "La Palma"
    },
    "Güepsa": {
      "68327000": "Güepsa (Cabecera Municipal)"
    },
    "Jesús María": {
      "68368000": "Jesus Maria (Cabecera Municipal)"
    },
    "La Belleza": {
      "68377000": "La Belleza (Cabecera Municipal)",
      "68377001": "La Quitaz",
      "68377003": "El Rubi",
      "68377005": "Los Valles"
    },
    "La Paz": {
      "68397000": "La Paz (Cabecera Municipal)",
      "68397002": "La Loma"
    },
    "Landázuri": {
      "68385000": "Landazuri (Cabecera Municipal)",
      "68385001": "Bajo Jordan",
      "68385005": "Plan De Armas",
      "68385006": "San Ignacio Del Opon",
      "68385007": "Miralindo",
      "68385009": "La India",
      "68385014": "Rio Blanco"
    },
    "Lebrija": {
      "68406000": "Lebrija (Cabecera Municipal)",
      "68406003": "El Conchal",
      "68406009": "Portugal",
      "68406013": "Uribe Uribe",
      "68406014": "Vanegas"
    },
    "Los Santos": {
      "68418000": "Los Santos (Cabecera Municipal)"
    },
    "Matanza": {
      "68444000": "Matanza (Cabecera Municipal)",
      "68444006": "Santa Cruz De La Colina"
    },
    "Mogotes": {
      "68464000": "Mogotes (Cabecera Municipal)",
      "68464002": "Pitiguao",
      "68464016": "Los Cauchos"
    },
    "Molagavita": {
      "68468000": "Molagavita (Cabecera Municipal)",
      "68468002": "El Junco"
    },
    "Málaga": {
      "68432000": "Malaga (Cabecera Municipal)"
    },
    "Ocamonte": {
      "68498000": "Ocamonte (Cabecera Municipal)"
    },
    "Oiba": {
      "68500000": "Oiba (Cabecera Municipal)",
      "68500006": "Puente Llano"
    },
    "Onzaga": {
      "68502000": "Onzaga (Cabecera Municipal)",
      "68502001": "Padua",
      "68502002": "Susa",
      "68502004": "El Carmen"
    },
    "Palmar": {
      "68522000": "Palmar (Cabecera Municipal)"
    },
    "Palmas Del Socorro": {
      "68524000": "Palmas Del Socorro (Cabecera Municipal)"
    },
    "Piedecuesta": {
      "68547000": "Piedecuesta (Cabecera Municipal)",
      "68547007": "Umpala",
      "68547016": "Condominio Ruitoque Country Club"
    },
    "Pinchote": {
      "68549000": "Pinchote (Cabecera Municipal)"
    },
    "Puente Nacional": {
      "68572000": "Puente Nacional (Cabecera Municipal)",
      "68572002": "Capilla",
      "68572003": "Providencia",
      "68572004": "Quebrada Negra",
      "68572012": "Peña Blanca"
    },
    "Puerto Parra": {
      "68573000": "Puerto Parra (Cabecera Municipal)",
      "68573001": "Campo Capote",
      "68573002": "Las Montoyas",
      "68573003": "Bocas De Carare O Carare Viejo"
    },
    "Puerto Wilches": {
      "68575000": "Puerto Wilches (Cabecera Municipal)",
      "68575001": "Badillo",
      "68575003": "Bocas Rosario",
      "68575004": "Carpintero",
      "68575005": "Chingale",
      "68575006": "El Guayabo",
      "68575007": "El Pedral",
      "68575011": "Kilometro 20 - Comuneros",
      "68575013": "Paturia",
      "68575014": "Pradilla",
      "68575018": "Vijagual",
      "68575019": "Puerto Cayumba",
      "68575022": "Sitio Nuevo",
      "68575023": "Kilometro Ocho",
      "68575024": "San Claver",
      "68575025": "Garcia Cadena"
    },
    "Páramo": {
      "68533000": "Paramo (Cabecera Municipal)"
    },
    "Rionegro": {
      "68615000": "Rionegro (Cabecera Municipal)",
      "68615002": "Cuesta Rica",
      "68615009": "La Ceiba",
      "68615011": "Llano De Palmas",
      "68615012": "Misijuay",
      "68615013": "Papayal",
      "68615017": "Veinte De Julio",
      "68615027": "Los Chorros (San Jose)",
      "68615031": "San Rafael",
      "68615036": "El Bambu"
    },
    "Sabana De Torres": {
      "68655000": "Sabana De Torres (Cabecera Municipal)",
      "68655001": "La Gomez",
      "68655002": "Sabaneta",
      "68655004": "Provincia",
      "68655006": "Veracruz Kilometro 80",
      "68655008": "Payoa Cinco"
    },
    "San Andrés": {
      "68669000": "San Andres (Cabecera Municipal)",
      "68669005": "Laguna De Ortices",
      "68669007": "Pangote"
    },
    "San Benito": {
      "68673000": "San Benito (Cabecera Municipal)",
      "68673004": "La Carrera",
      "68673005": "Las Casitas"
    },
    "San Gil": {
      "68679000": "San Gil (Cabecera Municipal)"
    },
    "San Joaquín": {
      "68682000": "San Joaquin (Cabecera Municipal)",
      "68682001": "Ricaurte"
    },
    "San José De Miranda": {
      "68684000": "San Jose De Miranda (Cabecera Municipal)"
    },
    "San Miguel": {
      "68686000": "San Miguel (Cabecera Municipal)"
    },
    "San Vicente De Chucurí": {
      "68689000": "San Vicente De Chucuri (Cabecera Municipal)",
      "68689001": "Albania",
      "68689012": "Yarima"
    },
    "Santa Bárbara": {
      "68705000": "Santa Barbara (Cabecera Municipal)"
    },
    "Santa Helena Del Opón": {
      "68720000": "Santa Helena Del Opon (Cabecera Municipal)",
      "68720001": "La Aragua",
      "68720002": "Cachipay",
      "68720004": "Plan De Alvarez",
      "68720005": "San Juan Bosco De La Verde"
    },
    "Simacota": {
      "68745000": "Simacota (Cabecera Municipal)",
      "68745006": "La Llanita",
      "68745009": "La Rochela"
    },
    "Socorro": {
      "68755000": "Socorro (Cabecera Municipal)",
      "68755002": "Berlin"
    },
    "Suaita": {
      "68770000": "Suaita (Cabecera Municipal)",
      "68770001": "Olival",
      "68770002": "San Jose De Suaita",
      "68770003": "Vado Real",
      "68770008": "Tolota"
    },
    "Sucre": {
      "68773000": "Sucre (Cabecera Municipal)",
      "68773001": "La Granja",
      "68773002": "La Pradera",
      "68773003": "Sabana Grande",
      "68773014": "San Isidro"
    },
    "Suratá": {
      "68780000": "Surata (Cabecera Municipal)",
      "68780001": "Cachiri"
    },
    "Tona": {
      "68820000": "Tona (Cabecera Municipal)",
      "68820001": "Berlin",
      "68820002": "La Corcova"
    },
    "Valle De San José": {
      "68855000": "Valle De San Jose (Cabecera Municipal)"
    },
    "Vetas": {
      "68867000": "Vetas (Cabecera Municipal)"
    },
    "Villanueva": {
      "68872000": "Villanueva (Cabecera Municipal)"
    },
    "Vélez": {
      "68861000": "Velez (Cabecera Municipal)",
      "68861001": "Alto Jordan",
      "68861002": "Gualilo",
      "68861022": "Lomalta",
      "68861024": "Los Guayabos"
    },
    "Zapatoca": {
      "68895000": "Zapatoca (Cabecera Municipal)",
      "68895001": "La Fuente"
    }
  },
  "Sucre": {
    "Buenavista": {
      "70110000": "Buenavista (Cabecera Municipal)",
      "70110004": "Las Chichas",
      "70110005": "Los Anones",
      "70110006": "Providencia"
    },
    "Caimito": {
      "70124000": "Caimito (Cabecera Municipal)",
      "70124001": "El Mamon",
      "70124002": "Siete Palmas",
      "70124004": "Los Cayitos",
      "70124006": "La Solera",
      "70124007": "Tofeme",
      "70124008": "Cedeño",
      "70124009": "Molinero",
      "70124010": "Nueva Estacion",
      "70124011": "La Mejia",
      "70124012": "Las Pavitas",
      "70124013": "Nueva Estrella",
      "70124014": "Nueva Fe",
      "70124015": "Pompuma"
    },
    "Chalán": {
      "70230000": "Chalan (Cabecera Municipal)",
      "70230001": "La Ceiba",
      "70230003": "Nuevo Manzanares"
    },
    "Coloso": {
      "70204000": "Coloso (Cabecera Municipal)",
      "70204002": "Chinulito",
      "70204005": "Bajo Don Juan",
      "70204006": "El Ojito"
    },
    "Corozal": {
      "70215000": "Corozal (Cabecera Municipal)",
      "70215001": "Cantagallo",
      "70215004": "Chapinero",
      "70215005": "Don Alonso",
      "70215006": "El Mamon",
      "70215009": "Hato Nuevo",
      "70215010": "Las Llanadas",
      "70215011": "Las Tinas",
      "70215014": "San Jose De Pileta",
      "70215016": "El Rincon De Las Flores",
      "70215018": "Las Peñas"
    },
    "Coveñas": {
      "70221000": "Coveñas (Cabecera Municipal)",
      "70221001": "Boca De La Cienaga",
      "70221002": "El Reparo",
      "70221004": "Punta Seca",
      "70221005": "El Mamey"
    },
    "El Roble": {
      "70233000": "El Roble (Cabecera Municipal)",
      "70233001": "Callejon",
      "70233002": "Cayo De Palma",
      "70233003": "Corneta",
      "70233004": "El Sitio",
      "70233005": "Las Tablitas",
      "70233006": "Palmital",
      "70233007": "Patillal",
      "70233008": "Grillo Alegre",
      "70233009": "Rancho De La Cruz",
      "70233010": "San Francisco",
      "70233011": "Santa Rosa",
      "70233012": "Tierra Santa",
      "70233013": "Villavicencio"
    },
    "Galeras": {
      "70235000": "Galeras (Cabecera Municipal)",
      "70235001": "Baraya",
      "70235002": "San Andres De Palomo",
      "70235003": "San Jose De Rivera",
      "70235007": "Pueblo Nuevo Ii",
      "70235009": "Pueblo Nuevo I (Junin)",
      "70235011": "Puerto Franco"
    },
    "Guaranda": {
      "70265000": "Guaranda (Cabecera Municipal)",
      "70265002": "Diazgranados",
      "70265004": "Gavalda",
      "70265006": "La Concordia",
      "70265008": "Palmaritico",
      "70265009": "Puerto Lopez"
    },
    "La Unión": {
      "70400000": "La Union (Cabecera Municipal)",
      "70400001": "Cayo Delgado",
      "70400002": "Pajarito",
      "70400004": "Las Palmitas",
      "70400005": "Sabaneta",
      "70400006": "Boca Negra",
      "70400007": "Conguitos",
      "70400008": "La Gloria",
      "70400009": "Villa Fatima"
    },
    "Los Palmitos": {
      "70418000": "Los Palmitos (Cabecera Municipal)",
      "70418001": "El Coley",
      "70418002": "El Piñal",
      "70418003": "Palmas De Vino",
      "70418004": "Sabanas De Beltran",
      "70418005": "Sabanas De Pedro",
      "70418006": "El Hatillo"
    },
    "Majagual": {
      "70429000": "Majagual (Cabecera Municipal)",
      "70429002": "El Naranjo",
      "70429005": "La Sierpe",
      "70429006": "Las Palmitas",
      "70429008": "Piza",
      "70429009": "Pueblonuevo",
      "70429011": "Santander",
      "70429013": "Zapata",
      "70429014": "Sincelejito",
      "70429016": "Leon Blanco",
      "70429023": "Los Patos",
      "70429025": "Palmarito"
    },
    "Morroa": {
      "70473000": "Morroa (Cabecera Municipal)",
      "70473002": "El Rincon",
      "70473003": "El Yeso",
      "70473004": "Las Flores",
      "70473005": "Sabaneta",
      "70473006": "Tumbatoro",
      "70473009": "Sabanas De Cali"
    },
    "Ovejas": {
      "70508000": "Ovejas (Cabecera Municipal)",
      "70508001": "Almagra",
      "70508002": "Canutal",
      "70508003": "Canutalito",
      "70508004": "Chengue",
      "70508005": "Damasco",
      "70508006": "Don Gabriel",
      "70508007": "El Floral",
      "70508009": "Flor Del Monte",
      "70508011": "La Peña",
      "70508012": "Osos",
      "70508013": "Pijiguay",
      "70508014": "San Rafael",
      "70508015": "Salitral",
      "70508018": "San Rafael Alto",
      "70508026": "Pedregal",
      "70508027": "San Francisco",
      "70508031": "Zapato # 2 Pijiguay"
    },
    "Palmito": {
      "70523000": "Palmito (Cabecera Municipal)",
      "70523001": "Algodoncillo",
      "70523003": "Guami",
      "70523006": "Chumpundun",
      "70523007": "El Martillo",
      "70523008": "El Palmar Brillante",
      "70523010": "Los Castillos",
      "70523011": "Media Sombra",
      "70523012": "Pueblecito",
      "70523013": "Pueblo Nuevo",
      "70523014": "San Miguel"
    },
    "Sampués": {
      "70670000": "Sampues (Cabecera Municipal)",
      "70670001": "Bossa Navarro",
      "70670002": "Ceja Del Mango",
      "70670003": "Escobar Abajo",
      "70670004": "Escobar Arriba",
      "70670007": "Mateo Perez",
      "70670008": "Santa Ines De Palito",
      "70670009": "Piedras Blancas",
      "70670010": "Sabanalarga",
      "70670011": "San Luis",
      "70670012": "Segovia",
      "70670013": "Achiote Arriba",
      "70670018": "Mata De Caña"
    },
    "San Benito Abad": {
      "70678000": "San Benito Abad (Cabecera Municipal)",
      "70678002": "Cuiva",
      "70678003": "Jegua",
      "70678004": "La Ceiba",
      "70678007": "Punta De Blanco",
      "70678009": "San Roque",
      "70678010": "Santiago Apostol",
      "70678011": "Doña Ana",
      "70678013": "El Limon",
      "70678015": "La Ventura",
      "70678020": "Punta Nueva",
      "70678025": "Cispataca",
      "70678026": "San Isidro",
      "70678027": "Villa Nueva",
      "70678032": "La Molina",
      "70678033": "Las Chispas",
      "70678034": "Rancho La Tia"
    },
    "San Jose De Toluviejo": {
      "70823000": "San Jose De Toluviejo (Cabecera Municipal)",
      "70823001": "Caracol",
      "70823002": "Las Piedras",
      "70823003": "Macajan",
      "70823004": "Palmira",
      "70823005": "Varsovia",
      "70823006": "La Piche",
      "70823007": "Cienaguita",
      "70823010": "Gualon",
      "70823011": "Cañito",
      "70823012": "La Siria",
      "70823013": "La Floresta",
      "70823014": "Los Altos",
      "70823015": "Nueva Esperanza"
    },
    "San Juan De Betulia": {
      "70702000": "San Juan De Betulia (Cabecera Municipal)",
      "70702001": "Albania",
      "70702004": "Sabaneta",
      "70702005": "Villa Lopez",
      "70702006": "Las Cruces",
      "70702007": "Loma Alta",
      "70702008": "Santo Tomas",
      "70702009": "El Socorro"
    },
    "San Marcos": {
      "70708000": "San Marcos (Cabecera Municipal)",
      "70708001": "Belen",
      "70708002": "Buenavista",
      "70708005": "Cuenca",
      "70708006": "El Limon",
      "70708007": "El Tablon",
      "70708009": "Las Flores",
      "70708010": "Montegrande",
      "70708011": "Palo Alto",
      "70708012": "El Pital",
      "70708013": "Santa Ines",
      "70708014": "La Quebrada",
      "70708015": "El Llano",
      "70708017": "Neiva",
      "70708021": "Cayo De La Cruz",
      "70708024": "El Oasis",
      "70708028": "San Felipe"
    },
    "San Onofre": {
      "70713000": "San Onofre (Cabecera Municipal)",
      "70713001": "Aguacate",
      "70713002": "Berlin",
      "70713003": "Berrugas",
      "70713005": "Labarces",
      "70713006": "Libertad",
      "70713007": "Pajonal",
      "70713008": "Palo Alto",
      "70713009": "Planparejo",
      "70713010": "Rincon Del Mar",
      "70713011": "Sabanas De Mucacal",
      "70713012": "San Antonio",
      "70713014": "Higueron",
      "70713015": "El Chicho",
      "70713016": "Barrancas",
      "70713017": "Cerro De Las Casas",
      "70713018": "Pajonalito",
      "70713019": "El Pueblito",
      "70713020": "Aguas Negras",
      "70713021": "Palacios",
      "70713022": "Bocacerrada",
      "70713023": "Palmira",
      "70713024": "Altos De Julio",
      "70713025": "Arroyo Seco",
      "70713026": "Las Brisas",
      "70713027": "Pisisi",
      "70713028": "Sabanas De Rincon",
      "70713029": "Sabanetica"
    },
    "San Pedro": {
      "70717000": "San Pedro (Cabecera Municipal)",
      "70717001": "San Mateo",
      "70717002": "Rovira",
      "70717003": "Numancia",
      "70717004": "El Bajo De La Alegria"
    },
    "Santiago De Tolú": {
      "70820000": "Santiago De Tolu (Cabecera Municipal)",
      "70820003": "Nueva Era",
      "70820007": "Pita En Medio",
      "70820008": "Puerto Viejo",
      "70820010": "Pita Abajo",
      "70820013": "Santa Lucia"
    },
    "Sincelejo": {
      "70001000": "Sincelejo (Cabecera Municipal)",
      "70001001": "Buenavista",
      "70001002": "Cruz Del Beque",
      "70001004": "Cerrito De La Palma",
      "70001005": "La Arena",
      "70001006": "La Chivera",
      "70001007": "La Gallera",
      "70001009": "Laguna Flor",
      "70001011": "Las Majaguas",
      "70001013": "Sabanas Del Potrero",
      "70001014": "San Antonio",
      "70001015": "San Martin",
      "70001016": "San Rafael",
      "70001017": "Buenavistica",
      "70001020": "Policarpa",
      "70001021": "San Jacinto",
      "70001022": "San Nicolas"
    },
    "Sucre": {
      "70771000": "Sucre (Cabecera Municipal)",
      "70771001": "Arboleda",
      "70771005": "Campo Alegre",
      "70771006": "Cordoba",
      "70771008": "El Congreso",
      "70771012": "La Ventura",
      "70771013": "Monteria",
      "70771015": "Naranjal",
      "70771016": "Nariño",
      "70771017": "Orejero",
      "70771018": "San Luis",
      "70771019": "Travesia",
      "70771020": "Hato Nuevo",
      "70771021": "Pampanilla",
      "70771024": "La Palma",
      "70771027": "San Mateo"
    }
  },
  "Tolima": {
    "Alpujarra": {
      "73024000": "Alpujarra (Cabecera Municipal)",
      "73024001": "La Arada",
      "73024002": "El Carmen",
      "73024003": "Ameses"
    },
    "Alvarado": {
      "73026000": "Alvarado (Cabecera Municipal)",
      "73026001": "Caldas Viejo",
      "73026004": "Rincon Chipalo",
      "73026005": "Veracruz",
      "73026008": "La Tebaida",
      "73026011": "Totarito"
    },
    "Ambalema": {
      "73030000": "Ambalema (Cabecera Municipal)",
      "73030002": "Chorrillo",
      "73030006": "La Aldea El Danubio",
      "73030007": "Boqueron"
    },
    "Anzoátegui": {
      "73043000": "Anzoategui (Cabecera Municipal)",
      "73043001": "Lisboa",
      "73043002": "Palomar",
      "73043003": "Santa Barbara"
    },
    "Armero": {
      "73055000": "Armero (Cabecera Municipal)",
      "73055002": "Mendez",
      "73055003": "San Pedro",
      "73055004": "San Felipe",
      "73055006": "Fundadores",
      "73055007": "Nuevo Horizonte"
    },
    "Ataco": {
      "73067000": "Ataco (Cabecera Municipal)",
      "73067001": "Campohermoso",
      "73067003": "Casa De Zinc",
      "73067005": "Mesa De Pole",
      "73067006": "Polecito",
      "73067012": "Monteloro",
      "73067014": "El Paujil",
      "73067016": "Condor"
    },
    "Cajamarca": {
      "73124000": "Cajamarca (Cabecera Municipal)",
      "73124001": "Anaime"
    },
    "Carmen De Apicalá": {
      "73148000": "Carmen De Apicala (Cabecera Municipal)"
    },
    "Casabianca": {
      "73152000": "Casabianca (Cabecera Municipal)"
    },
    "Chaparral": {
      "73168000": "Chaparral (Cabecera Municipal)",
      "73168004": "El Limon",
      "73168005": "La Marina",
      "73168006": "La Profunda",
      "73168007": "San Jose De Las Hermosas"
    },
    "Coello": {
      "73200000": "Coello (Cabecera Municipal)",
      "73200001": "Gualanday",
      "73200002": "La Barrialosa",
      "73200003": "Llano De La Virgen",
      "73200004": "Potrerillo",
      "73200005": "Vega Los Padres",
      "73200016": "Vindi",
      "73200017": "Calabozo"
    },
    "Coyaima": {
      "73217000": "Coyaima (Cabecera Municipal)",
      "73217001": "Castilla",
      "73217005": "Totarco Dinde",
      "73217011": "Guayaquil"
    },
    "Cunday": {
      "73226000": "Cunday (Cabecera Municipal)",
      "73226001": "La Aurora",
      "73226002": "San Pablo",
      "73226003": "Tres Esquinas",
      "73226004": "Valencia",
      "73226005": "Varsovia",
      "73226008": "El Reves"
    },
    "Dolores": {
      "73236000": "Dolores (Cabecera Municipal)",
      "73236004": "Rionegro",
      "73236005": "San Andres",
      "73236007": "Los Llanitos",
      "73236010": "La Soledad",
      "73236011": "San Pedro"
    },
    "Espinal": {
      "73268000": "Espinal (Cabecera Municipal)",
      "73268001": "Chicoral",
      "73268003": "San Francisco"
    },
    "Falan": {
      "73270000": "Falan (Cabecera Municipal)",
      "73270001": "Frias",
      "73270004": "Piedecuesta"
    },
    "Flandes": {
      "73275000": "Flandes (Cabecera Municipal)",
      "73275001": "El Colegio",
      "73275005": "Paradero I"
    },
    "Fresno": {
      "73283000": "Fresno (Cabecera Municipal)",
      "73283001": "Betania",
      "73283003": "El Tablazo",
      "73283004": "La Aguadita",
      "73283008": "San Bernardo"
    },
    "Guamo": {
      "73319000": "Guamo (Cabecera Municipal)",
      "73319002": "La Chamba",
      "73319004": "Rincon Santo Centro",
      "73319005": "Chipuelo Oriente",
      "73319009": "La Troja",
      "73319010": "Loma De Luisa",
      "73319013": "Cañada El Rodeo",
      "73319015": "Pueblo Nuevo",
      "73319016": "Cerezuela Las Garzas"
    },
    "Herveo": {
      "73347000": "Herveo (Cabecera Municipal)",
      "73347001": "Brasil",
      "73347003": "Letras",
      "73347004": "Mesones",
      "73347005": "Padua"
    },
    "Honda": {
      "73349000": "Honda (Cabecera Municipal)",
      "73349001": "Perico"
    },
    "Ibagué": {
      "73001000": "Ibague (Cabecera Municipal)",
      "73001001": "Buenos Aires",
      "73001004": "Dantas",
      "73001006": "Juntas",
      "73001007": "Laureles",
      "73001009": "San Bernardo",
      "73001010": "San Juan De La China",
      "73001011": "Tapias",
      "73001012": "Toche",
      "73001013": "Villarestrepo",
      "73001014": "Llanitos",
      "73001015": "El Totumo",
      "73001017": "Carmen De Bulira",
      "73001018": "El Rodeo",
      "73001020": "Coello - Cocora",
      "73001024": "Santa Teresa",
      "73001025": "Pastales Viejo",
      "73001027": "Pastales Nuevo",
      "73001028": "La Flor",
      "73001030": "El Cay",
      "73001032": "Alto De Gualanday",
      "73001036": "Briceño",
      "73001049": "La Miel",
      "73001057": "Los Tuneles",
      "73001058": "Pico De Oro",
      "73001059": "Tres Esquinas"
    },
    "Icononzo": {
      "73352000": "Icononzo (Cabecera Municipal)",
      "73352001": "Balconcitos",
      "73352002": "Boqueron",
      "73352003": "Mundo Nuevo",
      "73352005": "Patecuinde"
    },
    "Lérida": {
      "73408000": "Lerida (Cabecera Municipal)",
      "73408001": "Delicias",
      "73408002": "San Francisco De La Sierra",
      "73408003": "Padilla",
      "73408005": "Iguasitos"
    },
    "Líbano": {
      "73411000": "Libano (Cabecera Municipal)",
      "73411002": "Convenio",
      "73411006": "San Fernando",
      "73411007": "Santa Teresa",
      "73411008": "Tierradentro",
      "73411009": "Campo Alegre"
    },
    "Mariquita": {
      "73443000": "Mariquita (Cabecera Municipal)"
    },
    "Melgar": {
      "73449000": "Melgar (Cabecera Municipal)",
      "73449001": "Cualamana",
      "73449006": "Balcones Del Sumapaz",
      "73449008": "El Ruby",
      "73449009": "La Estancia",
      "73449012": "Quebraditas 1",
      "73449014": "San Jose De La Colorada"
    },
    "Murillo": {
      "73461000": "Murillo (Cabecera Municipal)",
      "73461001": "El Bosque"
    },
    "Natagaima": {
      "73483000": "Natagaima (Cabecera Municipal)",
      "73483001": "La Palmita",
      "73483002": "Velu",
      "73483008": "Rincon Anchique"
    },
    "Ortega": {
      "73504000": "Ortega (Cabecera Municipal)",
      "73504003": "Guaipa",
      "73504004": "Hato De Iglesia",
      "73504007": "La Mesa De Ortega",
      "73504008": "Olaya Herrera"
    },
    "Palocabildo": {
      "73520000": "Palocabildo (Cabecera Municipal)"
    },
    "Piedras": {
      "73547000": "Piedras (Cabecera Municipal)",
      "73547001": "Chicala",
      "73547002": "Doima",
      "73547003": "Guataquisito",
      "73547005": "Paradero Chipalo"
    },
    "Planadas": {
      "73555000": "Planadas (Cabecera Municipal)",
      "73555001": "Bilbao",
      "73555002": "Gaitania",
      "73555004": "Sur De Ata",
      "73555006": "Bruselas",
      "73555007": "San Miguel"
    },
    "Prado": {
      "73563000": "Prado (Cabecera Municipal)",
      "73563001": "Aco",
      "73563004": "Montoso"
    },
    "Purificación": {
      "73585000": "Purificacion (Cabecera Municipal)",
      "73585001": "Chenche Asoleado",
      "73585002": "Lozania",
      "73585006": "Villa Esperanza",
      "73585007": "Villa Colombia",
      "73585009": "El Baura",
      "73585013": "La Mata",
      "73585015": "Buenavista",
      "73585018": "Chenche Uno"
    },
    "Rioblanco": {
      "73616000": "Rioblanco (Cabecera Municipal)",
      "73616002": "Puerto Saldaña",
      "73616004": "Palonegro",
      "73616005": "Gaitan",
      "73616006": "Maracaibo"
    },
    "Roncesvalles": {
      "73622000": "Roncesvalles (Cabecera Municipal)",
      "73622001": "Santa Elena",
      "73622002": "El Cedro"
    },
    "Rovira": {
      "73624000": "Rovira (Cabecera Municipal)",
      "73624001": "El Corazon",
      "73624003": "Los Andes - La Bella",
      "73624004": "Riomanso",
      "73624005": "San Pedro",
      "73624007": "Guadualito",
      "73624008": "La Florida",
      "73624010": "La Selva",
      "73624012": "La Luisa"
    },
    "Saldaña": {
      "73671000": "Saldaña (Cabecera Municipal)",
      "73671001": "Jabalcon",
      "73671002": "Santa Ines",
      "73671008": "La Esperanza",
      "73671009": "Normandia"
    },
    "San Antonio": {
      "73675000": "San Antonio (Cabecera Municipal)",
      "73675001": "La Florida",
      "73675002": "Playarrica"
    },
    "San Luis": {
      "73678000": "San Luis (Cabecera Municipal)",
      "73678004": "Payande"
    },
    "San Sebastián De Mariquita": {
      "73443001": "El Hatillo",
      "73443002": "La Cabaña",
      "73443003": "Pitalito",
      "73443004": "La Albania",
      "73443006": "Camelias",
      "73443008": "La Parroquia",
      "73443009": "Las Marias"
    },
    "Santa Isabel": {
      "73686000": "Santa Isabel (Cabecera Municipal)",
      "73686001": "Colon",
      "73686003": "San Rafael"
    },
    "Suárez": {
      "73770001": "Hato Viejo",
      "73770005": "Agua Blanca"
    },
    "Valle De San Juan": {
      "73854000": "Valle De San Juan (Cabecera Municipal)"
    },
    "Venadillo": {
      "73861000": "Venadillo (Cabecera Municipal)",
      "73861001": "Junin",
      "73861002": "La Sierrita",
      "73861003": "Malabar",
      "73861004": "Palmarosa"
    },
    "Villarrica": {
      "73873000": "Villarrica (Cabecera Municipal)",
      "73873002": "La Colonia",
      "73873003": "Los Alpes",
      "73873004": "Puerto Lleras"
    }
  },
/*   "Vaupés": {
    "Carurú": {
      "97161000": "Caruru (Cabecera Municipal)"
    },
    "Mitú": {
      "97001000": "Mitu (Cabecera Municipal)",
      "97001002": "Camanaos",
      "97001005": "Acaricuara",
      "97001006": "Villafatima"
    },
    "Taraira": {
      "97666000": "Taraira (Cabecera Municipal)"
    }
  }, */
 /*  "Vichada": {
    "Cumaribo": {
      "99773000": "Cumaribo (Cabecera Municipal)",
      "99773001": "Palmarito",
      "99773002": "El Viento",
      "99773003": "Tres Matas",
      "99773004": "Amanaven",
      "99773005": "Chupave",
      "99773008": "Guanape",
      "99773010": "Puerto Principe",
      "99773013": "Puerto Nariño",
      "99773015": "Santa Rita"
    },
    "La Primavera": {
      "99524000": "La Primavera (Cabecera Municipal)",
      "99524001": "Nueva Antioquia",
      "99524002": "Santa Barbara",
      "99524007": "San Teodoro (La Pascua)"
    },
    "Puerto Carreño": {
      "99001000": "Puerto Carreño (Cabecera Municipal)",
      "99001002": "Casuarito"
    },
    "Santa Rosalía": {
      "99624000": "Santa Rosalia (Cabecera Municipal)",
      "99624001": "Guacacias"
    }
  } */
};

// Exportar para uso global
if (typeof window !== 'undefined') {
  window.corregimientosData = corregimientosData;
}
